
import React from "react";
import * as ReactDOMClient from "react-dom/client";
const { useState, useEffect, useRef, useMemo, useCallback, createContext, useContext, Fragment } = React;
// Exponemos en window para que los archivos JSX concatenados abajo los lean
// como globals (patrón heredado; refactor futuro: ES modules por archivo).
Object.assign(window, { React, ReactDOM: ReactDOMClient, useState, useEffect, useRef, useMemo, useCallback, createContext, useContext });


/* ===== data.jsx ===== */

/* Azulito — Mock data */

const DATA = {
  testimonials: [
    { id: 1, name: "María G.", role: "Mamá de Joaquín (6)", city: "Treinta y Tres", quote: "Cuando nos dijeron 'tu hijo está en el espectro', no entendíamos nada. Azulito nos dio pasos concretos: qué observar esta semana, a quién llamar, qué leer. Dejamos de sentirnos solos." },
    { id: 2, name: "Carlos & Sofía", role: "Papás de Mateo (4)", city: "Vergara", quote: "Lo que más nos ayudó fue la biblioteca de tableros visuales. Mateo dejó de frustrarse tanto en las mañanas porque ahora anticipa lo que viene." },
    { id: 3, name: "Luisa B.", role: "Abuela y cuidadora", city: "Santa Clara", quote: "Yo no manejo mucho el celular, pero esto es sencillo. El chat me respondió a las 11 de la noche cuando Tomi no podía dormir. Una gauchada." },
  ],
  professionals: [
    { id: 1, name: "Dra. Patricia Núñez", role: "Neuropediatra", city: "Treinta y Tres", phone: "099 123 456", tags: ["Diagnóstico", "Seguimiento"] },
    { id: 2, name: "Lic. Rodrigo Méndez", role: "Psicólogo infantil", city: "Treinta y Tres", phone: "098 456 789", tags: ["TEA", "Familias"] },
    { id: 3, name: "Lic. Florencia Arias", role: "Fonoaudióloga", city: "Vergara", phone: "097 321 654", tags: ["Lenguaje", "CAA"] },
    { id: 4, name: "T.O. Daniel Pereyra", role: "Terapista ocupacional", city: "Treinta y Tres", phone: "099 987 321", tags: ["Integración sensorial"] },
    { id: 5, name: "Lic. Gabriela Ferreira", role: "Psicopedagoga", city: "Santa Clara", phone: "098 765 432", tags: ["Escuela", "Aprendizaje"] },
    { id: 6, name: "Dra. Elena Castro", role: "Psiquiatra infantil", city: "Melo (C. Largo)", phone: "099 555 111", tags: ["Co-ocurrencias"] },
  ],
  resources: [
    { id: 1, title: "Tablero visual: rutina de la mañana", type: "Tablero", cat: "Rutinas", pages: 2, downloads: 384, pinned: true },
    { id: 2, title: "Guía: primeros pasos después del diagnóstico", type: "Guía PDF", cat: "Orientación", pages: 14, downloads: 612, pinned: true },
    { id: 3, title: "Anticipación: visita al médico", type: "Historia social", cat: "Salud", pages: 6, downloads: 241 },
    { id: 4, title: "Estrategias para el sueño en niños TEA", type: "Guía PDF", cat: "Sueño", pages: 10, downloads: 445 },
    { id: 5, title: "Tablero: comunicación con pictos", type: "Tablero", cat: "Comunicación", pages: 4, downloads: 298 },
    { id: 6, title: "Cómo manejar el cambio de rutina", type: "Artículo", cat: "Conducta", pages: null, downloads: 187 },
    { id: 7, title: "Kit sensorial casero (sin gastar)", type: "Guía PDF", cat: "Sensorial", pages: 8, downloads: 356 },
    { id: 8, title: "Escuela: cómo pedir apoyo educativo", type: "Plantilla", cat: "Escuela", pages: 3, downloads: 201 },
  ],
  articles: [
    { id: 1, title: "¿Qué significa 'espectro' en TEA?", readMin: 4, cat: "Conceptos", excerpt: "Una explicación con palabras simples para cuando recién llega el diagnóstico." },
    { id: 2, title: "Cuándo buscar una segunda opinión (y cuándo no)", readMin: 6, cat: "Orientación", excerpt: "Consejos prácticos de pediatras y psicólogos locales." },
    { id: 3, title: "Hermanos y hermanas: cómo acompañarlos también", readMin: 5, cat: "Familia", excerpt: "El diagnóstico impacta a toda la casa. Ideas reales que funcionan." },
  ],
  faqs: [
    { q: "¿Azulito hace diagnóstico?", a: "No. Azulito orienta, acompaña y conecta con profesionales. El diagnóstico siempre lo hace un equipo de salud." },
    { q: "¿Quién puede usar Azulito?", a: "Familias, cuidadores, docentes y cualquier persona cercana a un niño o niña con TEA. No hace falta saber de tecnología." },
    { q: "¿Es gratis?", a: "Sí, completamente gratuito. Lo impulsan los Clubes de Leones Treinta y Tres Olimar y Treinta y Tres Yerbal, la Asesoría TEA del Distrito, Amor Azul, y 33IA (comunidad impulsada por INDATA)." },
    { q: "¿Qué pasa con mis datos?", a: "Tu información familiar está protegida y encriptada. No la compartimos con terceros. Vos controlás tu perfil siempre." },
    { q: "¿Funciona sin internet?", a: "Sí. Azulito se instala como app (PWA) y los contenidos que ya visitaste quedan disponibles sin conexión." },
  ],
  metrics: {
    families: 127,
    children: 168,
    chats: 2340,
    resources: 4580,
    byCity: [
      { city: "Treinta y Tres", count: 74 },
      { city: "Vergara", count: 22 },
      { city: "Santa Clara", count: 14 },
      { city: "José Pedro Varela", count: 8 },
      { city: "Melo", count: 5 },
      { city: "Otras", count: 4 },
    ],
    topics: [
      { topic: "Rutinas y anticipación", n: 412 },
      { topic: "Sueño", n: 318 },
      { topic: "Conducta y berrinches", n: 287 },
      { topic: "Escuela y apoyo educativo", n: 245 },
      { topic: "Profesionales locales", n: 198 },
      { topic: "Comunicación", n: 156 },
      { topic: "Sensorial", n: 124 },
    ],
    weekly: [18, 24, 31, 29, 42, 38, 55, 61, 58, 72, 81, 94],
    children_age: [
      { range: "0-3", n: 34 },
      { range: "4-6", n: 58 },
      { range: "7-9", n: 42 },
      { range: "10-12", n: 22 },
      { range: "13+", n: 12 },
    ],
  },
  chatSuggestions: [
    "Por dónde empiezo, recién recibimos el diagnóstico",
    "¿Cómo ayudo a autorregularse en una crisis?",
    "Trámites en BPS: pensión y acceso a terapias",
    "Me cuesta la hora de dormir",
    "¿Cómo hablo con la escuela?",
    "El supermercado es un desafío",
  ],
  sampleChat: [
    { from: "azulito", text: "Hola 💙 Soy Azulito. Contame qué te preocupa y vemos juntos. No diagnostico ni reemplazo a un profesional, pero puedo acompañarte con pasos claros." },
    { from: "user", text: "Mi hijo de 5 se frustra mucho cuando cambiamos de actividad" },
    { from: "azulito", text: "Te entiendo. Los cambios bruscos son uno de los temas más consultados. Lo primero que suele ayudar es anticipar: que sepa qué viene antes de que pase." },
    { from: "azulito", type: "card", card: { title: "Tablero visual: rutina de la mañana", subtitle: "Descargable · 2 páginas", icon: "book", action: "Ver recurso" } },
    { from: "azulito", text: "Otra idea: contar hacia atrás (\"en 5, en 2, ahora\") y usar una frase fija antes de cada cambio. ¿Querés que te sugiera un profesional cerca si esto sigue mucho tiempo?" },
  ],
};

window.DATA = DATA;


/* ===== shell.jsx ===== */

/* Azulito — App shell, router, shared components */

// React + hooks son inyectados por el build (ver build.js). En dev via Babel
// standalone (deprecated) también estaban en window. No los redeclaramos acá.

// ============================================================
// ROUTER & APP STATE
// ============================================================

const AppCtx = createContext(null);
const useApp = () => useContext(AppCtx);

const ROUTES = {
  LANDING: "landing",
  LOGIN: "login",
  REGISTER: "register",
  CHANGE_PASSWORD: "change-password",
  FORGOT: "forgot-password",
  ONBOARDING: "onboarding",
  PRIVACY: "privacy",
  RESOURCE_DETAIL: "resource-detail",
  ARTICLE_DETAIL: "article-detail",
  PROFESSIONAL_DETAIL: "professional-detail",
  APP_HOME: "app-home",
  APP_LIBRARY: "app-library",
  APP_PROFESSIONALS: "app-professionals",
  APP_TESTIMONIALS: "app-testimonials",
  APP_CHAT: "app-chat",
  APP_PROFILE: "app-profile",
  ADMIN_HOME: "admin-home",
  ADMIN_CONTENT: "admin-content",
  ADMIN_USERS: "admin-users",
  ADMIN_METRICS: "admin-metrics",
  ADMIN_AI: "admin-ai",
  ADMIN_CHAT_LOG: "admin-chat-log",
};

// Transforma la respuesta de /api/content/public al shape que esperan los
// componentes (heredado de los mocks en DATA). Mantener este contrato en
// sincronía con el backend: si agregás un campo al seed, mapealo acá.
function transformPublicContent(payload) {
  const toResource = (r) => ({
    id: r.id,
    title: r.title,
    type: r.type,
    cat: r.category,
    pages: r.pages || null,
    downloads: r.views || 0,
    pinned: !!r.featured,
    shortDescription: r.shortDescription || "",
    tags: r.tags || [],
    body: r.body || "",
    readMin: r.readMin || null,
    assetUrl: r.assetUrl || "#",
    imageUrl: r.imageUrl || null,
  });
  const toArticle = (a) => {
    const words = String(a.content || "").trim().split(/\s+/).filter(Boolean).length;
    return {
      id: a.id,
      title: a.title,
      cat: a.category,
      excerpt: a.summary,
      readMin: a.readMin || Math.max(2, Math.round(words / 200)),
      cover: a.cover || null,
      // El reader necesita el cuerpo completo; sin esto los artículos no se
      // pueden leer dentro de la app.
      body: a.content || "",
      shortDescription: a.summary,
      type: "Artículo",
      tags: a.tags || [],
    };
  };
  const toTestimonial = (t) => ({
    id: t.id,
    name: t.authorAlias || "Familia anónima",
    role: t.authorRole || "",
    city: t.authorCity || "",
    quote: t.content,
  });
  const toProfessional = (p) => ({
    id: p.id,
    name: p.name,
    role: p.specialty,
    city: p.city,
    phone: p.phone,
    address: p.address || "",
    notes: p.notes || "",
    tags: p.tags || [],
  });
  const toFaq = (f) => ({ q: f.question, a: f.answer });
  return {
    resources: (payload.resources || []).map(toResource),
    articles: (payload.articles || []).map(toArticle),
    testimonials: (payload.testimonials || []).map(toTestimonial),
    professionals: (payload.professionals || []).map(toProfessional),
    faqs: (payload.faqs || []).map(toFaq),
    stats: payload.stats || { families: 0, cities: 0, resources: 0 },
  };
}

// Hook helper: devuelve contenido real si ya cargó, sino cae al mock DATA.
function useContent() {
  const { content } = useApp();
  return content || DATA;
}

// Mapa de ciudades → departamento para armar payload de registro.
const CITY_TO_DEPARTMENT = {
  "Treinta y Tres": "Treinta y Tres",
  "Vergara": "Treinta y Tres",
  "Santa Clara": "Treinta y Tres",
  "Santa Clara de Olimar": "Treinta y Tres",
  "José Pedro Varela": "Lavalleja",
  "Melo": "Cerro Largo",
  "Melo (C. Largo)": "Cerro Largo",
};

// Rutas públicas con URL propia. El resto de la app (home privada, admin,
// lectores) sigue viviendo en el estado: no aporta tener URL y expondría
// secciones que requieren sesión.
//
// Sin esto, /privacy devolvía 404 aunque la pantalla existiera, no se podía
// compartir el link de la política de privacidad y el botón "atrás" del
// navegador se salía del sitio en vez de volver a la pantalla anterior.
const RUTAS_URL = {
  "/": ROUTES.LANDING,
  "/privacidad": ROUTES.PRIVACY,
  "/entrar": ROUTES.LOGIN,
  "/registro": ROUTES.REGISTER,
};
const URL_DE_RUTA = Object.fromEntries(Object.entries(RUTAS_URL).map(([url, r]) => [r, url]));

function rutaDesdeUrl() {
  return RUTAS_URL[window.location.pathname] || null;
}

function AppProvider({ children }) {
  const [route, setRouteState] = useState(() => {
    // La URL manda sobre lo último guardado: si alguien comparte /privacidad,
    // tiene que abrir ahí y no en la pantalla donde quedó la visita anterior.
    return rutaDesdeUrl() || localStorage.getItem("azulito:route") || ROUTES.LANDING;
  });
  const [theme, setTheme] = useState(() => localStorage.getItem("azulito:theme") || "light");
  const [user, setUserState] = useState(() => {
    const s = localStorage.getItem("azulito:user");
    return s ? JSON.parse(s) : null;
  });
  const [toast, setToast] = useState(null);
  const [params, setParams] = useState({});
  const [content, setContent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/content/public")
      .then((r) => (r.ok ? r.json() : null))
      .then((payload) => {
        if (!cancelled && payload) setContent(transformPublicContent(payload));
      })
      .catch(() => { /* silencioso: fallback a DATA mock */ });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("azulito:theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("azulito:route", route);
  }, [route]);

  const setUser = useCallback((u) => {
    setUserState(u);
    try {
      if (u) localStorage.setItem("azulito:user", JSON.stringify(u));
      else localStorage.removeItem("azulito:user");
    } catch {}
  }, []);

  const setRoute = useCallback((r, p = {}) => {
    setParams(p);
    setRouteState(r);
    // Reflejar en la barra de direcciones las rutas que tienen URL. Las que no,
    // vuelven a "/" para no dejar una URL que al recargar daría 404.
    const destino = URL_DE_RUTA[r] || "/";
    if (window.location.pathname !== destino) {
      window.history.pushState({ route: r }, "", destino);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // Botón atrás/adelante del navegador.
  useEffect(() => {
    const alVolver = () => {
      const r = rutaDesdeUrl();
      if (r) {
        setParams({});
        setRouteState(r);
      }
    };
    window.addEventListener("popstate", alVolver);
    return () => window.removeEventListener("popstate", alVolver);
  }, []);

  const showToast = useCallback((msg, kind = "info") => {
    setToast({ msg, kind, id: Date.now() });
    setTimeout(() => setToast(null), 3200);
  }, []);

  // Restaurar sesión al montar si hay token guardado (validar contra backend).
  useEffect(() => {
    const token = localStorage.getItem("azulito:token");
    if (!token) return;
    fetch("/api/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((payload) => {
        if (payload && payload.user) {
          setUser({ ...payload.user, token });
        } else {
          localStorage.removeItem("azulito:token");
          setUser(null);
        }
      })
      .catch(() => { /* offline: mantenemos user local por ahora */ });
  }, [setUser]);

  const login = async (email, password) => {
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const payload = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(payload.error || `HTTP ${res.status}`);
    localStorage.setItem("azulito:token", payload.token);
    const u = { ...payload.user, token: payload.token };
    setUser(u);
    if (u.mustChangePassword) setRoute(ROUTES.CHANGE_PASSWORD);
    else if (u.role === "user") setRoute(ROUTES.APP_HOME);
    else setRoute(ROUTES.ADMIN_HOME);
    return u;
  };

  const register = async (payload) => {
    const res = await fetch("/api/auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || data.details || `HTTP ${res.status}`);
    if (data.token) {
      localStorage.setItem("azulito:token", data.token);
      const u = { ...data.user, token: data.token };
      setUser(u);
      setRoute(ROUTES.ONBOARDING);
    }
    return data;
  };

  const changePassword = async (currentPassword, nextPassword) => {
    const token = user?.token || localStorage.getItem("azulito:token");
    const res = await fetch("/api/auth/change-password", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ currentPassword, nextPassword }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
    setUser({ ...user, mustChangePassword: false });
    return data;
  };

  const logout = async () => {
    const token = user?.token || localStorage.getItem("azulito:token");
    if (token) {
      fetch("/api/auth/logout", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => {});
    }
    localStorage.removeItem("azulito:token");
    setUser(null);
    setRoute(ROUTES.LANDING);
  };

  const value = {
    route, setRoute, params,
    theme, setTheme,
    user, setUser,
    login, register, changePassword, logout,
    toast, showToast,
    content,
  };

  return React.createElement(AppCtx.Provider, { value }, children);
}

// ============================================================
// SHARED COMPONENTS
// ============================================================

function Drop({ size = 64, className = "", style = {}, happy = true }) {
  // The mascot image — uses the real asset
  return (
    <img
      src="assets/azulito.png"
      alt="Azulito, la gotita del Olimar"
      className={`azulito-mascot ${className}`}
      style={{ width: size, height: size, objectFit: "contain", ...style }}
      draggable={false}
    />
  );
}

function Btn({ children, variant = "primary", size = "md", icon, onClick, type = "button", className = "", style = {}, disabled, as: As = "button", href, ...rest }) {
  const cls = `btn btn--${variant} btn--${size} ${className}`;
  if (As === "a" || href) {
    return <a className={cls} href={href} onClick={onClick} style={style} {...rest}>{icon}{children}</a>;
  }
  return (
    <button className={cls} onClick={onClick} type={type} style={style} disabled={disabled} {...rest}>
      {icon}
      {children}
    </button>
  );
}

function Icon({ name, size = 20, className = "", ...rest }) {
  const paths = {
    arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
    arrowLeft: <path d="M19 12H5M11 6l-6 6 6 6" />,
    check: <path d="M5 13l4 4L19 7" />,
    x: <path d="M6 6l12 12M18 6L6 18" />,
    menu: <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>,
    heart: <path d="M12 21s-7-4.5-9.5-9a5.5 5.5 0 0 1 9.5-4 5.5 5.5 0 0 1 9.5 4C19 16.5 12 21 12 21Z" />,
    chat: <path d="M21 12a8 8 0 0 1-11.4 7.2L4 20l1-5A8 8 0 1 1 21 12Z" />,
    book: <><path d="M4 5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 1-2-2z" /><path d="M4 19h14" /></>,
    users: <><circle cx="9" cy="8" r="3.5" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><circle cx="17" cy="8" r="2.5" /><path d="M15 20c0-2 1-4 2-4h1c2 0 3 2 3 4" /></>,
    home: <><path d="M3 11 12 4l9 7" /><path d="M5 10v10h14V10" /></>,
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" /></>,
    logout: <><path d="M15 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" /><path d="M10 17 15 12 10 7" /><path d="M15 12H3" /></>,
    sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>,
    moon: <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />,
    download: <><path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" /></>,
    plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
    bell: <><path d="M18 16V11a6 6 0 1 0-12 0v5l-2 3h16z" /><path d="M10 20a2 2 0 0 0 4 0" /></>,
    phone: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 20 20 0 0 1-8.7-3.1 19.7 19.7 0 0 1-6-6A20 20 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.9 9.6a16 16 0 0 0 6 6L15.5 14a2 2 0 0 1 2.1-.4c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.8 2z" />,
    location: <><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></>,
    star: <path d="m12 2 3 7 7 .6-5.3 4.7 1.7 7-6.4-4-6.4 4 1.7-7L2 9.6 9 9z" />,
    eye: <><path d="M2 12s4-8 10-8 10 8 10 8-4 8-10 8-10-8-10-8z" /><circle cx="12" cy="12" r="3" /></>,
    eyeOff: <><path d="M9.9 4.2A10 10 0 0 1 12 4c6 0 10 8 10 8a18 18 0 0 1-3.2 4.1" /><path d="M6.6 6.6A18 18 0 0 0 2 12s4 8 10 8a10 10 0 0 0 5.4-1.6" /><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" /><path d="m2 2 20 20" /></>,
    lock: <><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 1 1 8 0v4" /></>,
    mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
    send: <path d="M22 2 11 13M22 2l-7 20-4-9-9-4z" />,
    sparkles: <><path d="M12 3v4M12 17v4M5 12H1M23 12h-4M7 7 4 4M20 20l-3-3M7 17l-3 3M20 4l-3 3" /></>,
    filter: <path d="M3 5h18l-7 9v6l-4-2v-4z" />,
    more: <><circle cx="5" cy="12" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="19" cy="12" r="1.5" /></>,
    edit: <><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></>,
    trash: <><path d="M3 6h18" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M6 6v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6" /></>,
    clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
    shield: <path d="M12 2 4 5v7c0 5 3.5 9 8 10 4.5-1 8-5 8-10V5z" />,
    play: <path d="M7 4v16l14-8z" fill="currentColor" stroke="none" />,
    folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />,
    trending: <><path d="m3 17 6-6 4 4 8-8" /><path d="M14 7h7v7" /></>,
    pin: <><path d="M12 2a6 6 0 0 0-6 6c0 4 6 12 6 12s6-8 6-12a6 6 0 0 0-6-6z" /><circle cx="12" cy="8" r="2" /></>,
    globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></>,
    calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={`icon ${className}`} {...rest}>
      {paths[name]}
    </svg>
  );
}

function Badge({ children, tone = "azul" }) {
  return <span className={`badge badge--${tone}`}>{children}</span>;
}

function Avatar({ name, src, size = 40, bg }) {
  const initials = name?.split(" ").map(s => s[0]).slice(0, 2).join("").toUpperCase() || "?";
  return (
    <div className="avatar" style={{ width: size, height: size, fontSize: size * 0.38, background: bg || `linear-gradient(135deg, var(--azulito), var(--olimar))` }}>
      {src ? <img src={src} alt={name} /> : initials}
    </div>
  );
}

function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div className={`toast toast--${toast.kind}`} key={toast.id}>
      <Icon name={toast.kind === "success" ? "check" : toast.kind === "error" ? "x" : "sparkles"} size={18} />
      <span>{toast.msg}</span>
    </div>
  );
}

function ThemeToggle() {
  const { theme, setTheme } = useApp();
  return (
    <button
      className="theme-toggle"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      aria-label="Cambiar tema"
      title={theme === "light" ? "Modo oscuro" : "Modo claro"}
    >
      <Icon name={theme === "light" ? "moon" : "sun"} size={18} />
    </button>
  );
}

// Public top nav
function PublicNav({ onOpenChat }) {
  const { setRoute } = useApp();
  const [open, setOpen] = useState(false);
  return (
    <header className="pnav">
      <div className="pnav__inner">
        <button className="pnav__brand" onClick={() => setRoute(ROUTES.LANDING)}>
          <Drop size={38} />
          <span className="pnav__wordmark display">Azulito</span>
        </button>
        <nav className={`pnav__links ${open ? "is-open" : ""}`}>
          <a href="#que-es" onClick={() => setOpen(false)}>Qué es</a>
          <a href="#para-quien" onClick={() => setOpen(false)}>Para quién</a>
          <a href="#que-ofrece" onClick={() => setOpen(false)}>Qué ofrece</a>
          <a href="#impulsores" onClick={() => setOpen(false)}>Quiénes</a>
          <button className="pnav__chat-link" onClick={() => { setOpen(false); onOpenChat?.(); }}>
            <Icon name="chat" size={16} /> Hablar con Azulito
          </button>
        </nav>
        <div className="pnav__actions">
          <ThemeToggle />
          <Btn variant="ghost" size="sm" onClick={() => setRoute(ROUTES.LOGIN)}>Entrar</Btn>
          <Btn variant="primary" size="sm" onClick={() => setRoute(ROUTES.REGISTER)}>Crear cuenta</Btn>
          <button className="pnav__burger" onClick={() => setOpen(v => !v)} aria-label="Menú">
            <Icon name={open ? "x" : "menu"} />
          </button>
        </div>
      </div>
    </header>
  );
}

// Private (family) bottom/side nav
function PrivateNav() {
  const { route, setRoute, user, logout } = useApp();
  const items = [
    { id: ROUTES.APP_HOME, label: "Inicio", icon: "home" },
    { id: ROUTES.APP_LIBRARY, label: "Biblioteca", icon: "book" },
    { id: ROUTES.APP_CHAT, label: "Chat", icon: "chat" },
    { id: ROUTES.APP_PROFESSIONALS, label: "Centros", icon: "users" },
    { id: ROUTES.APP_PROFILE, label: "Mi familia", icon: "heart" },
  ];
  return (
    <>
      <aside className="priv-side">
        <button className="priv-side__brand" onClick={() => setRoute(ROUTES.LANDING)}>
          <Drop size={36} />
          <span className="display">Azulito</span>
        </button>
        <nav className="priv-side__nav">
          {items.map(it => (
            <button key={it.id} className={`priv-side__item ${route === it.id ? "is-active" : ""}`} onClick={() => setRoute(it.id)}>
              <Icon name={it.icon} />
              <span>{it.label}</span>
            </button>
          ))}
        </nav>
        <div className="priv-side__foot">
          <div className="priv-side__user">
            <Avatar name={user?.name} size={36} />
            <div>
              <div className="priv-side__user-name">{user?.name}</div>
              <div className="priv-side__user-sub">Familia</div>
            </div>
          </div>
          <div className="priv-side__foot-actions">
            <ThemeToggle />
            <button className="priv-side__logout" onClick={logout} title="Cerrar sesión">
              <Icon name="logout" size={18} />
            </button>
          </div>
        </div>
      </aside>
      {/* Mobile bottom bar: chat destacado como botón central estilo app */}
      <nav className="priv-bbar">
        {items.map(it => {
          const isChat = it.id === ROUTES.APP_CHAT;
          if (isChat) {
            return (
              <button
                key={it.id}
                className={`priv-bbar__fab ${route === it.id ? "is-active" : ""}`}
                onClick={() => setRoute(it.id)}
                aria-label="Chat con Azulito"
              >
                <Icon name="chat" size={26} />
              </button>
            );
          }
          return (
            <button key={it.id} className={`priv-bbar__item ${route === it.id ? "is-active" : ""}`} onClick={() => setRoute(it.id)}>
              <Icon name={it.icon} size={22} />
              <span>{it.label}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
}

// Admin shell side nav
function AdminNav() {
  const { route, setRoute, user, logout } = useApp();
  const items = [
    { id: ROUTES.ADMIN_HOME, label: "Resumen", icon: "home" },
    { id: ROUTES.ADMIN_CONTENT, label: "Contenidos", icon: "folder" },
    { id: ROUTES.ADMIN_USERS, label: "Usuarios", icon: "users", adminOnly: true },
    { id: ROUTES.ADMIN_METRICS, label: "Métricas", icon: "trending" },
    { id: ROUTES.ADMIN_CHAT_LOG, label: "Conversaciones", icon: "chat" },
    { id: ROUTES.ADMIN_AI, label: "Config. IA", icon: "sparkles", adminOnly: true },
  ];
  const isAdmin = user?.role === "admin";
  return (
    <aside className="admin-side">
      <button className="admin-side__brand" onClick={() => setRoute(ROUTES.LANDING)}>
        <Drop size={32} />
        <div>
          <div className="display admin-side__title">Azulito</div>
          <div className="admin-side__sub">Panel {user?.role}</div>
        </div>
      </button>
      <nav className="admin-side__nav">
        {items.map(it => {
          const disabled = it.adminOnly && !isAdmin;
          return (
            <button
              key={it.id}
              className={`admin-side__item ${route === it.id ? "is-active" : ""} ${disabled ? "is-disabled" : ""}`}
              onClick={() => !disabled && setRoute(it.id)}
              disabled={disabled}
              title={disabled ? "Solo admin" : ""}
            >
              <Icon name={it.icon} size={18} />
              <span>{it.label}</span>
              {disabled && <Icon name="lock" size={14} className="admin-side__lock" />}
            </button>
          );
        })}
      </nav>
      <div className="admin-side__foot">
        <div className="admin-side__user">
          <Avatar name={user?.name} size={36} />
          <div>
            <div className="admin-side__user-name">{user?.name}</div>
            <div className="admin-side__user-sub">{user?.email}</div>
          </div>
        </div>
        <div className="admin-side__foot-actions">
          <ThemeToggle />
          <button className="admin-side__logout" onClick={logout} title="Cerrar sesión">
            <Icon name="logout" size={18} />
          </button>
        </div>
      </div>
    </aside>
  );
}

// Expose
Object.assign(window, {
  React, useState, useEffect, useRef, useMemo, useCallback,
  AppProvider, AppCtx, useApp, useContent, ROUTES, CITY_TO_DEPARTMENT,
  Drop, Btn, Icon, Badge, Avatar, Toast, ThemeToggle,
  PublicNav, PrivateNav, AdminNav,
});


/* ===== landing.jsx ===== */

/* Azulito — Landing page */

function Landing({ onOpenChat }) {
  const { setRoute } = useApp();
  const content = useContent();

  // SEO: FAQPage JSON-LD generado desde las FAQs reales de la base, para
  // rich snippets en Google. Se inyecta/reemplaza en <head> al cargar contenido.
  useEffect(() => {
    const faqs = (content.faqs || []).filter((f) => f.q && f.a);
    if (!faqs.length) return;
    let el = document.getElementById("faq-jsonld");
    if (!el) {
      el = document.createElement("script");
      el.id = "faq-jsonld";
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a }
      }))
    });
  }, [content.faqs]);

  return (
    <main className="landing">
      <PublicNav onOpenChat={onOpenChat} />

      {/* ---------- HERO ---------- */}
      <section className="hero">
        <div className="hero__bg" aria-hidden>
          <svg className="hero__wave" viewBox="0 0 1440 400" preserveAspectRatio="none">
            <defs>
              <linearGradient id="wg" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#5CCEF2" stopOpacity="0.35" />
                <stop offset="100%" stopColor="#29B8E8" stopOpacity="0.08" />
              </linearGradient>
            </defs>
            <path d="M0 200 Q 360 80 720 200 T 1440 200 L 1440 400 L 0 400 Z" fill="url(#wg)" />
            <path d="M0 260 Q 360 160 720 260 T 1440 260 L 1440 400 L 0 400 Z" fill="url(#wg)" opacity="0.5" />
          </svg>
          <div className="hero__blob hero__blob--a" />
          <div className="hero__blob hero__blob--b" />
        </div>

        <div className="hero__inner">
          <div className="hero__text">
            <span className="eyebrow hero__eyebrow">
              <span className="eyebrow__dot" /> Una gotita del Olimar
            </span>
            <h1 className="display hero__title">
              Cuando llega el TEA,<br />
              <em className="hero__title-em">nadie tiene que estar solo.</em>
            </h1>
            <p className="hero__lede">
              Azulito es una guía digital gratuita para familias que conviven con el <strong>Trastorno del Espectro Autista</strong> en Treinta y Tres y la región. Información clara, recursos concretos y una red cerca.
            </p>
            <div className="hero__cta">
              <Btn variant="primary" size="lg" icon={<Icon name="chat" size={18} />} onClick={onOpenChat}>
                Hablar con Azulito
              </Btn>
              <Btn variant="ghost" size="lg" onClick={() => setRoute(ROUTES.REGISTER)}>
                Crear cuenta familiar
              </Btn>
            </div>
            <div className="hero__trust">
              <Icon name="shield" size={16} />
              <span>Gratuito · Sin publicidad · Tus datos protegidos</span>
            </div>
          </div>

          <div className="hero__art">
            <div className="hero__mascot-ring">
              <div className="hero__ripple hero__ripple--1" />
              <div className="hero__ripple hero__ripple--2" />
              <div className="hero__ripple hero__ripple--3" />
              <Drop size={280} className="hero__mascot" />
            </div>
            <div className="hero__bubble hero__bubble--1">
              <Icon name="heart" size={14} />
              <span>"Qué observar esta semana"</span>
            </div>
            <div className="hero__bubble hero__bubble--2">
              <Icon name="book" size={14} />
              <span>Tableros visuales</span>
            </div>
            <div className="hero__bubble hero__bubble--3">
              <Icon name="users" size={14} />
              <span>Centros de salud cerca</span>
            </div>
          </div>
        </div>

        <div className="hero__stats">
          <div className="hero__stat">
            <b>{content.stats?.families ?? "—"}</b>
            <span>{(content.stats?.families === 1) ? "familia en la red" : "familias en la red"}</span>
          </div>
          <div className="hero__stat hero__stat--div" />
          <div className="hero__stat"><b>24/7</b><span>orientación disponible</span></div>
          <div className="hero__stat hero__stat--div" />
          <div className="hero__stat">
            <b>{content.stats?.cities ?? "—"}</b>
            <span>{(content.stats?.cities === 1) ? "ciudad conectada" : "ciudades conectadas"}</span>
          </div>
        </div>
      </section>

      {/* ---------- QUÉ ES ---------- */}
      <section className="section" id="que-es">
        <div className="section__inner grid-2">
          <div>
            <span className="eyebrow">01 · Qué es</span>
            <h2 className="display section__title">Una guía amigable disponible las 24 horas.</h2>
            <p className="section__lede">
              Azulito <strong>no diagnostica</strong> ni reemplaza a profesionales de salud. Su función es <em>orientar</em>, <em>acompañar</em> y <em>conectar</em> a las familias con los recursos y las personas que pueden ayudarlas.
            </p>
            <blockquote className="quote">
              "Cuando aparece el 'no sé por dónde empezar', Azulito propone rutas cortas y claras: qué observar, cómo pedir ayuda y qué recursos usar esta semana."
            </blockquote>
          </div>
          <div className="callout-card">
            <div className="callout-card__head">
              <Drop size={48} />
              <div>
                <div className="display callout-card__title">El nombre</div>
                <div className="callout-card__sub">Una gotita del río Olimar</div>
              </div>
            </div>
            <p className="callout-card__body">
              Viene del río que atraviesa Treinta y Tres y del <strong>azul de conciencia sobre el autismo</strong>. Personaje creado por Cristian Moreira (Miloco) para acompañar a cada hogar.
            </p>
            <div className="callout-card__drops">
              <span /><span /><span /><span /><span />
            </div>
          </div>
        </div>
      </section>

      {/* ---------- PARA QUIÉN ---------- */}
      <section className="section section--tinted" id="para-quien">
        <div className="section__inner">
          <div className="section__head">
            <span className="eyebrow">02 · Para quién</span>
            <h2 className="display section__title">Para cada persona que acompaña.</h2>
            <p className="section__lede">No hace falta saber de tecnología para usarlo.</p>
          </div>
          <div className="cards-4">
            {[
              { t: "Familias", d: "Que recién reciben una orientación diagnóstica y no saben por dónde empezar.", icon: "heart", tint: "azul" },
              { t: "Cuidadores cotidianos", d: "Abuelos, tíos o referentes que acompañan el día a día y necesitan herramientas.", icon: "users", tint: "coral" },
              { t: "Docentes y escuelas", d: "Que buscan material visual, guías de anticipación y contacto con profesionales.", icon: "book", tint: "sunny" },
              { t: "Comunidad", d: "Vecinos, clubes, instituciones que quieren entender mejor y apoyar.", icon: "globe", tint: "leaf" },
            ].map((c, i) => (
              <div key={i} className={`audience-card audience-card--${c.tint}`}>
                <div className="audience-card__icon"><Icon name={c.icon} size={22} /></div>
                <h3 className="audience-card__title">{c.t}</h3>
                <p className="audience-card__desc">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- QUÉ OFRECE ---------- */}
      <section className="section" id="que-ofrece">
        <div className="section__inner">
          <div className="section__head">
            <span className="eyebrow">03 · Qué ofrece hoy</span>
            <h2 className="display section__title">Herramientas pensadas para el día a día.</h2>
          </div>

          <div className="offer-grid">
            <div className="offer-card offer-card--lg">
              <div className="offer-card__icon"><Icon name="chat" size={24} /></div>
              <h3>Chat de orientación</h3>
              <p>Un asistente cálido que responde sobre TEA con guías clínicas (NICE, CDC) y recursos locales. Disponible sin registro.</p>
              <button className="offer-card__link" onClick={onOpenChat}>Probar ahora <Icon name="arrow" size={16} /></button>
              <div className="offer-card__demo">
                <div className="mini-chat">
                  <div className="mini-chat__bubble mini-chat__bubble--them">
                    <Drop size={22} />
                    <span>Contame qué te preocupa y vemos juntos 💙</span>
                  </div>
                  <div className="mini-chat__bubble mini-chat__bubble--me">Mi hijo no duerme</div>
                </div>
              </div>
            </div>
            <div className="offer-card">
              <div className="offer-card__icon offer-card__icon--coral"><Icon name="book" size={22} /></div>
              <h3>Biblioteca</h3>
              <p>Guías descargables y tableros visuales para usar en casa y en la escuela.</p>
            </div>
            <div className="offer-card">
              <div className="offer-card__icon offer-card__icon--sunny"><Icon name="users" size={22} /></div>
              <h3>Centros de salud</h3>
              <p>Hospital, mutualista, BPS, MIDES y grupos locales que acompañan familias con TEA en Treinta y Tres.</p>
            </div>
            <div className="offer-card">
              <div className="offer-card__icon offer-card__icon--leaf"><Icon name="heart" size={22} /></div>
              <h3>Testimonios</h3>
              <p>Experiencias reales de familias que orientan y contienen sin juzgar.</p>
            </div>
            <div className="offer-card">
              <div className="offer-card__icon"><Icon name="download" size={22} /></div>
              <h3>Funciona sin internet</h3>
              <p>Se instala como app y los contenidos que ya visitaste quedan disponibles offline.</p>
            </div>
            <div className="offer-card">
              <div className="offer-card__icon offer-card__icon--coral"><Icon name="shield" size={22} /></div>
              <h3>Privacidad</h3>
              <p>Contraseñas encriptadas. Vos controlás tu información. Nunca se comparte con terceros.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- CÓMO FUNCIONA ---------- */}
      <section className="section section--olimar">
        <div className="section__inner">
          <div className="section__head section__head--light">
            <span className="eyebrow eyebrow--light">04 · Cómo funciona</span>
            <h2 className="display section__title">El camino de una familia.</h2>
          </div>
          <div className="steps">
            {[
              { n: "01", t: "Llega al sitio", d: "Desde el celular o la computadora. Sin instalar nada." },
              { n: "02", t: "Explora o consulta", d: "Lee artículos, ve recursos o escribe al chat." },
              { n: "03", t: "Se registra", d: "Si quiere acceso completo, crea su perfil en 2 minutos." },
              { n: "04", t: "Recibe apoyo", d: "Biblioteca completa, profesionales y orientación." },
            ].map((s, i) => (
              <div key={i} className="step">
                <div className="step__num display">{s.n}</div>
                <div className="step__line" />
                <h4 className="step__title">{s.t}</h4>
                <p className="step__desc">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- TESTIMONIOS ---------- */}
      <section className="section">
        <div className="section__inner">
          <div className="section__head">
            <span className="eyebrow">05 · Testimonios</span>
            <h2 className="display section__title">Voces reales de la red.</h2>
          </div>
          <div className="testimonials">
            {content.testimonials.map(t => (
              <article key={t.id} className="testimonial">
                <div className="testimonial__mark" aria-hidden>"</div>
                <p className="testimonial__quote">{t.quote}</p>
                <div className="testimonial__who">
                  <Avatar name={t.name} size={40} />
                  <div>
                    <div className="testimonial__name">{t.name}</div>
                    <div className="testimonial__role">{t.role} · {t.city}</div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- IMPULSORES ---------- */}
      <section className="section section--tinted" id="impulsores">
        <div className="section__inner">
          <div className="section__head">
            <span className="eyebrow">06 · Quiénes impulsan</span>
            <h2 className="display section__title">Nadie puede solo.</h2>
            <p className="section__lede">Una articulación entre organizaciones de Treinta y Tres con un mismo norte.</p>
          </div>
          <div className="impulsors">
            {[
              { t: "Club de Leones Treinta y Tres Olimar", d: "Servicio comunitario y proyectos sociales del departamento." },
              { t: "Club de Leones Treinta y Tres Yerbal", d: "Red leonística local, vinculada al programa TEA." },
              { t: "Asesoría TEA — Distrito", d: "Vínculo institucional dentro de Lions International para programas TEA." },
              { t: "Asociación Amor Azul", d: "Red de familias y referentes TEA. Validación del contenido." },
              { t: "33IA (comunidad INDATA)", d: "Comunidad de tecnología impulsada por INDATA. Apoyo técnico y de desarrollo." },
            ].map((c, i) => (
              <div key={i} className="impulsor">
                <div className="impulsor__badge"><Icon name="shield" size={18} /></div>
                <div>
                  <h4 className="impulsor__title">{c.t}</h4>
                  <p className="impulsor__desc">{c.d}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="impulsor-quote display">
            "Familia, escuela y profesionales con un mismo norte."
          </div>
        </div>
      </section>

      {/* ---------- FAQ ---------- */}
      <section className="section">
        <div className="section__inner section__inner--narrow">
          <div className="section__head">
            <span className="eyebrow">07 · Preguntas frecuentes</span>
            <h2 className="display section__title">Lo que toda familia se pregunta.</h2>
          </div>
          <div className="faqs">
            {content.faqs.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
          </div>
        </div>
      </section>

      {/* ---------- CTA ---------- */}
      <section className="cta-band">
        <div className="cta-band__inner">
          <Drop size={120} className="cta-band__mascot" />
          <h2 className="display cta-band__title">Pronto va a llegar a cada familia.</h2>
          <p className="cta-band__sub">Cada consulta, cada recurso, cada profesional visible es una gotita más del Olimar que acompaña.</p>
          <div className="cta-band__actions">
            <Btn variant="primary" size="lg" onClick={() => setRoute(ROUTES.REGISTER)}>Crear cuenta familiar</Btn>
            <Btn variant="ghost-light" size="lg" onClick={onOpenChat} icon={<Icon name="chat" size={18} />}>Hablar con Azulito</Btn>
          </div>
        </div>
      </section>

      {/* ---------- FOOTER ---------- */}
      <footer className="footer">
        <div className="footer__inner">
          <div className="footer__brand">
            <Drop size={42} />
            <div>
              <div className="display footer__word">Azulito</div>
              <div className="footer__tag">Una gotita del Olimar</div>
            </div>
          </div>
          <div className="footer__cols">
            <div>
              <h5>Proyecto</h5>
              <a href="#que-es">Qué es</a>
              <a href="#para-quien">Para quién</a>
              <a href="#que-ofrece">Qué ofrece</a>
              <a href="#impulsores">Quiénes</a>
            </div>
            <div>
              <h5>Herramientas</h5>
              <button onClick={onOpenChat}>Chat de orientación</button>
              <button onClick={() => setRoute(ROUTES.REGISTER)}>Crear cuenta</button>
              <button onClick={() => setRoute(ROUTES.LOGIN)}>Iniciar sesión</button>
            </div>
            {/* Enlaces reales (no botones): son las páginas que sirve el servidor
                con el contenido en el HTML, y es por acá que Google descubre la
                biblioteca. Ver src/seo-pages.js. */}
            <div>
              <h5>Contenidos</h5>
              <a href="/biblioteca">Biblioteca de guías</a>
              <a href="/articulos">Artículos</a>
            </div>
            <div>
              <h5>Contacto</h5>
              <a href="mailto:plataformaazulito@gmail.com">plataformaazulito@gmail.com</a>
              <span>Treinta y Tres, Uruguay</span>
            </div>
            <div>
              <h5>Legal</h5>
              <button onClick={() => setRoute(ROUTES.PRIVACY)}>Política de privacidad</button>
              <a href="mailto:plataformaazulito@gmail.com">Ejercer derechos</a>
            </div>
          </div>
        </div>
        <p className="footer__notice">
          ¿Viste algo que no corresponde, un dato equivocado o un error en la plataforma?
          Escribinos a <a href="mailto:contacto@indata.uy">contacto@indata.uy</a> y lo corregimos.
        </p>
        <div className="footer__bottom">
          <span>© 2026 Azulito · Impulsado por Clubes de Leones Treinta y Tres Olimar y Treinta y Tres Yerbal, Asesoría TEA del Distrito, Amor Azul, y 33IA (comunidad INDATA).</span>
          <button className="footer__admin" onClick={() => setRoute(ROUTES.LOGIN)}>Panel interno</button>
        </div>
      </footer>

      {/* Bottom bar mobile-only: estilo app, chat como botón central destacado */}
      <nav className="lnav-bbar" aria-label="Navegación principal">
        <a href="#que-es" className="lnav-bbar__item"><Icon name="home" size={22} /><span>Inicio</span></a>
        <a href="#que-ofrece" className="lnav-bbar__item"><Icon name="book" size={22} /><span>Recursos</span></a>
        <button className="lnav-bbar__fab" onClick={onOpenChat} aria-label="Abrir chat">
          <Icon name="chat" size={28} />
        </button>
        <button className="lnav-bbar__item" onClick={() => setRoute(ROUTES.REGISTER)}><Icon name="heart" size={22} /><span>Crear</span></button>
        <button className="lnav-bbar__item" onClick={() => setRoute(ROUTES.LOGIN)}><Icon name="users" size={22} /><span>Entrar</span></button>
      </nav>
    </main>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq ${open ? "is-open" : ""}`}>
      <button className="faq__q" onClick={() => setOpen(v => !v)}>
        <span>{q}</span>
        <span className="faq__plus"><Icon name={open ? "x" : "plus"} size={18} /></span>
      </button>
      {open && <div className="faq__a">{a}</div>}
    </div>
  );
}

window.Landing = Landing;


/* ===== auth.jsx ===== */

/* Azulito — Auth screens */

function AuthLayout({ title, subtitle, children, foot }) {
  const { setRoute } = useApp();
  return (
    <div className="auth">
      {/* Header mobile-only: botón volver al home + logo. El botón "Volver al
          sitio" de la columna izquierda (auth__art) queda oculto en mobile por
          CSS, así que este header cumple esa función en pantallas chicas. */}
      <header className="auth__mobile-nav">
        <button className="auth__mobile-back" onClick={() => setRoute(ROUTES.LANDING)}>
          <Icon name="arrowLeft" size={18} /> Inicio
        </button>
        <button className="auth__mobile-brand" onClick={() => setRoute(ROUTES.LANDING)} aria-label="Ir al inicio">
          <Drop size={30} />
          <span className="display">Azulito</span>
        </button>
      </header>
      <div className="auth__stage">
        <div className="auth__art">
          <button className="auth__home" onClick={() => setRoute(ROUTES.LANDING)}>
            <Icon name="arrowLeft" size={16} /> Volver al sitio
          </button>
          <div className="auth__art-inner">
            <Drop size={180} className="auth__mascot" />
            <h2 className="display auth__art-title">Bienvenido a la red.</h2>
            <p className="auth__art-sub">Azulito acompaña a familias TEA de Treinta y Tres y la región con información, recursos y una comunidad cerca.</p>
            <ul className="auth__features">
              <li><Icon name="check" size={16} /> Gratuito, sin publicidad</li>
              <li><Icon name="check" size={16} /> Datos encriptados y protegidos</li>
              <li><Icon name="check" size={16} /> Contenidos validados con profesionales</li>
            </ul>
          </div>
          <div className="auth__art-foot">
            <span>Impulsado por Clubes de Leones Treinta y Tres Olimar · Treinta y Tres Yerbal · Amor Azul · Asesoría TEA del Distrito · 33IA (INDATA)</span>
          </div>
        </div>

        <div className="auth__panel">
          <div className="auth__panel-inner">
            <div className="auth__head">
              <ThemeToggle />
            </div>
            <div className="auth__brand">
              <Drop size={48} />
              <span className="display">Azulito</span>
            </div>
            <h1 className="display auth__title">{title}</h1>
            {subtitle && <p className="auth__subtitle">{subtitle}</p>}
            {children}
            {foot}
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, hint, icon, type = "text", value, onChange, placeholder, autoFocus, error }) {
  const [show, setShow] = useState(false);
  const isPwd = type === "password";
  return (
    <label className={`field ${error ? "is-error" : ""}`}>
      <span className="field__label">{label}</span>
      <div className="field__control">
        {icon && <span className="field__icon"><Icon name={icon} size={18} /></span>}
        <input
          type={isPwd ? (show ? "text" : "password") : type}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
        {isPwd && (
          <button type="button" className="field__pwd" onClick={() => setShow(v => !v)}>
            <Icon name={show ? "eyeOff" : "eye"} size={18} />
          </button>
        )}
      </div>
      {hint && !error && <span className="field__hint">{hint}</span>}
      {error && <span className="field__err">{error}</span>}
    </label>
  );
}

function Login() {
  const { setRoute, login, showToast } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (!email || !password) { setErr("Ingresá email y contraseña"); return; }
    setBusy(true);
    try {
      await login(email.trim(), password);
      showToast("Hola de nuevo 💙", "success");
    } catch (ex) {
      setErr(ex.message || "No pudimos iniciar sesión");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Hola, ¿quién vuelve hoy?"
      subtitle="Entrá con tu correo para acceder a tu perfil familiar."
      foot={
        <>
          <div className="auth__divider"><span>o</span></div>
          <div className="auth__swap">
            ¿Primera vez? <button onClick={() => setRoute(ROUTES.REGISTER)}>Crear cuenta familiar</button>
          </div>
        </>
      }
    >
      <form className="auth__form" onSubmit={submit}>
        <Field label="Correo electrónico" icon="mail" type="email" value={email} onChange={setEmail} placeholder="tu@correo.com" autoFocus />
        <Field label="Contraseña" icon="lock" type="password" value={password} onChange={setPassword} error={err} />
        <div className="auth__row">
          <label className="checkbox"><input type="checkbox" defaultChecked /> <span>Recordarme</span></label>
          <button type="button" className="auth__link" onClick={() => setRoute(ROUTES.FORGOT)}>¿Olvidaste la contraseña?</button>
        </div>
        <Btn variant="primary" size="lg" type="submit" disabled={busy}>{busy ? "Entrando…" : "Entrar"}</Btn>
      </form>
    </AuthLayout>
  );
}

function Register() {
  const { setRoute, register, showToast } = useApp();
  const [step, setStep] = useState(1);
  const [busy, setBusy] = useState(false);
  const [submitErr, setSubmitErr] = useState(null);
  const [form, setForm] = useState({
    name: "", email: "", city: "Treinta y Tres",
    relation: "Madre/Padre",
    password: "", password2: "",
    children: [{ name: "", age: "", diagnosis: "En estudio" }],
    accept: false,
  });
  const [errores, setErrores] = useState({});
  const limpiarError = (campo) => setErrores(e => (e[campo] ? { ...e, [campo]: null } : e));

  // Validación del paso 1. Mensajes en el tono de la plataforma: dicen qué
  // falta, no retan a nadie.
  const validarPaso1 = () => {
    const nuevos = {};
    if (!form.name.trim()) {
      nuevos.name = "Necesitamos tu nombre para saber cómo llamarte.";
    }
    if (!form.email.trim()) {
      nuevos.email = "Necesitamos un correo para que puedas entrar a tu cuenta.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(form.email.trim())) {
      nuevos.email = "Ese correo no parece válido. Revisalo, por favor.";
    }
    setErrores(nuevos);
    return Object.keys(nuevos).length === 0;
  };

  const upd = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const updChild = (i, k, v) => setForm(f => ({ ...f, children: f.children.map((c, j) => i === j ? { ...c, [k]: v } : c) }));
  const addChild = () => setForm(f => ({ ...f, children: [...f.children, { name: "", age: "", diagnosis: "En estudio" }] }));
  const rmChild = (i) => setForm(f => ({ ...f, children: f.children.filter((_, j) => j !== i) }));

  const pwStrength = useMemo(() => {
    let s = 0;
    if (form.password.length >= 8) s++;
    if (/[A-Z]/.test(form.password)) s++;
    if (/[0-9]/.test(form.password)) s++;
    if (/[^A-Za-z0-9]/.test(form.password)) s++;
    return s;
  }, [form.password]);

  const submit = async () => {
    setSubmitErr(null);
    if (form.password.length < 8) { setSubmitErr("La contraseña debe tener al menos 8 caracteres"); return; }
    if (form.password !== form.password2) { setSubmitErr("Las contraseñas no coinciden"); return; }
    if (!form.accept) { setSubmitErr("Necesitás aceptar términos y privacidad"); return; }
    setBusy(true);
    try {
      const department = (window.CITY_TO_DEPARTMENT || {})[form.city] || form.city || "Treinta y Tres";
      const childrenAges = form.children
        .map(c => String(c.age || "").trim())
        .filter(Boolean);
      await register({
        name: form.name.trim(),
        email: form.email.trim(),
        city: form.city,
        department,
        consentData: true,
        password: form.password,
        childrenAges,
      });
      showToast("¡Cuenta creada! Te damos la bienvenida 💙", "success");
    } catch (ex) {
      setSubmitErr(ex.message || "No pudimos crear la cuenta");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title={step === 3 ? "¡Ya casi!" : "Sumate a la red Azulito"}
      subtitle={step === 3 ? "Último paso antes de empezar." : `Paso ${step} de 3 · Esto no toma más de 2 minutos.`}
      foot={step === 1 && (
        <div className="auth__swap">
          ¿Ya tenés cuenta? <button onClick={() => setRoute(ROUTES.LOGIN)}>Iniciar sesión</button>
        </div>
      )}
    >
      <div className="auth__steps">
        <div className={`auth__step ${step >= 1 ? "is-on" : ""}`}>1</div>
        <div className="auth__steps-line"><div style={{ width: `${(step - 1) * 50}%` }} /></div>
        <div className={`auth__step ${step >= 2 ? "is-on" : ""}`}>2</div>
        <div className="auth__steps-line"><div style={{ width: `${Math.max(0, step - 2) * 100}%` }} /></div>
        <div className={`auth__step ${step >= 3 ? "is-on" : ""}`}>3</div>
      </div>

      {step === 1 && (
        // Antes este submit hacía setStep(2) sin mirar nada: se podía llegar al
        // paso 3 con el nombre y el correo vacíos y recién fallaba al final,
        // después de cargar los datos de los hijos. Ahora no avanza sin lo
        // mínimo, y el error aparece al lado del campo.
        <form className="auth__form" onSubmit={(e) => { e.preventDefault(); if (validarPaso1()) setStep(2); }} noValidate>
          <Field label="Tu nombre" icon="users" value={form.name} onChange={v => { upd("name", v); limpiarError("name"); }} placeholder="María Fernández" autoFocus error={errores.name} />
          <Field label="Correo electrónico" icon="mail" type="email" value={form.email} onChange={v => { upd("email", v); limpiarError("email"); }} placeholder="tu@correo.com" hint="Lo usamos solo para ingresar y recuperar tu cuenta" error={errores.email} />
          <label className="field">
            <span className="field__label">¿Quién sos en la familia?</span>
            <select className="field__select" value={form.relation} onChange={e => upd("relation", e.target.value)}>
              <option>Madre/Padre</option><option>Abuelo/a</option><option>Tío/a</option><option>Cuidador/a</option><option>Docente</option><option>Otro</option>
            </select>
          </label>
          <label className="field">
            <span className="field__label">Ciudad</span>
            <select className="field__select" value={form.city} onChange={e => upd("city", e.target.value)}>
              <option>Treinta y Tres</option><option>Vergara</option><option>Santa Clara</option><option>José Pedro Varela</option><option>Melo</option><option>Otras</option>
            </select>
          </label>
          <Btn variant="primary" size="lg" type="submit">Continuar</Btn>
        </form>
      )}

      {step === 2 && (
        <form className="auth__form" onSubmit={(e) => { e.preventDefault(); setStep(3); }}>
          <div className="auth__kids-head">
            <h3 className="display">Contanos sobre tus hijos/as</h3>
            <p>Esta información es opcional y privada. Nos ayuda a sugerirte recursos más útiles.</p>
          </div>
          {form.children.map((c, i) => (
            <div key={i} className="auth__kid">
              <div className="auth__kid-head">
                <span>Hijo/a #{i + 1}</span>
                {form.children.length > 1 && <button type="button" onClick={() => rmChild(i)}><Icon name="x" size={14} /></button>}
              </div>
              <div className="auth__kid-grid">
                <Field label="Nombre (o inicial)" value={c.name} onChange={v => updChild(i, "name", v)} placeholder="J." />
                <Field label="Edad" type="number" value={c.age} onChange={v => updChild(i, "age", v)} placeholder="5" />
                <label className="field">
                  <span className="field__label">Estado</span>
                  <select className="field__select" value={c.diagnosis} onChange={e => updChild(i, "diagnosis", e.target.value)}>
                    <option>En estudio</option><option>Con diagnóstico TEA</option><option>Orientación diagnóstica</option><option>Prefiero no decir</option>
                  </select>
                </label>
              </div>
            </div>
          ))}
          <button type="button" className="auth__addkid" onClick={addChild}>
            <Icon name="plus" size={16} /> Agregar otro hijo/a
          </button>
          <div className="auth__row">
            <Btn variant="ghost" size="lg" onClick={() => setStep(1)}>Atrás</Btn>
            <Btn variant="primary" size="lg" type="submit">Continuar</Btn>
          </div>
        </form>
      )}

      {step === 3 && (
        <form className="auth__form" onSubmit={(e) => { e.preventDefault(); submit(); }}>
          <div className="auth__confirm" style={{ textAlign: "center" }}>
            <Drop size={56} />
            <h3 className="display">Elegí tu contraseña</h3>
            <p>Tenés que recordarla. La usás cada vez que entrás a Azulito.</p>
          </div>
          <Field label="Contraseña" icon="lock" type="password" value={form.password} onChange={v => upd("password", v)} autoFocus />
          <div className="pwdmeter">
            <div className="pwdmeter__bars">
              {[0,1,2,3].map(i => <div key={i} className={`pwdmeter__bar ${i < pwStrength ? `is-${pwStrength}` : ""}`} />)}
            </div>
            <span className="pwdmeter__label">
              {form.password.length === 0 ? "—" : pwStrength <= 1 ? "Débil" : pwStrength === 2 ? "Aceptable" : pwStrength === 3 ? "Fuerte" : "Muy fuerte"}
            </span>
          </div>
          <ul className="pwdrules">
            <li className={form.password.length >= 8 ? "is-on" : ""}><Icon name="check" size={14} /> 8+ caracteres</li>
            <li className={/[A-Z]/.test(form.password) ? "is-on" : ""}><Icon name="check" size={14} /> Una mayúscula</li>
            <li className={/[0-9]/.test(form.password) ? "is-on" : ""}><Icon name="check" size={14} /> Un número</li>
            <li className={/[^A-Za-z0-9]/.test(form.password) ? "is-on" : ""}><Icon name="check" size={14} /> Un símbolo</li>
          </ul>
          <Field label="Confirmá la contraseña" icon="lock" type="password" value={form.password2} onChange={v => upd("password2", v)} error={submitErr} />
          <label className="checkbox checkbox--lg">
            <input type="checkbox" checked={form.accept} onChange={e => upd("accept", e.target.checked)} />
            <span>Acepto la <button type="button" className="auth__link" onClick={() => setRoute(ROUTES.PRIVACY)}>política de privacidad</button>. Entiendo que Azulito no hace diagnóstico.</span>
          </label>
          <div className="auth__row">
            <Btn variant="ghost" size="lg" onClick={() => setStep(2)} disabled={busy}>Atrás</Btn>
            <Btn variant="primary" size="lg" type="submit" disabled={!form.accept || busy}>{busy ? "Creando…" : "Crear cuenta"}</Btn>
          </div>
        </form>
      )}
    </AuthLayout>
  );
}

function ChangePassword() {
  const { user, setRoute, showToast, changePassword } = useApp();
  const [current, setCurrent] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const strength = useMemo(() => {
    let s = 0;
    if (p1.length >= 8) s++;
    if (/[A-Z]/.test(p1)) s++;
    if (/[0-9]/.test(p1)) s++;
    if (/[^A-Za-z0-9]/.test(p1)) s++;
    return s;
  }, [p1]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (!current) return setErr("Ingresá tu contraseña actual");
    if (p1.length < 8) return setErr("La nueva contraseña necesita al menos 8 caracteres");
    if (p1 !== p2) return setErr("Las contraseñas no coinciden");
    setBusy(true);
    try {
      await changePassword(current, p1);
      showToast("¡Contraseña actualizada! 💙", "success");
      setTimeout(() => {
        if (user?.role === "user") setRoute(ROUTES.APP_HOME);
        else setRoute(ROUTES.ADMIN_HOME);
      }, 400);
    } catch (ex) {
      setErr(ex.message || "No se pudo actualizar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Cambiá tu contraseña temporal"
      subtitle="Es un paso de seguridad de primer acceso. Elegí una nueva contraseña que recuerdes."
    >
      <form className="auth__form" onSubmit={submit}>
        <Field label="Contraseña actual" icon="lock" type="password" value={current} onChange={setCurrent} autoFocus />
        <Field label="Nueva contraseña" icon="lock" type="password" value={p1} onChange={setP1} />
        <div className="pwdmeter">
          <div className="pwdmeter__bars">
            {[0,1,2,3].map(i => <div key={i} className={`pwdmeter__bar ${i < strength ? `is-${strength}` : ""}`} />)}
          </div>
          <span className="pwdmeter__label">
            {strength <= 1 ? "Débil" : strength === 2 ? "Aceptable" : strength === 3 ? "Fuerte" : "Muy fuerte"}
          </span>
        </div>
        <ul className="pwdrules">
          <li className={p1.length >= 8 ? "is-on" : ""}><Icon name="check" size={14} /> 8+ caracteres</li>
          <li className={/[A-Z]/.test(p1) ? "is-on" : ""}><Icon name="check" size={14} /> Una mayúscula</li>
          <li className={/[0-9]/.test(p1) ? "is-on" : ""}><Icon name="check" size={14} /> Un número</li>
          <li className={/[^A-Za-z0-9]/.test(p1) ? "is-on" : ""}><Icon name="check" size={14} /> Un símbolo</li>
        </ul>
        <Field label="Confirmá la contraseña" icon="lock" type="password" value={p2} onChange={setP2} error={err} />
        <Btn variant="primary" size="lg" type="submit" disabled={busy}>{busy ? "Guardando…" : "Guardar y continuar"}</Btn>
      </form>
    </AuthLayout>
  );
}

Object.assign(window, { Login, Register, ChangePassword });


/* ===== chat.jsx ===== */

/* Azulito — Chat */

// Mapea sourceUsed del backend a mensajes tipo card/pro para la UI.
// Solo crea cards para los tipos que tienen una vista clickeable en la app
// (recursos y profesionales). Artículos y FAQs se mencionan en el texto del
// modelo pero no generan card — no hay detail page para ellos y una card
// no-clickeable solo confundiría.
const SALUDO = "Hola 💙 Soy Azulito. Contame qué te preocupa esta semana y vemos juntas por dónde empezar. No diagnostico ni reemplazo a un profesional, pero puedo acompañarte con pasos claros.";

// Las conversaciones sin cuenta se guardan en el navegador. Antes quedaban para
// siempre: al reabrir el chat aparecían mensajes de días atrás, con información
// que podía estar desactualizada, y en un dispositivo compartido la siguiente
// persona veía la conversación de la familia anterior. Ahora caducan.
const VIDA_SESION_ANONIMA_MS = 12 * 60 * 60 * 1000;

function leerSesionAnonima() {
  try {
    const id = localStorage.getItem("azulito:chat-session");
    if (!id) return null;
    const visto = Number(localStorage.getItem("azulito:chat-session-ts") || 0);
    if (!visto || Date.now() - visto > VIDA_SESION_ANONIMA_MS) {
      olvidarSesionAnonima();
      return null;
    }
    return id;
  } catch {
    return null;
  }
}

function recordarSesionAnonima(id) {
  try {
    localStorage.setItem("azulito:chat-session", id);
    localStorage.setItem("azulito:chat-session-ts", String(Date.now()));
  } catch { /* modo privado o storage lleno: la sesión vive solo en memoria */ }
}

function olvidarSesionAnonima() {
  try {
    localStorage.removeItem("azulito:chat-session");
    localStorage.removeItem("azulito:chat-session-ts");
  } catch { /* ídem */ }
}

function buildSourceAttachments(sourceUsed, professionals) {
  if (!Array.isArray(sourceUsed)) return [];
  const attachments = [];
  const seen = new Set();
  for (const src of sourceUsed) {
    if (!src || typeof src.label !== "string") continue;
    const key = `${src.type}:${src.label}`;
    if (seen.has(key)) continue;
    seen.add(key);
    if (src.type === "resource" && src.id) {
      attachments.push({
        from: "azulito",
        type: "card",
        card: {
          kind: "resource",
          id: src.id,
          title: src.label,
          subtitle: "Recurso de la biblioteca",
          icon: "book",
          action: "Leer",
        },
      });
    } else if (src.type === "professional") {
      const match = (professionals || []).find(p => p.name === src.label);
      if (match) {
        attachments.push({ from: "azulito", type: "pro", pro: match });
      }
    }
    if (attachments.length >= 2) break;
  }
  return attachments;
}

function ChatView({ embedded, onClose }) {
  const { user, setRoute } = useApp();
  const content = useContent();
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [sessionId, setSessionId] = useState(() => (user ? null : leerSesionAnonima()));
  const scrollRef = useRef();

  // Empezar de cero. Necesario en dispositivos compartidos —la tablet de la
  // asociación, la computadora de una charla— donde el hilo anterior queda
  // guardado y la siguiente persona lo hereda.
  const nuevaConversacion = () => {
    if (typing) return;
    olvidarSesionAnonima();
    setSessionId(null);
    setMsgs([{ from: "azulito", text: user ? `Hola ${user.name?.split(" ")[0] || ""} 💙 Contame en qué te acompaño hoy.` : SALUDO }]);
  };

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [msgs, typing]);

  useEffect(() => {
    // Solo persistimos sessionId para anónimos. Los usuarios logueados no lo
    // necesitan en localStorage porque el historial viaja por userId.
    if (sessionId && !user) recordarSesionAnonima(sessionId);
  }, [sessionId, user]);

  // Hidratar historial al montar: logueado → por user, anónimo → por sessionId
  // guardado. Fallback a welcome message si no hay nada.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const params = new URLSearchParams();
        const headers = {};
        if (user?.token) {
          headers.Authorization = `Bearer ${user.token}`;
        } else if (sessionId) {
          params.set("sessionId", sessionId);
        } else {
          // Sin user y sin sessionId previo: no hay historial. Mostramos welcome.
          if (!cancelled) {
            setMsgs([{ from: "azulito", text: SALUDO }]);
            setLoaded(true);
          }
          return;
        }
        const qs = params.toString();
        const res = await fetch(`/api/chat/history${qs ? "?" + qs : ""}`, { headers });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        const history = (data.messages || []).map((m) => ({
          from: m.role === "user" ? "user" : "azulito",
          text: m.content,
        }));
        if (cancelled) return;
        if (history.length === 0) {
          setMsgs([{ from: "azulito", text: user ? `Hola ${user.name?.split(" ")[0] || ""} 💙 Contame en qué te acompaño hoy.` : SALUDO }]);
        } else {
          setMsgs(history);
        }
        setLoaded(true);
      } catch (e) {
        console.warn("[chat-history]", e.message);
        if (!cancelled) {
          setMsgs([{ from: "azulito", text: "Hola 💙 Soy Azulito. Contame qué te preocupa." }]);
          setLoaded(true);
        }
      }
    })();
    return () => { cancelled = true; };
    // Rehidrata si cambia de user (login/logout). No dependemos de sessionId para
    // evitar refetches cuando setSessionId ocurre tras el primer send.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const send = async (text) => {
    if (!text.trim() || typing) return;
    const userMsg = { from: "user", text };
    setMsgs(m => [...m, userMsg]);
    setInput("");
    setTyping(true);
    try {
      const headers = { "Content-Type": "application/json" };
      if (user?.token) headers.Authorization = `Bearer ${user.token}`;
      const res = await fetch("/api/chat/messages", {
        method: "POST",
        headers,
        body: JSON.stringify({ message: text, sessionId: sessionId || undefined }),
      });
      if (res.status === 403) {
        // La sesión guardada es de otra cuenta (típico en dispositivo
        // compartido). Se descarta y se reintenta una sola vez con una nueva.
        olvidarSesionAnonima();
        setSessionId(null);
        const reintento = await fetch("/api/chat/messages", {
          method: "POST",
          headers,
          body: JSON.stringify({ message: text }),
        });
        if (!reintento.ok) throw new Error(`HTTP ${reintento.status}`);
        const dato = await reintento.json();
        if (dato.sessionId) setSessionId(dato.sessionId);
        setMsgs(m => [...m, { from: "azulito", text: dato.reply }, ...buildSourceAttachments(dato.sourceUsed, content.professionals)]);
        return;
      }
      if (!res.ok) {
        const payload = await res.json().catch(() => ({}));
        throw new Error(payload.error || `HTTP ${res.status}`);
      }
      const data = await res.json();
      if (data.sessionId) setSessionId(data.sessionId);
      const extras = buildSourceAttachments(data.sourceUsed, content.professionals);
      setMsgs(m => [...m, { from: "azulito", text: data.reply }, ...extras]);
    } catch (e) {
      console.error("[chat]", e);
      setMsgs(m => [...m, {
        from: "azulito",
        text: "Tuve un problema para responderte recién. Probá de nuevo en unos segundos 💙",
      }]);
    } finally {
      setTyping(false);
    }
  };

  // Back siempre visible. Si el chat está embedded (FAB + pop-over o fullscreen
   // mobile), cierra el popup. Si es standalone (ruta app-chat), rutea al home.
  const handleBack = () => {
    if (onClose) onClose();
    else setRoute(user ? ROUTES.APP_HOME : ROUTES.LANDING);
  };

  return (
    <div className={`chat ${embedded ? "chat--embed" : ""}`}>
      <header className="chat__header">
        <button className="chat__back" onClick={handleBack} aria-label="Volver al sitio">
          <Icon name="arrowLeft" size={18} />
          <span className="chat__back-label">Volver al sitio</span>
        </button>
        <div className="chat__avatar"><Drop size={40} /></div>
        <div className="chat__head-body">
          <div className="chat__head-name">Azulito</div>
          <div className="chat__head-status"><span className="chat__dot" /> En línea</div>
        </div>
        {msgs.length > 1 && (
          <button
            className="chat__nueva"
            onClick={nuevaConversacion}
            disabled={typing}
            title="Empezar una conversación nueva"
          >
            <Icon name="plus" size={16} />
            <span className="chat__nueva-label">Nueva</span>
          </button>
        )}
      </header>

      <div className="chat__disclaim">
        <Icon name="shield" size={14} /> Azulito no diagnostica. En urgencias buscá ayuda presencial.
      </div>

      <div className="chat__stream" ref={scrollRef}>
        <div className="chat__day">Hoy</div>
        {msgs.map((m, i) => <Msg key={i} m={m} />)}
        {typing && (
          <div className="msg msg--them">
            <div className="msg__avatar"><Drop size={28} /></div>
            <div className="msg__bubble msg__bubble--typing">
              <span /><span /><span />
            </div>
          </div>
        )}
      </div>

      <div className="chat__suggestions">
        {DATA.chatSuggestions.slice(0, 4).map((s, i) => (
          <button key={i} onClick={() => send(s)}>{s}</button>
        ))}
      </div>

      <form className="chat__composer" onSubmit={(e) => { e.preventDefault(); send(input); }}>
        <input
          placeholder="Contame qué te preocupa…"
          value={input}
          onChange={e => setInput(e.target.value)}
        />
        <button type="submit" className="chat__send" aria-label="Enviar"><Icon name="send" size={18} /></button>
      </form>

      {/* Azulito puede equivocarse. Si dice algo que no corresponde, queremos
          enterarnos: es la vía más rápida para corregir el contenido. */}
      <p className="chat__report">
        ¿Azulito te respondió algo que no corresponde? Avisanos a <a href="mailto:contacto@indata.uy">contacto@indata.uy</a>
      </p>
    </div>
  );
}

function Msg({ m }) {
  const { setRoute } = useApp();
  if (m.from === "user") {
    return <div className="msg msg--me"><div className="msg__bubble">{m.text}</div></div>;
  }
  const openCard = () => {
    if (m.card?.kind === "resource" && m.card.id) {
      setRoute(ROUTES.RESOURCE_DETAIL, { id: m.card.id });
    }
  };
  const openPro = () => {
    if (m.pro?.id) setRoute(ROUTES.PROFESSIONAL_DETAIL, { id: m.pro.id });
  };
  return (
    <div className="msg msg--them">
      <div className="msg__avatar"><Drop size={28} /></div>
      {m.type === "card" && (
        <div className="msg__bubble msg__bubble--rich">
          <button type="button" className="msg-card msg-card--clickable" onClick={openCard}>
            <div className="msg-card__icon"><Icon name={m.card.icon} size={20} /></div>
            <div>
              <div className="msg-card__title">{m.card.title}</div>
              <div className="msg-card__sub">{m.card.subtitle}</div>
            </div>
            <span className="msg-card__action">{m.card.action} <Icon name="arrow" size={14} /></span>
          </button>
        </div>
      )}
      {m.type === "pro" && (
        <div className="msg__bubble msg__bubble--rich">
          <button type="button" className="msg-pro msg-pro--clickable" onClick={openPro}>
            <Avatar name={m.pro.name} size={44} />
            <div>
              <div className="msg-pro__name">{m.pro.name}</div>
              <div className="msg-pro__role">{m.pro.role} · {m.pro.city}</div>
            </div>
            <span className="msg-pro__action"><Icon name="arrow" size={14} /> Ver ficha</span>
          </button>
        </div>
      )}
      {!m.type && <div className="msg__bubble">{m.text}</div>}
    </div>
  );
}

// Floating chat widget for landing page
function ChatFab({ open, onToggle }) {
  return (
    <>
      <button className={`chat-fab ${open ? "is-open" : ""}`} onClick={onToggle} aria-label="Abrir chat">
        {open ? <Icon name="x" size={22} /> : <><Drop size={36} className="chat-fab__drop" /><span className="chat-fab__pulse" /></>}
      </button>
      {open && (
        <div className="chat-pop">
          <ChatView embedded onClose={onToggle} />
        </div>
      )}
    </>
  );
}

Object.assign(window, { ChatView, ChatFab });


/* ===== app.jsx ===== */

/* Azulito — Private family area */

// Tiempo relativo corto en español. Se usa en la actividad reciente del chat.
function relTimeEs(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 60_000) return "ahora";
  if (diff < 3_600_000) return `hace ${Math.round(diff / 60_000)} min`;
  if (diff < 86_400_000) return `hace ${Math.round(diff / 3_600_000)} h`;
  if (diff < 7 * 86_400_000) return `hace ${Math.round(diff / 86_400_000)} d`;
  return new Date(iso).toLocaleDateString("es-UY", { day: "2-digit", month: "short" });
}

// Fetch del overview privado del usuario (incluye hijos registrados). Se usa
// tanto en AppHome (stats) como en Profile (lista de hijos).
function usePrivateOverview() {
  const { user } = useApp();
  const [data, setData] = useState(null);
  useEffect(() => {
    const token = user?.token;
    if (!token) return;
    let cancelled = false;
    fetch("/api/app/overview", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : null)
      .then((payload) => { if (!cancelled && payload) setData(payload); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [user?.token]);
  return data;
}

// Fetch del historial de chat del usuario (últimas N interacciones).
function useChatHistory() {
  const { user } = useApp();
  const [messages, setMessages] = useState(null);
  useEffect(() => {
    const token = user?.token;
    if (!token) { setMessages([]); return; }
    let cancelled = false;
    fetch("/api/chat/history", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : { messages: [] })
      .then((payload) => { if (!cancelled) setMessages(payload.messages || []); })
      .catch(() => { if (!cancelled) setMessages([]); });
    return () => { cancelled = true; };
  }, [user?.token]);
  return messages;
}

function AppHome() {
  const { user, setRoute } = useApp();
  const content = useContent();
  const overview = usePrivateOverview();
  const history = useChatHistory();
  const openResource = (r) => setRoute(ROUTES.RESOURCE_DETAIL, { id: r.id });
  const openProfessional = (p) => setRoute(ROUTES.PROFESSIONAL_DETAIL, { id: p.id });
  const stopAnd = (cb) => (e) => { e.stopPropagation(); cb?.(); };
  const lastRead = useMemo(() => (window.getLastReading ? window.getLastReading(content.resources) : null), [content.resources]);
  const first = user?.name?.split(" ")[0] || "Familia";
  const now = new Date();
  const hour = now.getHours();
  const greet = hour < 12 ? "Buenos días" : hour < 19 ? "Buenas tardes" : "Buenas noches";

  // Últimas preguntas del usuario al chat (solo role=user, top 3 más recientes).
  const recentQuestions = useMemo(() => {
    if (!Array.isArray(history)) return [];
    return history
      .filter((m) => m.role === "user")
      .slice(-3)
      .reverse();
  }, [history]);

  // Profesional cercano: matchea por ciudad exacta primero, después departamento.
  // Si no hay match, cae al primero del listado.
  const nearbyPro = useMemo(() => {
    const list = content.professionals || [];
    if (!list.length) return null;
    const city = (user?.city || "").toLowerCase();
    const dept = (user?.department || "").toLowerCase();
    return (
      list.find((p) => city && (p.city || "").toLowerCase() === city) ||
      list.find((p) => dept && (p.city || "").toLowerCase().includes(dept)) ||
      list[0]
    );
  }, [content.professionals, user?.city, user?.department]);

  // Conteo simple de actividad del usuario: consultas al chat + lecturas
  // iniciadas (guardadas en localStorage por el reader).
  const chatCount = Array.isArray(history) ? history.filter((m) => m.role === "user").length : 0;
  const readingCount = useMemo(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("azulito:reader:progress") || "{}");
      return Object.keys(raw).length;
    } catch { return 0; }
  }, []);

  const featuredResources = content.resources.filter((r) => r.pinned).slice(0, 2);
  const resourcesToShow = featuredResources.length > 0 ? featuredResources : content.resources.slice(0, 2);

  return (
    <div className="appview">
      <header className="appview__header">
        <div>
          <div className="appview__greet">{greet}, {first} 💙</div>
          <h1 className="display appview__title">¿En qué te acompañamos hoy?</h1>
        </div>
      </header>

      {/* Mini stats personales */}
      <div className="home-stats">
        <div className="home-stat">
          <div className="home-stat__icon home-stat__icon--azul"><Icon name="chat" size={18} /></div>
          <div>
            <div className="home-stat__value display">{chatCount}</div>
            <div className="home-stat__label">{chatCount === 1 ? "consulta al chat" : "consultas al chat"}</div>
          </div>
        </div>
        <div className="home-stat">
          <div className="home-stat__icon home-stat__icon--leaf"><Icon name="book" size={18} /></div>
          <div>
            <div className="home-stat__value display">{readingCount}</div>
            <div className="home-stat__label">{readingCount === 1 ? "recurso abierto" : "recursos abiertos"}</div>
          </div>
        </div>
        <div className="home-stat">
          <div className="home-stat__icon home-stat__icon--coral"><Icon name="heart" size={18} /></div>
          <div>
            <div className="home-stat__value display">{overview?.children?.length ?? (user?.childrenCount ?? 0)}</div>
            <div className="home-stat__label">en tu familia</div>
          </div>
        </div>
      </div>

      {lastRead && (
        <button className="continue-reading" onClick={() => openResource(lastRead.resource)}>
          <div className="continue-reading__icon"><Icon name="book" size={20} /></div>
          <div className="continue-reading__body">
            <span className="eyebrow">Continuar leyendo</span>
            <div className="continue-reading__title">{lastRead.resource.title}</div>
            <div className="continue-reading__bar"><div style={{ width: `${lastRead.pct}%` }} /></div>
            <div className="continue-reading__meta">{lastRead.pct}% leído</div>
          </div>
          <Icon name="arrow" size={20} />
        </button>
      )}

      {/* Big CTA: chat */}
      <button className="home-chat" onClick={() => setRoute(ROUTES.APP_CHAT)}>
        <div className="home-chat__mascot"><Drop size={96} /></div>
        <div className="home-chat__body">
          <span className="eyebrow">Siempre disponible</span>
          <h2 className="display">Hablá con Azulito</h2>
          <p>Contale qué te preocupa esta semana. Responde con calma y recursos concretos.</p>
        </div>
        <Icon name="arrow" size={22} className="home-chat__arrow" />
      </button>

      {/* Actividad reciente en el chat — solo si el usuario ya conversó */}
      {recentQuestions.length > 0 && (
        <section className="home-week">
          <div className="home-week__head">
            <div>
              <span className="eyebrow">Tu actividad reciente</span>
              <h3 className="display">Últimas consultas al chat</h3>
            </div>
            <button className="home-week__more" onClick={() => setRoute(ROUTES.APP_CHAT)}>Seguir conversando</button>
          </div>
          <div className="home-week__list">
            {recentQuestions.map((m, i) => (
              <button key={i} className="home-week__item home-week__item--btn" onClick={() => setRoute(ROUTES.APP_CHAT)}>
                <div className="home-week__check"><Icon name="chat" size={14} /></div>
                <div className="home-week__text">{String(m.content).slice(0, 140)}{m.content.length > 140 ? "…" : ""}</div>
                <div className="home-week__day">{relTimeEs(m.createdAt)}</div>
              </button>
            ))}
          </div>
        </section>
      )}

      <div className="home-grid">
        {/* Featured resources */}
        <section className="home-card">
          <div className="home-card__head">
            <h3 className="display">Recursos para vos</h3>
            <button onClick={() => setRoute(ROUTES.APP_LIBRARY)}>Ver todos</button>
          </div>
          <div className="home-res">
            {resourcesToShow.length === 0
              ? <div className="home-empty">Todavía no hay recursos destacados.</div>
              : resourcesToShow.map((r) => (
                <div key={r.id} className="res-row" style={{ cursor: "pointer" }} onClick={() => openResource(r)}>
                  <div className="res-row__icon"><Icon name="book" /></div>
                  <div className="res-row__body">
                    <div className="res-row__title">{r.title}</div>
                    <div className="res-row__meta"><Badge tone="coral">{r.cat}</Badge><span>{r.type}</span>{r.pages && <span>· {r.pages} pág.</span>}</div>
                  </div>
                  <button className="res-row__action" onClick={stopAnd(() => openResource(r))} aria-label="Abrir recurso"><Icon name="arrow" size={16} /></button>
                </div>
              ))}
          </div>
        </section>

        {/* Centro de salud / referencia cercana — filtrado por ciudad/departamento */}
        <section className="home-card">
          <div className="home-card__head">
            <h3 className="display">
              {nearbyPro && user?.city && nearbyPro.city === user.city ? `Referencia en ${user.city}` : "Centro de salud cerca"}
            </h3>
            <button onClick={() => setRoute(ROUTES.APP_PROFESSIONALS)}>Ver todos</button>
          </div>
          {nearbyPro ? (
            <div className="pro-mini" style={{ cursor: "pointer" }} onClick={() => openProfessional(nearbyPro)}>
              <Avatar name={nearbyPro.name} size={56} />
              <div>
                <div className="pro-mini__name">{nearbyPro.name}</div>
                <div className="pro-mini__role">{nearbyPro.role}</div>
                <div className="pro-mini__city"><Icon name="location" size={14} />{nearbyPro.city}</div>
              </div>
              <Btn variant="ghost" size="sm" icon={<Icon name="arrow" size={14} />} onClick={stopAnd(() => openProfessional(nearbyPro))}>Ver ficha</Btn>
            </div>
          ) : <div className="home-empty">Estamos cargando los centros de salud.</div>}
        </section>

        {/* Read */}
        <section className="home-card home-card--full">
          <div className="home-card__head">
            <h3 className="display">Para leer esta semana</h3>
            {content.articles.length > 3 && <button onClick={() => setRoute(ROUTES.APP_LIBRARY)}>Ver todos</button>}
          </div>
          <div className="home-articles">
            {content.articles.length === 0
              ? <div className="home-empty">Todavía no hay artículos publicados.</div>
              : content.articles.slice(0, 3).map((a) => (
                <article key={a.id} className="art-row" style={{ cursor: "pointer" }} onClick={() => setRoute(ROUTES.ARTICLE_DETAIL, { id: a.id })}>
                  <div className="art-row__cat"><Badge tone="azul">{a.cat}</Badge></div>
                  <h4 className="art-row__title">{a.title}</h4>
                  <p className="art-row__excerpt">{a.excerpt}</p>
                  <div className="art-row__meta"><Icon name="clock" size={14} />{a.readMin} min de lectura · <b>Leer</b></div>
                </article>
              ))}
          </div>
        </section>
      </div>
    </div>
  );
}

function Library() {
  const { setRoute } = useApp();
  const content = useContent();
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("Todas");
  const openResource = (r) => setRoute(ROUTES.RESOURCE_DETAIL, { id: r.id });
  const cats = ["Todas", ...new Set(content.resources.map(r => r.cat))];
  const items = content.resources.filter(r => (cat === "Todas" || r.cat === cat) && r.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="appview">
      <header className="appview__header">
        <div>
          <span className="eyebrow">Biblioteca</span>
          <h1 className="display appview__title">Recursos para usar hoy.</h1>
        </div>
      </header>

      <div className="lib-toolbar">
        <div className="lib-search">
          <Icon name="search" size={18} />
          <input placeholder="Buscar guías, tableros, plantillas…" value={q} onChange={e => setQ(e.target.value)} />
        </div>
        <div className="lib-chips">
          {cats.map(c => (
            <button key={c} className={`chip ${cat === c ? "is-on" : ""}`} onClick={() => setCat(c)}>{c}</button>
          ))}
        </div>
      </div>

      <div className="lib-grid">
        {items.map(r => (
          <article key={r.id} className="res-card" style={{ cursor: "pointer" }} onClick={() => openResource(r)}>
            <div className="res-card__cover">
              {r.imageUrl
                ? <img src={r.imageUrl} alt={r.title || "Recurso de la biblioteca Azulito"} className="res-card__img" loading="lazy" />
                : <div className="res-card__cover-grid">
                    {[...Array(6)].map((_, i) => <span key={i} style={{ opacity: 0.2 + (i % 3) * 0.2 }} />)}
                  </div>}
              <Badge tone="coral">{r.cat}</Badge>
              {r.pinned && <div className="res-card__pin"><Icon name="pin" size={14} /></div>}
            </div>
            <div className="res-card__body">
              <div className="res-card__type">{r.type}{r.readMin ? ` · ${r.readMin} min de lectura` : (r.pages ? ` · ${r.pages} pág.` : "")}</div>
              <h3 className="res-card__title">{r.title}</h3>
              <div className="res-card__foot">
                <span><Icon name="eye" size={14} />{r.downloads}</span>
                <Btn variant="primary" size="sm" icon={<Icon name="book" size={14} />} onClick={(e) => { e.stopPropagation(); openResource(r); }}>Leer</Btn>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

// Elige icono + color del badge según los tags del centro. Heurística simple
// para que cada tipo de centro (público, mutualista, trámites, grupo TEA) tenga
// identidad visual clara sin inventar datos.
function centerIconTone(p) {
  const tags = (p.tags || []).map((t) => t.toLowerCase());
  if (tags.some((t) => t.includes("público") || t.includes("publico"))) return { icon: "shield", tone: "azul" };
  if (tags.some((t) => t.includes("mutualista"))) return { icon: "heart", tone: "coral" };
  if (tags.some((t) => t.includes("pensión") || t.includes("trámite") || t.includes("ayudas"))) return { icon: "folder", tone: "sunny" };
  if (tags.some((t) => t.includes("tea") || t.includes("familias") || t.includes("pares"))) return { icon: "sparkles", tone: "coral" };
  if (tags.some((t) => t.includes("programas") || t.includes("inclusión"))) return { icon: "users", tone: "leaf" };
  if (tags.some((t) => t.includes("0-3") || t.includes("temprana"))) return { icon: "star", tone: "sunny" };
  return { icon: "location", tone: "azul" };
}

function Professionals() {
  const { setRoute } = useApp();
  const content = useContent();
  const [city, setCity] = useState("Todas");
  const cities = ["Todas", ...new Set(content.professionals.map(p => p.city))];
  const items = content.professionals.filter(p => city === "Todas" || p.city === city);
  const openPro = (p) => setRoute(ROUTES.PROFESSIONAL_DETAIL, { id: p.id });
  return (
    <div className="appview">
      <header className="appview__header">
        <div>
          <span className="eyebrow">Centros de salud y referencias</span>
          <h1 className="display appview__title">Dónde pedir ayuda.</h1>
          <p className="appview__lede">Hospital, mutualistas, BPS, MIDES y grupos locales que acompañan familias con TEA en Treinta y Tres. Si hace falta algún contacto, escribinos y lo sumamos.</p>
        </div>
      </header>

      <div className="lib-toolbar">
        <div className="lib-chips">
          {cities.map(c => (
            <button key={c} className={`chip ${city === c ? "is-on" : ""}`} onClick={() => setCity(c)}>{c}</button>
          ))}
        </div>
      </div>

      <div className="center-grid">
        {items.map((p) => {
          const { icon, tone } = centerIconTone(p);
          const shortNotes = p.notes ? String(p.notes).slice(0, 140) + (p.notes.length > 140 ? "…" : "") : "";
          return (
            <article key={p.id} className="center-card" onClick={() => openPro(p)}>
              <div className={`center-card__icon center-card__icon--${tone}`}>
                <Icon name={icon} size={22} />
              </div>
              <h3 className="center-card__name">{p.name}</h3>
              <div className="center-card__role">{p.role}</div>
              <div className="center-card__city">
                <Icon name="location" size={13} />{p.city}
              </div>
              {shortNotes && <p className="center-card__notes">{shortNotes}</p>}
              <div className="center-card__tags">
                {(p.tags || []).slice(0, 3).map((t) => <Badge key={t} tone="azul">{t}</Badge>)}
              </div>
              <div className="center-card__foot">
                <span className="center-card__cta">Ver ficha <Icon name="arrow" size={14} /></span>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}

function Testimonials() {
  const content = useContent();
  return (
    <div className="appview">
      <header className="appview__header">
        <div>
          <span className="eyebrow">Testimonios</span>
          <h1 className="display appview__title">Lo que cuentan otras familias.</h1>
        </div>
      </header>
      <div className="testimonials">
        {content.testimonials.map(t => (
          <article key={t.id} className="testimonial">
            <div className="testimonial__mark">"</div>
            <p className="testimonial__quote">{t.quote}</p>
            <div className="testimonial__who">
              <Avatar name={t.name} size={40} />
              <div>
                <div className="testimonial__name">{t.name}</div>
                <div className="testimonial__role">{t.role} · {t.city}</div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

function Profile() {
  const { user, setUser, logout, setRoute, showToast } = useApp();
  const overview = usePrivateOverview();
  const [localChildren, setLocalChildren] = useState(null);
  const children = localChildren ?? overview?.children ?? [];
  const [editOpen, setEditOpen] = useState(false);
  const [form, setForm] = useState({ name: "", city: "" });
  const [kidForm, setKidForm] = useState(null); // {id?, approximateAge, notes}
  const [busy, setBusy] = useState(false);

  const authHeaders = { Authorization: `Bearer ${user?.token}`, "Content-Type": "application/json" };

  const openEdit = () => {
    setForm({ name: user?.name || "", city: user?.city || "" });
    setEditOpen(true);
  };

  const saveMe = async () => {
    setBusy(true);
    try {
      const r = await fetch("/api/me", { method: "PUT", headers: authHeaders, body: JSON.stringify(form) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
      setUser({ ...user, ...data.user, token: user.token });
      showToast("Datos actualizados 💙", "success");
      setEditOpen(false);
    } catch (e) {
      showToast(e.message, "error");
    } finally {
      setBusy(false);
    }
  };

  const saveKid = async () => {
    setBusy(true);
    try {
      const isNew = !kidForm.id;
      const r = await fetch(isNew ? "/api/me/children" : `/api/me/children/${kidForm.id}`, {
        method: isNew ? "POST" : "PUT",
        headers: authHeaders,
        body: JSON.stringify({ approximateAge: kidForm.approximateAge, notes: kidForm.notes })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
      const base = localChildren ?? overview?.children ?? [];
      setLocalChildren(isNew ? [...base, data.child] : base.map((c) => (c.id === data.child.id ? data.child : c)));
      showToast(isNew ? "Integrante agregado 💙" : "Integrante actualizado 💙", "success");
      setKidForm(null);
    } catch (e) {
      showToast(e.message, "error");
    } finally {
      setBusy(false);
    }
  };

  const removeKid = async (c) => {
    if (!window.confirm("¿Quitar este integrante del censo familiar?")) return;
    try {
      const r = await fetch(`/api/me/children/${c.id}`, { method: "DELETE", headers: authHeaders });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const base = localChildren ?? overview?.children ?? [];
      setLocalChildren(base.filter((k) => k.id !== c.id));
      showToast("Integrante quitado", "success");
    } catch (e) {
      showToast(e.message, "error");
    }
  };

  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deletePwd, setDeletePwd] = useState("");

  const deleteAccount = async () => {
    setBusy(true);
    try {
      const r = await fetch("/api/me", { method: "DELETE", headers: authHeaders, body: JSON.stringify({ password: deletePwd }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
      showToast("Tu cuenta fue eliminada. Gracias por haber sido parte 💙", "success");
      setTimeout(logout, 1200);
    } catch (e) {
      showToast(e.message, "error");
      setBusy(false);
    }
  };
  const kidGradients = [
    "linear-gradient(135deg, var(--coral), var(--coral-deep))",
    "linear-gradient(135deg, var(--sunny), var(--coral))",
    "linear-gradient(135deg, var(--azulito), var(--olimar))",
    "linear-gradient(135deg, var(--leaf), var(--azulito))",
  ];
  const location = [user?.city, user?.department].filter(Boolean).filter((v, i, arr) => arr.indexOf(v) === i).join(" · ") || "—";
  const fmtJoined = user?.createdAt ? new Date(user.createdAt).toLocaleDateString("es-UY", { month: "long", year: "numeric" }) : null;

  return (
    <div className="appview">
      <header className="appview__header">
        <div>
          <span className="eyebrow">Mi familia</span>
          <h1 className="display appview__title">Perfil familiar</h1>
        </div>
      </header>
      <div className="profile-grid">
        <div className="profile-card">
          <Avatar name={user?.alias || user?.name} size={72} />
          <h2 className="display">{user?.name}</h2>
          {user?.alias && user.alias !== user.name && <div className="profile-meta">{user.alias}</div>}
          <div className="profile-meta">{user?.email}</div>
          <div className="profile-meta">{location}</div>
          {fmtJoined && <div className="profile-meta">Registrado desde {fmtJoined}</div>}
          <Btn variant="ghost" size="sm" icon={<Icon name="edit" size={14} />} onClick={openEdit}>Editar mis datos</Btn>
          <Btn variant="ghost" size="sm" icon={<Icon name="lock" size={14} />} onClick={() => setRoute(ROUTES.CHANGE_PASSWORD)}>Cambiar contraseña</Btn>
        </div>
        <div className="profile-card">
          <h3 className="display">Mis hijos/as</h3>
          <div className="profile-kids">
            {children.length === 0 && (
              <div className="home-empty" style={{ padding: "16px 0" }}>
                No registraste hijos/as todavía. El censo es voluntario.
              </div>
            )}
            {children.map((c, i) => {
              const label = c.approximateAge ? `${c.approximateAge}${/\d/.test(c.approximateAge) && !/año/i.test(c.approximateAge) ? " años" : ""}` : "Edad no especificada";
              const noteOrRole = c.notes?.trim() || "En nuestra red";
              return (
                <div key={c.id || i} className="profile-kid">
                  <Avatar name={c.approximateAge ? `H${i + 1}` : "H"} size={44} bg={kidGradients[i % kidGradients.length]} />
                  <div>
                    <b>Hijo/a {i + 1}</b>
                    <span>{label} · {noteOrRole}</span>
                  </div>
                  <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
                    <button className="admin-action" title="Editar" onClick={() => setKidForm({ id: c.id, approximateAge: c.approximateAge || "", notes: c.notes || "" })}>
                      <Icon name="edit" size={12} />
                    </button>
                    <button className="admin-action admin-action--danger" title="Quitar" onClick={() => removeKid(c)}>
                      <Icon name="trash" size={12} />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          <Btn variant="ghost" size="sm" icon={<Icon name="plus" size={14} />} onClick={() => setKidForm({ approximateAge: "", notes: "" })}>Agregar integrante</Btn>
        </div>
        <div className="profile-card">
          <h3 className="display">Privacidad y datos</h3>
          <ul className="profile-list">
            <li><Icon name="shield" size={16} /> Tus datos están protegidos y no se comparten</li>
            <li><Icon name="check" size={16} /> Controlás tu perfil desde acá</li>
            <li><Icon name="mail" size={16} /> Para bajas o consultas: plataformaazulito@gmail.com</li>
          </ul>
          <Btn variant="ghost" size="sm" onClick={() => setRoute(ROUTES.PRIVACY)}>Ver política completa</Btn>
          <Btn variant="ghost" size="sm" icon={<Icon name="logout" size={14} />} onClick={logout}>Cerrar sesión</Btn>
          <Btn variant="ghost" size="sm" icon={<Icon name="trash" size={14} />} onClick={() => { setDeletePwd(""); setDeleteOpen(true); }}>Eliminar mi cuenta</Btn>
        </div>
      </div>

      {deleteOpen && (
        <div className="admin-modal" onClick={() => !busy && setDeleteOpen(false)}>
          <div className="admin-modal__dialog" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal__head">
              <h2 className="display admin-modal__title">Eliminar mi cuenta</h2>
              <button className="admin-modal__close" onClick={() => setDeleteOpen(false)} disabled={busy} aria-label="Cerrar">×</button>
            </div>
            <div className="admin-modal__body">
              <p><b>Esto es definitivo.</b> Se eliminan tu cuenta, los datos del censo familiar y todo tu historial de chat. No se puede deshacer.</p>
              <p>Si preferís hacer una pausa sin perder nada, podés simplemente cerrar sesión y volver cuando quieras.</p>
              <div className="field">
                <span className="field__label">Confirmá tu contraseña</span>
                <input className="field__input" type="password" value={deletePwd} onChange={(e) => setDeletePwd(e.target.value)} autoFocus />
              </div>
            </div>
            <div className="admin-modal__foot">
              <Btn variant="primary" size="md" onClick={() => setDeleteOpen(false)} disabled={busy}>Conservar mi cuenta</Btn>
              <Btn variant="ghost" size="md" onClick={deleteAccount} disabled={busy || !deletePwd}>{busy ? "Eliminando…" : "Eliminar definitivamente"}</Btn>
            </div>
          </div>
        </div>
      )}

      {editOpen && (
        <div className="admin-modal" onClick={() => !busy && setEditOpen(false)}>
          <div className="admin-modal__dialog" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal__head">
              <h2 className="display admin-modal__title">Editar mis datos</h2>
              <button className="admin-modal__close" onClick={() => setEditOpen(false)} disabled={busy} aria-label="Cerrar">×</button>
            </div>
            <div className="admin-modal__body">
              <div className="field">
                <span className="field__label">Nombre</span>
                <input className="field__input" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} />
              </div>
              <div className="field">
                <span className="field__label">Ciudad</span>
                <input className="field__input" value={form.city} onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))} />
              </div>
            </div>
            <div className="admin-modal__foot">
              <Btn variant="ghost" size="md" onClick={() => setEditOpen(false)} disabled={busy}>Cancelar</Btn>
              <Btn variant="primary" size="md" onClick={saveMe} disabled={busy}>{busy ? "Guardando…" : "Guardar"}</Btn>
            </div>
          </div>
        </div>
      )}

      {kidForm && (
        <div className="admin-modal" onClick={() => !busy && setKidForm(null)}>
          <div className="admin-modal__dialog" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal__head">
              <h2 className="display admin-modal__title">{kidForm.id ? "Editar integrante" : "Agregar integrante"}</h2>
              <button className="admin-modal__close" onClick={() => setKidForm(null)} disabled={busy} aria-label="Cerrar">×</button>
            </div>
            <div className="admin-modal__body">
              <div className="field">
                <span className="field__label">Edad aproximada</span>
                <input className="field__input" placeholder="Ej: 5" value={kidForm.approximateAge} onChange={(e) => setKidForm((f) => ({ ...f, approximateAge: e.target.value }))} />
              </div>
              <div className="field">
                <span className="field__label">Notas (opcional)</span>
                <input className="field__input" placeholder="Lo que quieras recordar" value={kidForm.notes} onChange={(e) => setKidForm((f) => ({ ...f, notes: e.target.value }))} />
              </div>
            </div>
            <div className="admin-modal__foot">
              <Btn variant="ghost" size="md" onClick={() => setKidForm(null)} disabled={busy}>Cancelar</Btn>
              <Btn variant="primary" size="md" onClick={saveKid} disabled={busy}>{busy ? "Guardando…" : "Guardar"}</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

Object.assign(window, { AppHome, Library, Professionals, Testimonials, Profile });


/* ===== charts.jsx ===== */

/* Azulito — gráficos del panel de métricas
 *
 * Escritos a mano en SVG, sin librería. El bundle es uno solo: el mismo app.js
 * que descarga cada familia desde el celular incluye el panel admin, así que
 * meter una librería de gráficos ahí les cuesta ancho de banda a ellas para
 * mejorar una pantalla que usa una sola persona.
 *
 * Reemplazan a MiniChart, que era un sparkline sin ejes cuyas etiquetas decían
 * siempre "Ene…Dic" sin importar los datos — se usaba para visitas por día,
 * registros por día y mensajes por hora, y en los tres casos mentía.
 *
 * Paleta validada con el script de la guía de visualización, en modo claro
 * (sobre crema #FDF9F3) y oscuro (sobre #0A1F2B): las tres pasan banda de
 * luminosidad, piso de croma, separación para daltonismo y contraste.
 *   serie 1  #1A8FBD  azul gotita
 *   serie 2  #C2662E  coral profundo
 *   serie 3  #7A5EA8  violeta
 */

const VIZ_SERIES = ["var(--viz-1)", "var(--viz-2)", "var(--viz-3)"];

// --- utilidades ------------------------------------------------------------

function ejeY(max) {
  // Escala "linda": 1-2-5 × potencia de 10, para que las guías caigan en
  // números que una persona lee de un vistazo (0, 5, 10) y no en 0, 3.7, 7.4.
  if (!max || max <= 0) return { tope: 1, pasos: [0, 1] };
  const magnitud = Math.pow(10, Math.floor(Math.log10(max)));
  const norm = max / magnitud;
  const escalon = (norm <= 1 ? 1 : norm <= 2 ? 2 : norm <= 5 ? 5 : 10) * magnitud;
  const paso = escalon / 2;
  const pasos = [];
  for (let v = 0; v <= escalon + 0.0001; v += paso) pasos.push(Math.round(v * 100) / 100);
  return { tope: escalon, pasos };
}

function diaCorto(iso) {
  if (!iso || iso.length < 10) return iso || "";
  const [, m, d] = iso.split("-");
  return `${Number(d)}/${Number(m)}`;
}

function diaLargo(iso) {
  if (!iso || iso.length < 10) return iso || "";
  const dias = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
  const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "setiembre", "octubre", "noviembre", "diciembre"];
  const f = new Date(`${iso}T12:00:00Z`);
  return `${dias[f.getUTCDay()]} ${f.getUTCDate()} de ${meses[f.getUTCMonth()]}`;
}

// Cuántas etiquetas del eje X entran sin encimarse.
function saltoEtiquetas(n, ancho) {
  const porEtiqueta = 46;
  const caben = Math.max(2, Math.floor(ancho / porEtiqueta));
  return Math.max(1, Math.ceil(n / caben));
}

// --- Serie temporal (área + línea, con crosshair) --------------------------

function GraficoTiempo({ datos, etiqueta = "valor", color = 0, alto = 190, formatoX = diaCorto, formatoTooltip = diaLargo }) {
  const [activo, setActivo] = useState(null);
  const [ancho, setAncho] = useState(720);
  const cajaRef = useRef(null);

  useEffect(() => {
    const medir = () => { if (cajaRef.current) setAncho(cajaRef.current.clientWidth || 720); };
    medir();
    window.addEventListener("resize", medir);
    return () => window.removeEventListener("resize", medir);
  }, []);

  const puntos = datos || [];
  if (!puntos.length) return <div className="viz viz--vacio">Sin datos en este período</div>;

  const M = { arriba: 12, derecha: 12, abajo: 26, izquierda: 34 };
  const W = Math.max(280, ancho);
  const H = alto;
  const anchoTrama = W - M.izquierda - M.derecha;
  const altoTrama = H - M.arriba - M.abajo;
  const maxDato = Math.max(...puntos.map((p) => p.n), 0);
  const { tope, pasos } = ejeY(maxDato);

  const x = (i) => M.izquierda + (puntos.length === 1 ? anchoTrama / 2 : (i / (puntos.length - 1)) * anchoTrama);
  const y = (v) => M.arriba + altoTrama - (v / tope) * altoTrama;

  const linea = puntos.map((p, i) => `${i === 0 ? "M" : "L"} ${x(i).toFixed(1)},${y(p.n).toFixed(1)}`).join(" ");
  const area = `${linea} L ${x(puntos.length - 1).toFixed(1)},${y(0)} L ${x(0).toFixed(1)},${y(0)} Z`;
  const trazo = VIZ_SERIES[color % VIZ_SERIES.length];
  const gradId = `viz-grad-${color}`;
  const salto = saltoEtiquetas(puntos.length, anchoTrama);

  const alMover = (evento) => {
    const caja = evento.currentTarget.getBoundingClientRect();
    const px = ((evento.clientX - caja.left) / caja.width) * W;
    const i = Math.round(((px - M.izquierda) / anchoTrama) * (puntos.length - 1));
    setActivo(Math.max(0, Math.min(puntos.length - 1, i)));
  };

  return (
    <div className="viz" ref={cajaRef}>
      <svg
        viewBox={`0 0 ${W} ${H}`}
        className="viz__svg"
        role="img"
        aria-label={`${etiqueta} por día, del ${formatoTooltip(puntos[0].day)} al ${formatoTooltip(puntos[puntos.length - 1].day)}`}
        onPointerMove={alMover}
        onPointerLeave={() => setActivo(null)}
      >
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={trazo} stopOpacity="0.22" />
            <stop offset="100%" stopColor={trazo} stopOpacity="0.02" />
          </linearGradient>
        </defs>

        {/* Guías horizontales: recesivas, nunca compiten con los datos */}
        {pasos.map((v) => (
          <g key={v}>
            <line x1={M.izquierda} y1={y(v)} x2={W - M.derecha} y2={y(v)} className="viz__guia" />
            <text x={M.izquierda - 7} y={y(v) + 3.5} className="viz__num" textAnchor="end">{v}</text>
          </g>
        ))}

        <path d={area} fill={`url(#${gradId})`} />
        <path d={linea} fill="none" stroke={trazo} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />

        {/* Crosshair: el lector apunta a una fecha, no a una línea de 2px */}
        {activo !== null && (
          <g>
            <line x1={x(activo)} y1={M.arriba} x2={x(activo)} y2={M.arriba + altoTrama} className="viz__cruz" />
            <circle cx={x(activo)} cy={y(puntos[activo].n)} r="5" fill={trazo} className="viz__punto" />
          </g>
        )}

        {puntos.map((p, i) =>
          i % salto === 0 || i === puntos.length - 1 ? (
            <text key={p.day} x={x(i)} y={H - 8} className="viz__num" textAnchor="middle">{formatoX(p.day)}</text>
          ) : null
        )}
      </svg>

      {activo !== null && (
        <div
          className="viz__tip"
          style={{ left: `${(x(activo) / W) * 100}%` }}
        >
          <strong>{puntos[activo].n}</strong>
          <span>{etiqueta}</span>
          <em>{formatoTooltip(puntos[activo].day)}</em>
        </div>
      )}
    </div>
  );
}

// --- Barras (categorías o franjas horarias) --------------------------------

function GraficoBarras({ datos, etiqueta = "valor", color = 0, alto = 190, horizontal = false }) {
  const [activo, setActivo] = useState(null);
  const puntos = datos || [];
  if (!puntos.length) return <div className="viz viz--vacio">Sin datos en este período</div>;

  const trazo = VIZ_SERIES[color % VIZ_SERIES.length];
  const max = Math.max(...puntos.map((p) => p.n), 0);
  const { tope, pasos } = ejeY(max);

  if (horizontal) {
    // Categorías con nombre: horizontal, porque las etiquetas se leen enteras
    // sin rotarlas — rotar texto es una molestia para quien lee, no un estilo.
    return (
      <div className="viz viz--barras-h">
        {puntos.map((p, i) => (
          <div
            key={p.label}
            className={`vizb ${activo === i ? "is-activa" : ""}`}
            onPointerEnter={() => setActivo(i)}
            onPointerLeave={() => setActivo(null)}
            tabIndex={0}
            onFocus={() => setActivo(i)}
            onBlur={() => setActivo(null)}
          >
            <span className="vizb__nombre" title={p.label}>{p.label}</span>
            <span className="vizb__pista">
              <span className="vizb__fill" style={{ width: `${tope ? (p.n / tope) * 100 : 0}%`, background: trazo }} />
            </span>
            <span className="vizb__valor">{p.n}</span>
          </div>
        ))}
      </div>
    );
  }

  const W = 720, H = alto;
  const M = { arriba: 12, derecha: 8, abajo: 24, izquierda: 34 };
  const anchoTrama = W - M.izquierda - M.derecha;
  const altoTrama = H - M.arriba - M.abajo;
  const paso = anchoTrama / puntos.length;
  const anchoBarra = Math.max(3, paso - 3); // 2px+ de aire entre barras
  const y = (v) => M.arriba + altoTrama - (v / tope) * altoTrama;
  const salto = saltoEtiquetas(puntos.length, anchoTrama);

  return (
    <div className="viz">
      <svg viewBox={`0 0 ${W} ${H}`} className="viz__svg" role="img" aria-label={`${etiqueta} por franja`}>
        {pasos.map((v) => (
          <g key={v}>
            <line x1={M.izquierda} y1={y(v)} x2={W - M.derecha} y2={y(v)} className="viz__guia" />
            <text x={M.izquierda - 7} y={y(v) + 3.5} className="viz__num" textAnchor="end">{v}</text>
          </g>
        ))}
        {puntos.map((p, i) => (
          <g key={p.label}
             onPointerEnter={() => setActivo(i)}
             onPointerLeave={() => setActivo(null)}>
            {/* Área de contacto más grande que la barra pintada */}
            <rect x={M.izquierda + i * paso} y={M.arriba} width={paso} height={altoTrama} fill="transparent" />
            <rect
              x={M.izquierda + i * paso + (paso - anchoBarra) / 2}
              y={y(p.n)}
              width={anchoBarra}
              height={Math.max(0, M.arriba + altoTrama - y(p.n))}
              rx="3"
              fill={trazo}
              opacity={activo === null || activo === i ? 1 : 0.45}
            />
          </g>
        ))}
        {puntos.map((p, i) =>
          i % salto === 0 ? (
            <text key={p.label} x={M.izquierda + i * paso + paso / 2} y={H - 7} className="viz__num" textAnchor="middle">{p.label}</text>
          ) : null
        )}
      </svg>
      {activo !== null && (
        <div className="viz__tip viz__tip--fijo">
          <strong>{puntos[activo].n}</strong>
          <span>{etiqueta}</span>
          <em>{puntos[activo].label}</em>
        </div>
      )}
    </div>
  );
}

// --- Tabla de respaldo -----------------------------------------------------
// La guía pide que todo valor que muestre un tooltip sea alcanzable sin hover.

function TablaDatos({ datos, columna = "Día", etiqueta = "Valor", formato = diaCorto }) {
  const [abierta, setAbierta] = useState(false);
  if (!datos || !datos.length) return null;
  return (
    <div className="viz-tabla">
      <button className="viz-tabla__toggle" onClick={() => setAbierta((v) => !v)} aria-expanded={abierta}>
        {abierta ? "Ocultar datos" : "Ver datos"}
      </button>
      {abierta && (
        <table>
          <thead><tr><th>{columna}</th><th>{etiqueta}</th></tr></thead>
          <tbody>
            {datos.map((p) => (
              <tr key={p.day || p.label}><td>{p.day ? formato(p.day) : p.label}</td><td>{p.n}</td></tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}


/* ===== admin.jsx ===== */

/* Azulito — Admin panel + Metrics */

// --- Rango de fechas del panel ---------------------------------------------

function hoyUY() {
  return new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);
}

function hoyMenos(dias) {
  return new Date(Date.now() - 3 * 3600 * 1000 - dias * 86400000).toISOString().slice(0, 10);
}

const PRESETS = [
  { id: "hoy", nombre: "Hoy", calcular: () => ({ desde: hoyUY(), hasta: hoyUY() }) },
  { id: "7d", nombre: "7 días", calcular: () => ({ desde: hoyMenos(6), hasta: hoyUY() }) },
  { id: "30d", nombre: "30 días", calcular: () => ({ desde: hoyMenos(29), hasta: hoyUY() }) },
  { id: "90d", nombre: "90 días", calcular: () => ({ desde: hoyMenos(89), hasta: hoyUY() }) },
  // "Todo" arranca en el primer dato real de la plataforma, no en una fecha
  // arbitraria: así el gráfico no abre con meses vacíos por delante.
  { id: "todo", nombre: "Todo", calcular: () => ({ desde: "2026-03-01", hasta: hoyUY() }) },
];

// Hook: fetch del summary real desde /api/admin/summary, acotado al rango.
function useAdminSummary(rango) {
  const { user } = useApp();
  const [summary, setSummary] = useState(null);
  const [err, setErr] = useState(null);
  const [cargando, setCargando] = useState(false);
  const desde = rango?.desde;
  const hasta = rango?.hasta;

  useEffect(() => {
    const token = user?.token;
    if (!token) { setErr("no-token"); return; }
    let cancelled = false;
    setCargando(true);
    const qs = desde && hasta ? `?desde=${desde}&hasta=${hasta}` : "";
    fetch(`/api/admin/summary${qs}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then((data) => { if (!cancelled) { setSummary(data); setErr(null); } })
      .catch((e) => { if (!cancelled) setErr(e.message); })
      .finally(() => { if (!cancelled) setCargando(false); });
    return () => { cancelled = true; };
  }, [user?.token, desde, hasta]);

  return { summary, err, cargando };
}

// Barra de filtros: una sola fila, arriba de todo, y alcanza a TODO lo que hay
// debajo — si un número del panel no responde al filtro, dos cifras de la misma
// pantalla dejan de cerrar y no se sabe cuál creer.
function FiltroFechas({ rango, onCambio, cargando }) {
  const [abierto, setAbierto] = useState(false);
  const activo = PRESETS.find((p) => {
    const r = p.calcular();
    return r.desde === rango.desde && r.hasta === rango.hasta;
  });

  return (
    <div className="filtros">
      <div className="filtros__presets" role="group" aria-label="Período">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            className={`filtros__preset ${activo?.id === p.id ? "is-on" : ""}`}
            onClick={() => { onCambio(p.calcular()); setAbierto(false); }}
            aria-pressed={activo?.id === p.id}
          >
            {p.nombre}
          </button>
        ))}
        <button
          className={`filtros__preset ${!activo ? "is-on" : ""}`}
          onClick={() => setAbierto((v) => !v)}
          aria-expanded={abierto}
        >
          {activo ? "A medida" : `${rango.desde} → ${rango.hasta}`}
        </button>
      </div>

      {abierto && (
        <div className="filtros__custom">
          <label>
            <span>Desde</span>
            <input type="date" value={rango.desde} max={rango.hasta}
                   onChange={(e) => e.target.value && onCambio({ ...rango, desde: e.target.value })} />
          </label>
          <label>
            <span>Hasta</span>
            <input type="date" value={rango.hasta} min={rango.desde} max={hoyUY()}
                   onChange={(e) => e.target.value && onCambio({ ...rango, hasta: e.target.value })} />
          </label>
        </div>
      )}

      {cargando && <span className="filtros__cargando">actualizando…</span>}
    </div>
  );
}

function relTime(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 60000) return "hace unos segundos";
  if (diff < 3600000) return `hace ${Math.round(diff / 60000)} min`;
  if (diff < 86400000) return `hace ${Math.round(diff / 3600000)} h`;
  return `hace ${Math.round(diff / 86400000)} d`;
}

function AdminHome() {
  const { user, setRoute } = useApp();
  const content = useContent();
  const { summary } = useAdminSummary();
  const t = summary?.totals;
  const ready = !!summary;
  const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("es-UY"));
  return (
    <div className="adminview">
      <header className="adminview__header">
        <div>
          <div className="adminview__greet">Hola, {user?.name?.split(" ")[0]} 💙</div>
          <h1 className="display adminview__title">Panel {user?.role}</h1>
        </div>
        <div className="adminview__head-actions">
          <Btn variant="ghost" size="sm" icon={<Icon name="bell" size={14} />} onClick={() => setRoute(ROUTES.ADMIN_CHAT_LOG)}>Consultas</Btn>
          <Btn variant="primary" size="sm" icon={<Icon name="plus" size={14} />} onClick={() => setRoute(ROUTES.ADMIN_CONTENT)}>Gestionar contenidos</Btn>
        </div>
      </header>

      <div className="kpi-row">
        <KPI label="Familias registradas" value={fmt(t?.registeredUsers)} delta={ready ? `${fmt(t.cities)} ciudad${t.cities === 1 ? "" : "es"}` : "cargando…"} tone="azul" icon="heart" />
        <KPI label="Niños/as en el censo" value={fmt(t?.totalChildren)} delta={ready ? (t.totalChildren === 0 ? "sin datos todavía" : "censo voluntario") : "cargando…"} tone="coral" icon="users" />
        <KPI label="Consultas al chat" value={fmt(t?.messages)} delta={ready ? `${fmt(t.conversations)} sesion${t.conversations === 1 ? "" : "es"}` : "cargando…"} tone="sunny" icon="chat" />
        <KPI label="Recursos activos" value={fmt(t?.activeResources)} delta={ready ? `${fmt(t.publishedArticles)} artículos publicados` : "cargando…"} tone="leaf" icon="book" />
      </div>

      <div className="admin-grid">
        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Últimas consultas del chat</h3>
            <button onClick={() => setRoute(ROUTES.ADMIN_CHAT_LOG)}>Ver todas</button>
          </div>
          <div className="admin-chat-list">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && summary.latestMessages.length === 0 && <div className="admin-empty">Sin consultas todavía. Cuando las mamás empiecen a usar el chat, aparecen acá.</div>}
            {ready && summary.latestMessages.map((c) => (
              <div key={c.id} className="admin-chat-row">
                <div className="admin-chat-row__from">{c.from}</div>
                <div className="admin-chat-row__q">{String(c.question).slice(0, 140)}{c.question.length > 140 ? "…" : ""}</div>
                <div className="admin-chat-row__t">{relTime(c.createdAt)}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Recursos más vistos</h3>
            <button onClick={() => setRoute(ROUTES.ADMIN_CONTENT)}>Gestionar</button>
          </div>
          <div className="admin-top">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && summary.topResources.map((r, i) => {
              const maxViews = Math.max(1, ...summary.topResources.map((x) => x.views || 0));
              return (
                <div key={r.id} className="admin-top-row">
                  <div className="admin-top-row__rank">{i + 1}</div>
                  <div className="admin-top-row__title">{r.title}</div>
                  <div className="admin-top-row__bar">
                    <div style={{ width: `${(r.views / maxViews) * 100}%` }} />
                  </div>
                  <div className="admin-top-row__n">{r.views}</div>
                </div>
              );
            })}
          </div>
        </section>

        <section className="admin-card admin-card--wide">
          <div className="admin-card__head">
            <h3 className="display">Conversaciones abiertas por día</h3>
            <span className="admin-card__sub">últimos 14 días</span>
          </div>
          {ready
            ? <GraficoTiempo datos={summary.conversacionesPorDia} etiqueta="conversaciones" color={0} alto={160} />
            : <div className="admin-empty">Cargando…</div>}
        </section>
      </div>
    </div>
  );
}

function KPI({ label, value, delta, tone, icon }) {
  return (
    <div className={`kpi kpi--${tone}`}>
      <div className="kpi__icon"><Icon name={icon} size={18} /></div>
      <div className="kpi__label">{label}</div>
      <div className="kpi__value display">{value}</div>
      <div className="kpi__delta"><Icon name="trending" size={12} /> {delta}</div>
    </div>
  );
}


// Esquema de formulario por entidad. Lo usa el modal de editor para renderizar
// campos correctos (text, textarea, number, select, bool, tags CSV). Debe seguir
// emparejado con entitySchemas en src/store.js — si agregás un campo allá,
// agregalo acá también o no se podrá editar desde el panel.
const CONTENT_FORM_SCHEMA = {
  resources: [
    { key: "title", label: "Título", type: "text", required: true },
    { key: "shortDescription", label: "Descripción corta", type: "textarea", required: true },
    { key: "body", label: "Contenido (markdown)", type: "textarea-lg", hint: "Lo que lee la familia en el reader. Soporta markdown básico." },
    { key: "type", label: "Tipo", type: "select", required: true, options: ["guia","pdf","video","post","articulo","herramienta"] },
    { key: "category", label: "Categoría", type: "text", required: true },
    { key: "tags", label: "Tags (separadas por coma)", type: "tags" },
    { key: "pages", label: "Páginas", type: "number" },
    { key: "readMin", label: "Minutos de lectura", type: "number" },
    { key: "assetUrl", label: "URL del archivo (opcional)", type: "text" },
    { key: "imageUrl", label: "URL de imagen (opcional)", type: "text" },
    { key: "visibility", label: "Visibilidad", type: "select", required: true, options: ["public","registered","admin"] },
    { key: "featured", label: "Destacado en home", type: "bool" },
    { key: "active", label: "Publicado (activo)", type: "bool" },
  ],
  articles: [
    { key: "title", label: "Título", type: "text", required: true },
    { key: "slug", label: "Slug (URL amigable)", type: "text" },
    { key: "summary", label: "Resumen", type: "textarea", required: true },
    { key: "content", label: "Contenido (markdown)", type: "textarea-lg", required: true },
    { key: "cover", label: "URL de portada", type: "text" },
    { key: "category", label: "Categoría", type: "text", required: true },
    { key: "readMin", label: "Minutos de lectura", type: "number" },
    { key: "published", label: "Publicado", type: "bool" },
  ],
  testimonials: [
    { key: "title", label: "Título", type: "text", required: true },
    { key: "content", label: "Testimonio", type: "textarea-lg", required: true },
    { key: "authorAlias", label: "Autor/a (alias)", type: "text" },
    { key: "authorRole", label: "Rol (ej. mamá de X)", type: "text" },
    { key: "authorCity", label: "Ciudad", type: "text" },
    { key: "category", label: "Categoría", type: "text", required: true },
    { key: "tags", label: "Tags (separadas por coma)", type: "tags" },
    { key: "active", label: "Visible", type: "bool" },
  ],
  professionals: [
    { key: "name", label: "Nombre del centro", type: "text", required: true },
    { key: "specialty", label: "Tipo (hospital, mutualista, BPS, etc.)", type: "text", required: true },
    { key: "city", label: "Ciudad", type: "text", required: true },
    { key: "department", label: "Departamento", type: "text", required: true },
    { key: "phone", label: "Teléfono", type: "text" },
    { key: "address", label: "Dirección", type: "text" },
    { key: "notes", label: "Descripción y qué pueden gestionar ahí", type: "textarea" },
    { key: "modality", label: "Modalidad de atención (mutualista, particular, publico, bps-ayex, distancia — separadas por coma)", type: "tags" },
    { key: "accepting", label: "¿Toma pacientes nuevos?", type: "select", options: ["", "si", "lista-espera", "no"] },
    { key: "tags", label: "Tags (separadas por coma)", type: "tags" },
    { key: "active", label: "Visible", type: "bool" },
  ],
  faqs: [
    { key: "question", label: "Pregunta", type: "textarea", required: true },
    { key: "answer", label: "Respuesta", type: "textarea-lg", required: true },
    { key: "category", label: "Categoría", type: "text", required: true },
    { key: "active", label: "Visible", type: "bool" },
  ],
};

const CONTENT_DEFAULTS = {
  resources: { title: "", shortDescription: "", body: "", type: "guia", category: "", tags: [], pages: 0, readMin: 0, assetUrl: "", imageUrl: "", visibility: "public", featured: false, active: true, views: 0 },
  articles: { title: "", slug: "", summary: "", content: "", cover: "", category: "", readMin: 0, published: true },
  testimonials: { title: "", content: "", authorAlias: "", authorRole: "", authorCity: "", category: "", tags: [], active: true },
  professionals: { name: "", specialty: "", city: "", department: "", phone: "", address: "", notes: "", tags: [], active: true },
  faqs: { question: "", answer: "", category: "", active: true },
};

const CONTENT_LABELS = {
  resources: "recurso",
  articles: "artículo",
  testimonials: "testimonio",
  professionals: "centro de salud",
  faqs: "pregunta",
};

function AdminContent() {
  const { user } = useApp();
  const [tab, setTab] = useState("resources");
  const [counts, setCounts] = useState({});
  const [listByTab, setListByTab] = useState({});
  const [query, setQuery] = useState("");
  const [err, setErr] = useState(null);
  const [editing, setEditing] = useState(null); // { mode, entity, data }
  const [busy, setBusy] = useState(false);
  const [formErr, setFormErr] = useState(null);

  // Fetch de todas las entidades en paralelo al montar; se cachean en listByTab.
  useEffect(() => {
    const token = user?.token;
    if (!token) { setErr("no-token"); return; }
    let cancelled = false;
    const entities = ["resources", "articles", "professionals", "testimonials", "faqs"];
    Promise.all(entities.map((e) =>
      fetch(`/api/admin/${e}`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status} en ${e}`)))
        .then((data) => [e, Array.isArray(data) ? data : []])
    )).then((pairs) => {
      if (cancelled) return;
      const listMap = Object.fromEntries(pairs);
      setListByTab(listMap);
      setCounts(Object.fromEntries(pairs.map(([k, v]) => [k, v.length])));
    }).catch((e) => { if (!cancelled) setErr(e.message); });
    return () => { cancelled = true; };
  }, [user?.token]);

  const tabs = [
    { id: "resources", label: "Recursos", icon: "book" },
    { id: "articles", label: "Artículos", icon: "edit" },
    { id: "professionals", label: "Centros", icon: "users" },
    { id: "testimonials", label: "Testimonios", icon: "heart" },
    { id: "faqs", label: "Preguntas", icon: "chat" },
  ];

  const currentList = listByTab[tab] || [];
  const filtered = currentList.filter((item) => {
    if (!query) return true;
    const q = query.toLowerCase();
    return [item.title, item.name, item.question, item.content, item.shortDescription, item.summary, item.category, item.specialty, item.city]
      .filter(Boolean).some((s) => String(s).toLowerCase().includes(q));
  });

  const ready = !!listByTab[tab];
  const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString("es-UY", { day: "2-digit", month: "short", year: "numeric" }) : "—";

  const render = {
    resources: (r) => ({
      title: r.title,
      sub: r.shortDescription?.slice(0, 90) || "",
      cat: r.category,
      type: r.type,
      extra: `${r.views ?? 0} vistas`,
      status: r.active ? (r.visibility === "public" ? "Público" : "Registrado") : "Inactivo",
      statusTone: r.active ? (r.visibility === "public" ? "leaf" : "azul") : "coral",
      icon: "book",
    }),
    articles: (a) => ({
      title: a.title,
      sub: a.summary?.slice(0, 90) || "",
      cat: a.category,
      type: `${a.readMin || "?"} min lectura`,
      extra: `${a.views ?? 0} vistas`,
      status: a.published ? "Publicado" : "Borrador",
      statusTone: a.published ? "leaf" : "sunny",
      icon: "edit",
    }),
    professionals: (p) => ({
      title: p.name,
      sub: p.specialty,
      cat: p.city || p.department,
      type: (p.tags || []).slice(0, 2).join(", "),
      extra: p.phone === "—" ? "Teléfono por validar" : p.phone,
      status: p.active ? "Activo" : "Inactivo",
      statusTone: p.active ? "leaf" : "coral",
      icon: "users",
    }),
    testimonials: (t) => ({
      title: t.title,
      sub: t.content?.slice(0, 90) || "",
      cat: t.category,
      type: t.authorAlias || "Anónimo",
      extra: t.authorCity || "",
      status: t.active ? "Activo" : "Inactivo",
      statusTone: t.active ? "leaf" : "coral",
      icon: "heart",
    }),
    faqs: (f) => ({
      title: f.question,
      sub: f.answer?.slice(0, 90) || "",
      cat: f.category,
      type: "FAQ",
      extra: fmtDate(f.updatedAt || f.createdAt),
      status: f.active ? "Activo" : "Inactivo",
      statusTone: f.active ? "leaf" : "coral",
      icon: "chat",
    }),
  }[tab];

  const openCreate = () => {
    setFormErr(null);
    setEditing({ mode: "create", entity: tab, data: { ...CONTENT_DEFAULTS[tab] } });
  };
  const openEdit = (item) => {
    setFormErr(null);
    const base = { ...CONTENT_DEFAULTS[tab], ...item };
    setEditing({ mode: "edit", entity: tab, data: base });
  };
  const closeEditor = () => { if (!busy) { setEditing(null); setFormErr(null); } };

  // Normaliza data de formulario antes de enviar al backend: coerce numbers,
  // tags (string → array), strings vacíos a omitir en opcionales.
  const preparePayload = (entity, data) => {
    const schema = CONTENT_FORM_SCHEMA[entity];
    const out = {};
    for (const f of schema) {
      const v = data[f.key];
      if (f.type === "number") {
        const n = Number(v);
        if (Number.isFinite(n) && n > 0) out[f.key] = n;
      } else if (f.type === "tags") {
        if (Array.isArray(v)) out[f.key] = v;
        else if (typeof v === "string") out[f.key] = v.split(",").map((x) => x.trim()).filter(Boolean);
      } else if (f.type === "bool") {
        out[f.key] = !!v;
      } else if (f.type === "select") {
        if (v) out[f.key] = v;
      } else {
        if (typeof v === "string") {
          const trimmed = v.trim();
          if (trimmed) out[f.key] = trimmed;
          else if (f.required) out[f.key] = "";
        }
      }
    }
    return out;
  };

  const save = async () => {
    if (!editing) return;
    const token = user?.token;
    if (!token) { setFormErr("Sesión expirada"); return; }
    const payload = preparePayload(editing.entity, editing.data);
    const schema = CONTENT_FORM_SCHEMA[editing.entity];
    for (const f of schema) {
      if (f.required && !payload[f.key] && payload[f.key] !== false && payload[f.key] !== 0) {
        setFormErr(`Falta: ${f.label}`);
        return;
      }
    }
    setBusy(true);
    setFormErr(null);
    try {
      const url = editing.mode === "edit"
        ? `/api/admin/${editing.entity}/${editing.data.id}`
        : `/api/admin/${editing.entity}`;
      const method = editing.mode === "edit" ? "PUT" : "POST";
      const r = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      if (!r.ok) {
        const body = await r.json().catch(() => ({}));
        throw new Error(body.error || `HTTP ${r.status}`);
      }
      const saved = await r.json();
      setListByTab((prev) => {
        const list = prev[editing.entity] || [];
        const next = editing.mode === "edit"
          ? list.map((x) => x.id === saved.id ? saved : x)
          : [saved, ...list];
        return { ...prev, [editing.entity]: next };
      });
      setCounts((prev) => ({ ...prev, [editing.entity]: (prev[editing.entity] || 0) + (editing.mode === "edit" ? 0 : 1) }));
      setEditing(null);
    } catch (e) {
      setFormErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  const remove = async (item) => {
    if (!item?.id) return;
    const token = user?.token;
    if (!token) return;
    const label = CONTENT_LABELS[tab] || "registro";
    const name = item.title || item.name || item.question || "este registro";
    if (!window.confirm(`¿Eliminar ${label} "${String(name).slice(0, 80)}"? Esta acción no se puede deshacer.`)) return;
    try {
      const r = await fetch(`/api/admin/${tab}/${item.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!r.ok) {
        const body = await r.json().catch(() => ({}));
        throw new Error(body.error || `HTTP ${r.status}`);
      }
      setListByTab((prev) => ({ ...prev, [tab]: (prev[tab] || []).filter((x) => x.id !== item.id) }));
      setCounts((prev) => ({ ...prev, [tab]: Math.max(0, (prev[tab] || 1) - 1) }));
    } catch (e) {
      window.alert(`No se pudo eliminar: ${e.message}`);
    }
  };

  return (
    <div className="adminview">
      <header className="adminview__header">
        <div>
          <span className="eyebrow">Contenidos</span>
          <h1 className="display adminview__title">Lo que ven las familias.</h1>
          <p className="adminview__lede">Todo el contenido que se sirve desde la plataforma. Editá, creá o remové desde acá; los cambios impactan en vivo en el sitio público y en el chat.</p>
        </div>
      </header>

      <div className="admin-tabs">
        {tabs.map(t => (
          <button key={t.id} className={`admin-tab ${tab === t.id ? "is-on" : ""}`} onClick={() => setTab(t.id)}>
            <Icon name={t.icon} size={16} />
            <span>{t.label}</span>
            <span className="admin-tab__count">{counts[t.id] ?? "…"}</span>
          </button>
        ))}
      </div>

      <div className="admin-toolbar">
        <div className="lib-search">
          <Icon name="search" size={18} />
          <input placeholder="Buscar…" value={query} onChange={(e) => setQuery(e.target.value)} />
        </div>
        <Btn variant="primary" size="sm" icon={<Icon name="plus" size={14} />} onClick={openCreate}>
          Nuevo {CONTENT_LABELS[tab]}
        </Btn>
      </div>

      {err && !ready && <div className="admin-empty">No pudimos cargar {tab} ({err}).</div>}

      <div className="admin-table">
        <div className="admin-table__head">
          <span>Título</span>
          <span>Categoría</span>
          <span>Tipo / Detalle</span>
          <span>Estado</span>
          <span>Extra</span>
          <span></span>
        </div>
        {!ready && <div className="admin-empty">Cargando…</div>}
        {ready && filtered.length === 0 && (
          <div className="admin-empty">
            {currentList.length === 0 ? "Todavía no hay contenido en esta categoría." : "Ningún resultado coincide con la búsqueda."}
          </div>
        )}
        {ready && filtered.map((item) => {
          const v = render(item);
          return (
            <div key={item.id} className="admin-table__row">
              <div className="admin-table__title">
                <div className="admin-table__thumb"><Icon name={v.icon} size={14} /></div>
                <div>
                  <b>{v.title}</b>
                  <span>{v.sub}</span>
                </div>
              </div>
              <div><Badge tone="coral">{v.cat || "—"}</Badge></div>
              <div>{v.type || "—"}</div>
              <div><Badge tone={v.statusTone}>{v.status}</Badge></div>
              <div>{v.extra || "—"}</div>
              <div className="admin-table__actions">
                <button className="admin-action" onClick={() => openEdit(item)} title="Editar">
                  <Icon name="edit" size={12} /> <span className="admin-action__label">Editar</span>
                </button>
                <button className="admin-action admin-action--danger" onClick={() => remove(item)} title="Eliminar">
                  <Icon name="trash" size={12} /> <span className="admin-action__label">Eliminar</span>
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {editing && (
        <ContentEditor
          entity={editing.entity}
          mode={editing.mode}
          data={editing.data}
          busy={busy}
          error={formErr}
          onChange={(key, value) => setEditing((prev) => prev ? { ...prev, data: { ...prev.data, [key]: value } } : prev)}
          onSave={save}
          onClose={closeEditor}
        />
      )}
    </div>
  );
}

// Modal de editor para crear/editar contenido. Usa un overlay fixed full-screen
// y renderiza campos según CONTENT_FORM_SCHEMA. No depende de CSS nuevo —
// estilos inline para evitar tocar components.css.
function ContentEditor({ entity, mode, data, busy, error, onChange, onSave, onClose }) {
  const schema = CONTENT_FORM_SCHEMA[entity] || [];
  const label = CONTENT_LABELS[entity] || "registro";
  const titleText = mode === "edit" ? `Editar ${label}` : `Nuevo ${label}`;

  return (
    <div className="admin-modal" onClick={onClose}>
      <div className="admin-modal__dialog" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal__head">
          <h2 className="display admin-modal__title">{titleText}</h2>
          <button className="admin-modal__close" onClick={onClose} disabled={busy} aria-label="Cerrar">×</button>
        </div>

        <div className="admin-modal__body">
          {schema.map((f) => {
            const value = data[f.key];
            if (f.type === "bool") {
              return (
                <div key={f.key} className="field field--row">
                  <span className="field__label">{f.label}</span>
                  <Toggle on={!!value} onChange={(v) => onChange(f.key, v)} />
                </div>
              );
            }
            if (f.type === "select") {
              return (
                <div key={f.key} className="field">
                  <label className="field__label">{f.label}{f.required ? " *" : ""}</label>
                  <select className="field__select" value={value || ""} onChange={(e) => onChange(f.key, e.target.value)}>
                    {!f.required && <option value="">—</option>}
                    {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
                  </select>
                </div>
              );
            }
            if (f.type === "tags") {
              const display = Array.isArray(value) ? value.join(", ") : (value || "");
              return (
                <div key={f.key} className="field">
                  <label className="field__label">{f.label}</label>
                  <div className="field__control">
                    <input
                      value={display}
                      onChange={(e) => onChange(f.key, e.target.value.split(",").map((x) => x.trim()).filter(Boolean))}
                      placeholder="ej. rutinas, sueño, anticipación"
                    />
                  </div>
                </div>
              );
            }
            if (f.type === "textarea" || f.type === "textarea-lg") {
              const rows = f.type === "textarea-lg" ? 10 : 4;
              return (
                <div key={f.key} className="field">
                  <label className="field__label">{f.label}{f.required ? " *" : ""}</label>
                  <textarea
                    className="field__textarea"
                    rows={rows}
                    value={value || ""}
                    onChange={(e) => onChange(f.key, e.target.value)}
                  />
                  {f.hint && <span className="field__hint">{f.hint}</span>}
                </div>
              );
            }
            const inputType = f.type === "number" ? "number" : "text";
            return (
              <div key={f.key} className="field">
                <label className="field__label">{f.label}{f.required ? " *" : ""}</label>
                <div className="field__control">
                  <input
                    type={inputType}
                    value={value == null ? "" : value}
                    onChange={(e) => onChange(f.key, inputType === "number" ? (e.target.value === "" ? 0 : Number(e.target.value)) : e.target.value)}
                  />
                </div>
              </div>
            );
          })}
        </div>

        {error && <div className="field__err admin-modal__error">{error}</div>}

        <div className="admin-modal__footer">
          <Btn variant="ghost" size="sm" onClick={onClose} disabled={busy}>Cancelar</Btn>
          <Btn variant="primary" size="sm" onClick={onSave} disabled={busy}>
            {busy ? "Guardando…" : (mode === "edit" ? "Guardar cambios" : "Crear")}
          </Btn>
        </div>
      </div>
    </div>
  );
}

function AdminUsers() {
  const { user: me, showToast } = useApp();
  const [users, setUsers] = useState(null);
  const [err, setErr] = useState(null);
  const [query, setQuery] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [editing, setEditing] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [busy, setBusy] = useState(false);
  const [resetInfo, setResetInfo] = useState(null);

  const authHeaders = { Authorization: `Bearer ${me?.token}`, "Content-Type": "application/json" };

  const openUserEdit = (u) => {
    setEditing(u);
    setEditForm({ name: u.name || "", email: u.email || "", city: u.city || "", department: u.department || "", status: u.status || "active" });
  };

  const saveUserEdit = async () => {
    if (!editing) return;
    setBusy(true);
    try {
      const r = await fetch(`/api/admin/users/${editing.id}`, { method: "PUT", headers: authHeaders, body: JSON.stringify(editForm) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
      setUsers((prev) => prev.map((u) => (u.id === editing.id ? { ...u, ...editForm } : u)));
      showToast("Usuario actualizado 💙", "success");
      setEditing(null);
    } catch (e) {
      showToast(e.message, "error");
    } finally {
      setBusy(false);
    }
  };

  const deleteUser = async (u) => {
    const label = u.name || u.email;
    if (!window.confirm(`ELIMINAR a ${label}: se borran su cuenta, censo e historial de chat. Es DEFINITIVO.\n\nPara dar de baja sin borrar datos, usá Editar → Estado: Inactiva.\n\n¿Eliminar definitivamente?`)) return;
    const typed = window.prompt(`Escribí ELIMINAR para confirmar el borrado de ${label}:`);
    if (typed !== "ELIMINAR") return;
    setBusy(true);
    try {
      const r = await fetch(`/api/admin/users/${u.id}`, { method: "DELETE", headers: authHeaders });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
      setUsers((prev) => prev.filter((x) => x.id !== u.id));
      showToast("Cuenta eliminada definitivamente", "success");
    } catch (e) {
      showToast(e.message, "error");
    } finally {
      setBusy(false);
    }
  };

  const resetPassword = async (u) => {
    if (!window.confirm(`¿Generar contraseña temporal para ${u.name || u.email}? Se cierran sus sesiones activas.`)) return;
    setBusy(true);
    try {
      const r = await fetch(`/api/admin/users/${u.id}/reset-password`, { method: "POST", headers: authHeaders });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
      setResetInfo({ user: u, password: data.temporaryPassword });
    } catch (e) {
      showToast(e.message, "error");
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    const token = me?.token;
    if (!token) { setErr("no-token"); return; }
    let cancelled = false;
    fetch("/api/admin/users", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then((data) => { if (!cancelled) setUsers(Array.isArray(data) ? data : []); })
      .catch((e) => { if (!cancelled) setErr(e.message); });
    return () => { cancelled = true; };
  }, [me?.token]);

  const ready = users !== null;
  const filtered = (users || []).filter((u) => {
    if (roleFilter !== "all" && u.role !== roleFilter) return false;
    if (query) {
      const q = query.toLowerCase();
      return (u.name || "").toLowerCase().includes(q) ||
             (u.alias || "").toLowerCase().includes(q) ||
             (u.email || "").toLowerCase().includes(q) ||
             (u.city || "").toLowerCase().includes(q) ||
             (u.department || "").toLowerCase().includes(q);
    }
    return true;
  });

  const families = (users || []).filter((u) => u.role === "user" && u.status === "active").length;
  const fmtDate = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return d.toLocaleDateString("es-UY", { day: "2-digit", month: "short", year: "numeric" });
  };
  const roleTone = (r) => r === "admin" ? "coral" : r === "editor" ? "sunny" : "azul";

  const exportCsv = () => {
    if (!ready) return;
    const rows = [["Nombre", "Alias", "Email", "Rol", "Estado", "Ciudad", "Departamento", "Hijos/as", "Registrado", "Último acceso"]];
    for (const u of filtered) {
      rows.push([u.name || "", u.alias || "", u.email || "", u.role || "", u.status || "", u.city || "", u.department || "", String(u.childrenCount ?? 0), u.createdAt || "", u.lastLoginAt || ""]);
    }
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `azulito-usuarios-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="adminview">
      <header className="adminview__header">
        <div>
          <span className="eyebrow">Usuarios</span>
          <h1 className="display adminview__title">
            {ready
              ? `${families} ${families === 1 ? "familia" : "familias"} en la red.`
              : "Cargando familias…"}
          </h1>
        </div>
        <Btn variant="primary" size="md" icon={<Icon name="download" size={14} />} onClick={exportCsv} disabled={!ready}>
          Exportar CSV
        </Btn>
      </header>

      {ready && users.length > 0 && (
        <div className="lib-toolbar">
          <div className="lib-search">
            <Icon name="search" size={18} />
            <input placeholder="Buscar por nombre, email o ciudad…" value={query} onChange={(e) => setQuery(e.target.value)} />
          </div>
          <div className="lib-chips">
            {[
              { id: "all", label: "Todos" },
              { id: "user", label: "Familias" },
              { id: "admin", label: "Admin" },
              { id: "editor", label: "Editor" },
            ].map((r) => (
              <button key={r.id} className={`chip ${roleFilter === r.id ? "is-on" : ""}`} onClick={() => setRoleFilter(r.id)}>
                {r.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {err && !ready && <div className="admin-empty">No pudimos cargar los usuarios ({err}).</div>}

      <div className="admin-table">
        <div className="admin-table__head">
          <span>Usuario</span>
          <span>Rol</span>
          <span>Ciudad</span>
          <span>Hijos/as</span>
          <span>Alta</span>
          <span></span>
        </div>
        {!ready && <div className="admin-empty">Cargando…</div>}
        {ready && filtered.length === 0 && (
          <div className="admin-empty">
            {users.length === 0
              ? "Todavía no hay familias registradas. Cuando las mamás de Amor Azul se sumen, aparecen acá."
              : "Ningún usuario coincide con los filtros."}
          </div>
        )}
        {ready && filtered.map((u) => {
          const displayName = u.alias || u.name || u.email;
          return (
            <div key={u.id} className={`admin-table__row ${u.status !== "active" ? "is-inactive" : ""}`}>
              <div className="admin-table__title">
                <Avatar name={displayName} size={36} />
                <div>
                  <b>{displayName}</b>
                  <span>{u.email}</span>
                </div>
              </div>
              <div><Badge tone={roleTone(u.role)}>{u.role}</Badge></div>
              <div>{u.city || u.department || "—"}</div>
              <div>{u.childrenCount > 0 ? u.childrenCount : "—"}</div>
              <div>{fmtDate(u.createdAt)}</div>
              <div className="admin-table__actions">
                {u.status !== "active" && <Badge tone="coral">{u.status}</Badge>}
                <button className="admin-action" onClick={() => openUserEdit(u)} title="Editar datos">
                  <Icon name="edit" size={12} /> <span className="admin-action__label">Editar</span>
                </button>
                <button className="admin-action" onClick={() => resetPassword(u)} title="Generar contraseña temporal" disabled={busy}>
                  <Icon name="lock" size={12} /> <span className="admin-action__label">Reset</span>
                </button>
                {u.id !== me?.id && (
                  <button className="admin-action admin-action--danger" onClick={() => deleteUser(u)} title="Eliminar definitivamente" disabled={busy}>
                    <Icon name="trash" size={12} />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {editing && (
        <div className="admin-modal" onClick={() => !busy && setEditing(null)}>
          <div className="admin-modal__dialog" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal__head">
              <h2 className="display admin-modal__title">Editar usuario</h2>
              <button className="admin-modal__close" onClick={() => setEditing(null)} disabled={busy} aria-label="Cerrar">×</button>
            </div>
            <div className="admin-modal__body">
              {[["name", "Nombre"], ["email", "Email"], ["city", "Ciudad"], ["department", "Departamento"]].map(([k, label]) => (
                <div key={k} className="field">
                  <span className="field__label">{label}</span>
                  <input className="field__input" value={editForm[k] || ""} onChange={(e) => setEditForm((f) => ({ ...f, [k]: e.target.value }))} />
                </div>
              ))}
              <div className="field">
                <span className="field__label">Estado</span>
                <select className="field__input" value={editForm.status} onChange={(e) => setEditForm((f) => ({ ...f, status: e.target.value }))}>
                  <option value="active">Activa</option>
                  <option value="inactive">Inactiva</option>
                </select>
              </div>
            </div>
            <div className="admin-modal__foot">
              <Btn variant="ghost" size="md" onClick={() => setEditing(null)} disabled={busy}>Cancelar</Btn>
              <Btn variant="primary" size="md" onClick={saveUserEdit} disabled={busy}>{busy ? "Guardando…" : "Guardar"}</Btn>
            </div>
          </div>
        </div>
      )}

      {resetInfo && (
        <div className="admin-modal" onClick={() => setResetInfo(null)}>
          <div className="admin-modal__dialog" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal__head">
              <h2 className="display admin-modal__title">Contraseña temporal</h2>
              <button className="admin-modal__close" onClick={() => setResetInfo(null)} aria-label="Cerrar">×</button>
            </div>
            <div className="admin-modal__body">
              <p>Para <b>{resetInfo.user.name || resetInfo.user.email}</b>. Entregásela por un canal seguro (WhatsApp directo o en persona). Al entrar, la app le pide crear una nueva.</p>
              <p style={{ fontSize: 22, fontWeight: 800, textAlign: "center", padding: "12px 0", userSelect: "all" }}>{resetInfo.password}</p>
            </div>
            <div className="admin-modal__foot">
              <Btn variant="primary" size="md" onClick={() => { navigator.clipboard?.writeText(resetInfo.password); setResetInfo(null); }}>Copiar y cerrar</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function AdminMetrics() {
  const [rango, setRango] = useState(() => PRESETS[2].calcular()); // 30 días
  const { summary, cargando } = useAdminSummary(rango);
  const t = summary?.totals;
  const ready = !!summary;
  const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("es-UY"));
  return (
    <div className="adminview">
      <header className="adminview__header">
        <div>
          <span className="eyebrow">Métricas · Para Gobernación y Clubes</span>
          <h1 className="display adminview__title">La red en números.</h1>
          <p className="adminview__lede">Información agregada y anonimizada, sirve para orientar proyectos de servicio y demostrar impacto. Datos tomados en vivo de la base.</p>
        </div>
      </header>

      <FiltroFechas rango={rango} onCambio={setRango} cargando={cargando} />

      <div className={`metricas ${cargando ? "is-cargando" : ""}`}>
      <div className="kpi-row">
        <KPI label="Familias registradas" value={fmt(t?.registeredUsers)} delta={ready ? `${fmt(t.cities)} ciudad${t.cities === 1 ? "" : "es"}` : "cargando…"} tone="azul" icon="heart" />
        <KPI label="Niños/as declarados" value={fmt(t?.totalChildren)} delta="censo voluntario" tone="coral" icon="users" />
        <KPI label="Ciudades alcanzadas" value={fmt(t?.cities)} delta={ready && summary.geography.length ? summary.geography.slice(0, 2).map((g) => g.city).join(" + ") : ""} tone="sunny" icon="location" />
        <KPI label="Conversaciones chat" value={fmt(t?.conversations)} delta={ready ? `${fmt(t.messages)} consultas` : "cargando…"} tone="leaf" icon="chat" />
      </div>

      <div className="kpi-row">
        <KPI label="Visitas totales" value={ready ? fmt(summary.visits?.total) : "—"} delta={ready ? `${fmt(summary.visits?.today)} hoy` : "cargando…"} tone="azul" icon="search" />
        <KPI label="Familias activas (7 días)" value={ready ? fmt(summary.activeUsers7d) : "—"} delta="entraron esta semana" tone="azul" icon="users" />
        <KPI label="Registros hoy" value={ready ? fmt(summary.dailySignups?.[summary.dailySignups.length - 1]?.n) : "—"} delta="nuevas familias" tone="leaf" icon="heart" />
        <KPI label="Consultas hoy" value={ready ? fmt(summary.dailyMessages?.[summary.dailyMessages.length - 1]?.n) : "—"} delta="mensajes al chat" tone="sunny" icon="chat" />
        <KPI label="Alertas de crisis (7 días)" value={ready ? fmt(summary.escalations?.last7d) : "—"} delta={ready ? `${fmt(summary.escalations?.total)} en total` : "cargando…"} tone="coral" icon="bell" />
      </div>

      <div className="admin-grid">
        <section className="admin-card admin-card--wide">
          <div className="admin-card__head">
            <h3 className="display">Familias por ciudad</h3>
          </div>
          <div className="bar-list">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && summary.geography.length === 0 && <div className="admin-empty">Sin familias registradas todavía.</div>}
            {ready && summary.geography.length > 0 && (() => {
              const max = Math.max(1, ...summary.geography.map((g) => g.count));
              return summary.geography.map((c) => (
                <div key={c.city} className="bar-row">
                  <div className="bar-row__label">{c.city}</div>
                  <div className="bar-row__bar"><div style={{ width: `${(c.count / max) * 100}%` }} /></div>
                  <div className="bar-row__n">{c.count}</div>
                </div>
              ));
            })()}
          </div>
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Edad de los niños/as</h3>
          </div>
          <div className="age-bars">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && summary.childrenByAge.every((a) => a.n === 0) && <div className="admin-empty">Sin datos de edades todavía.</div>}
            {ready && summary.childrenByAge.some((a) => a.n > 0) && (() => {
              const max = Math.max(1, ...summary.childrenByAge.map((a) => a.n));
              return summary.childrenByAge.map((a) => (
                <div key={a.range} className="age-bar">
                  <div className="age-bar__bar" style={{ height: `${(a.n / max) * 100}%` }} />
                  <span className="age-bar__n">{a.n}</span>
                  <span className="age-bar__label">{a.range}</span>
                </div>
              ));
            })()}
          </div>
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Temas más consultados</h3>
          </div>
          <div className="topics">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && summary.topTopics.length === 0 && <div className="admin-empty">Sin consultas categorizables todavía.</div>}
            {ready && summary.topTopics.length > 0 && (() => {
              const max = Math.max(1, ...summary.topTopics.map((x) => x.n));
              return summary.topTopics.map((x) => (
                <div key={x.topic} className="topic">
                  <span>{x.topic}</span>
                  <div className="topic__bar"><div style={{ width: `${(x.n / max) * 100}%` }} /></div>
                  <b>{x.n}</b>
                </div>
              ));
            })()}
          </div>
        </section>

        <section className="admin-card admin-card--wide">
          <div className="admin-card__head">
            <h3 className="display">Conversaciones abiertas por día</h3>
          </div>
          {ready
            ? <>
                <GraficoTiempo datos={summary.conversacionesPorDia} etiqueta="conversaciones" color={0} />
                <TablaDatos datos={summary.conversacionesPorDia} etiqueta="Conversaciones" />
              </>
            : <div className="admin-empty">Cargando…</div>}
        </section>

        <section className="admin-card admin-card--wide">
          <div className="admin-card__head">
            <h3 className="display">Visitas al sitio por día</h3>
          </div>
          {ready
            ? <>
                <GraficoTiempo datos={summary.visits?.daily} etiqueta="visitas" color={0} />
                <TablaDatos datos={summary.visits?.daily} etiqueta="Visitas" />
              </>
            : <div className="admin-empty">Cargando…</div>}
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Cómo llegan a Azulito</h3>
          </div>
          <div className="topics">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && !summary.visits?.sources?.length && <div className="admin-empty">Sin datos de origen todavía.</div>}
            {ready && summary.visits?.sources?.length > 0 && (() => {
              const nombres = {
                "directo": "Directo (link, QR o marcador)",
                "google.com": "Búsqueda de Google",
                "l.facebook.com": "Facebook",
                "m.facebook.com": "Facebook",
                "facebook.com": "Facebook",
                "l.instagram.com": "Instagram",
                "instagram.com": "Instagram",
                "t.co": "X / Twitter",
              };
              const bonito = (s) => nombres[s] || (s.startsWith("utm:") ? `Campaña: ${s.slice(4)}` : s);
              const max = Math.max(1, ...summary.visits.sources.map((x) => x.n));
              return summary.visits.sources.map((x) => (
                <div key={x.label} className="topic">
                  <span>{bonito(x.label)}</span>
                  <div className="topic__bar"><div style={{ width: `${(x.n / max) * 100}%` }} /></div>
                  <b>{x.n}</b>
                </div>
              ));
            })()}
          </div>
          <p style={{ margin: "8px 0 0", fontSize: 12, opacity: 0.6 }}>
            WhatsApp y otras apps de mensajería no informan el origen: esas visitas cuentan como “Directo”.
          </p>
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Con qué dispositivo entran</h3>
          </div>
          <div className="topics">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && !summary.visits?.devices?.length && <div className="admin-empty">Sin datos todavía.</div>}
            {ready && summary.visits?.devices?.length > 0 && (() => {
              const max = Math.max(1, ...summary.visits.devices.map((x) => x.n));
              return summary.visits.devices.map((x) => (
                <div key={x.label} className="topic">
                  <span style={{ textTransform: "capitalize" }}>{x.label}</span>
                  <div className="topic__bar"><div style={{ width: `${(x.n / max) * 100}%` }} /></div>
                  <b>{x.n}</b>
                </div>
              ));
            })()}
          </div>
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Registros por día</h3>
          </div>
          {ready
            ? <>
                <GraficoTiempo datos={summary.dailySignups} etiqueta="registros" color={2} alto={160} />
                <TablaDatos datos={summary.dailySignups} etiqueta="Registros" />
              </>
            : <div className="admin-empty">Cargando…</div>}
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Consultas al chat por día</h3>
          </div>
          {ready
            ? <>
                <GraficoTiempo datos={summary.dailyMessages} etiqueta="consultas" color={1} alto={160} />
                <TablaDatos datos={summary.dailyMessages} etiqueta="Consultas" />
              </>
            : <div className="admin-empty">Cargando…</div>}
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Horario de las consultas</h3>
          </div>
          {ready && summary.messagesByHour?.some((n) => n > 0)
            ? (() => {
                const pico = summary.messagesByHour.indexOf(Math.max(...summary.messagesByHour));
                const porHora = summary.messagesByHour.map((n, h) => ({ label: `${h}h`, n }));
                return (
                  <>
                    <GraficoBarras datos={porHora} etiqueta="consultas" color={1} alto={160} />
                    <p className="admin-card__nota">Hora de Uruguay. Pico a las {pico}:00.</p>
                  </>
                );
              })()
            : <div className="admin-empty">{ready ? "Sin consultas en este período." : "Cargando…"}</div>}
        </section>

        <section className="admin-card">
          <div className="admin-card__head">
            <h3 className="display">Contenido más citado por Azulito</h3>
          </div>
          <div className="topics">
            {!ready && <div className="admin-empty">Cargando…</div>}
            {ready && (!summary.topSources || summary.topSources.length === 0) && <div className="admin-empty">Sin citas del bot todavía.</div>}
            {ready && summary.topSources?.length > 0 && (() => {
              const max = Math.max(1, ...summary.topSources.map((x) => x.n));
              return summary.topSources.map((x) => (
                <div key={x.label} className="topic">
                  <span>{x.label}</span>
                  <div className="topic__bar"><div style={{ width: `${(x.n / max) * 100}%` }} /></div>
                  <b>{x.n}</b>
                </div>
              ));
            })()}
          </div>
        </section>
      </div>
      </div>
    </div>
  );
}

function AdminAI() {
  const { user } = useApp();
  const [settings, setSettings] = useState(null);
  const [err, setErr] = useState(null);
  const [showFullPrompt, setShowFullPrompt] = useState(false);

  useEffect(() => {
    const token = user?.token;
    if (!token) { setErr("no-token"); return; }
    let cancelled = false;
    fetch("/api/admin/ai-settings", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then((data) => { if (!cancelled) setSettings(data); })
      .catch((e) => { if (!cancelled) setErr(e.message); });
    return () => { cancelled = true; };
  }, [user?.token]);

  const ready = !!settings;
  const prompt = settings?.systemPrompt || "";
  const fmtDate = (iso) => iso ? new Date(iso).toLocaleString("es-UY") : "—";

  return (
    <div className="adminview">
      <header className="adminview__header">
        <div>
          <span className="eyebrow">Configuración IA</span>
          <h1 className="display adminview__title">Cómo responde Azulito.</h1>
          <p className="adminview__lede">Valores reales del agente en vivo. Los cambios se hacen editando <code>src/content.js</code> + <code>node src/migrate-ai-settings.js</code> — ver <code>docs/CHAT.md</code>.</p>
        </div>
      </header>

      {err && !ready && <div className="admin-empty">No pudimos cargar la configuración ({err}).</div>}
      {!ready && !err && <div className="admin-empty">Cargando…</div>}

      {ready && (
        <div className="ai-cfg">
          <div className="admin-card">
            <div className="admin-card__head"><h3 className="display">System prompt</h3></div>
            <div className="ai-row" style={{ flexDirection: "column", alignItems: "stretch", gap: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                <div>
                  <b>Instrucciones del agente</b>
                  <span>{prompt.length.toLocaleString("es-UY")} caracteres · última actualización {fmtDate(settings.updatedAt)}</span>
                </div>
                <Btn variant="ghost" size="sm" onClick={() => setShowFullPrompt((v) => !v)} icon={<Icon name={showFullPrompt ? "eyeOff" : "eye"} size={14} />}>
                  {showFullPrompt ? "Ocultar" : "Ver completo"}
                </Btn>
              </div>
              <pre style={{ whiteSpace: "pre-wrap", fontSize: 13, lineHeight: 1.55, background: "var(--bg-elev-2)", padding: 14, borderRadius: "var(--r-md)", maxHeight: showFullPrompt ? "none" : 160, overflow: "auto", fontFamily: "var(--font-mono)" }}>
                {prompt || "(vacío)"}
              </pre>
            </div>
          </div>

          <div className="admin-card">
            <div className="admin-card__head"><h3 className="display">Parámetros del motor</h3></div>
            <div className="ai-row">
              <div><b>Temperature</b><span>Creatividad de las respuestas. Bajo = más conservador.</span></div>
              <code className="ai-key">{settings.temperature ?? "—"}</code>
            </div>
            <div className="ai-row">
              <div><b>Max length</b><span>Tope de tokens de salida por respuesta.</span></div>
              <code className="ai-key">{settings.maxLength ?? "—"}</code>
            </div>
            <div className="ai-row">
              <div><b>Tono</b><span>Estilo declarado.</span></div>
              <code className="ai-key">{settings.tone || "—"}</code>
            </div>
            <div className="ai-row">
              <div><b>Fuentes activas</b><span>Knowledge base usada para RAG.</span></div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {(settings.activeSources || []).map((s) => <Badge key={s} tone="azul">{s}</Badge>)}
              </div>
            </div>
          </div>

          <div className="admin-card">
            <div className="admin-card__head"><h3 className="display">Mensajes del agente</h3></div>
            <div className="ai-row" style={{ flexDirection: "column", alignItems: "stretch", gap: 6 }}>
              <b>Bienvenida</b>
              <p style={{ margin: 0, color: "var(--text-muted)", fontSize: 14 }}>{settings.welcomeMessage || "—"}</p>
            </div>
            <div className="ai-row" style={{ flexDirection: "column", alignItems: "stretch", gap: 6 }}>
              <b>Seguridad (crisis)</b>
              <p style={{ margin: 0, color: "var(--text-muted)", fontSize: 14 }}>{settings.safetyMessage || "—"}</p>
            </div>
            <div className="ai-row" style={{ flexDirection: "column", alignItems: "stretch", gap: 6 }}>
              <b>Derivación</b>
              <p style={{ margin: 0, color: "var(--text-muted)", fontSize: 14 }}>{settings.handoffMessage || "—"}</p>
            </div>
          </div>

          <div className="admin-card">
            <div className="admin-card__head"><h3 className="display">Guardrails aplicados</h3></div>
            <ul className="ai-checks">
              <li><Icon name="check" size={16} /> No diagnostica, solo orienta</li>
              <li><Icon name="check" size={16} /> No recomienda ni desaconseja medicación (deriva al equipo tratante)</li>
              <li><Icon name="check" size={16} /> Protocolo de crisis: 911 + línea 0800 0767 (prevención del suicidio)</li>
              <li><Icon name="check" size={16} /> RAG sobre contenido local curado del relevamiento</li>
              <li><Icon name="check" size={16} /> Fuentes reputadas citables: NICE, AAP, CDC, OMS, NAS UK, NIMH, MSP, BPS</li>
              <li><Icon name="check" size={16} /> No ofrece links/archivos inexistentes (anti-alucinación)</li>
              <li><Icon name="check" size={16} /> Lenguaje neurodiverso (sin "enfermedad", sin "sufrir autismo")</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

function AdminChatLog() {
  const { user } = useApp();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState(null);
  const [onlyFlagged, setOnlyFlagged] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const token = user?.token;
    if (!token) { setErr("no-token"); return; }
    let cancelled = false;
    const q = onlyFlagged ? "?flag=only&limit=200" : "?limit=200";
    fetch(`/api/admin/chat-log${q}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then((d) => { if (!cancelled) setItems(d.items || []); })
      .catch((e) => { if (!cancelled) setErr(e.message); });
    return () => { cancelled = true; };
  }, [user?.token, onlyFlagged]);

  const ready = items !== null;
  const filtered = (items || []).filter((it) => {
    if (!query) return true;
    return (it.question || "").toLowerCase().includes(query.toLowerCase())
        || (it.from || "").toLowerCase().includes(query.toLowerCase());
  });

  const relTime = (iso) => {
    if (!iso) return "";
    const diff = Date.now() - new Date(iso).getTime();
    if (diff < 60000) return "hace unos segundos";
    if (diff < 3600000) return `hace ${Math.round(diff / 60000)} min`;
    if (diff < 86400000) return `hace ${Math.round(diff / 3600000)} h`;
    return `hace ${Math.round(diff / 86400000)} d`;
  };

  const exportCsv = () => {
    if (!ready) return;
    const rows = [["Origen", "Pregunta", "Categoría", "Flag", "Fecha", "SessionID"]];
    for (const it of filtered) {
      rows.push([it.from, it.question, it.category, it.escalationFlag ? "sí" : "no", it.createdAt, it.sessionId]);
    }
    const csv = rows.map((r) => r.map((c) => `"${String(c || "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `azulito-conversaciones-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="adminview">
      <header className="adminview__header">
        <div>
          <span className="eyebrow">Monitor de conversaciones</span>
          <h1 className="display adminview__title">Qué consultan las familias.</h1>
          <p className="adminview__lede">
            {ready ? `${filtered.length} ${filtered.length === 1 ? "consulta" : "consultas"} reales` : "Cargando…"} · anonimizadas por defecto. Las marcadas con 🔶 tienen palabras de crisis (autolesión, violencia, emergencia) — requieren seguimiento del equipo.
          </p>
        </div>
        <div className="adminview__head-actions">
          <Btn variant="ghost" size="sm" icon={<Icon name="download" size={14} />} onClick={exportCsv} disabled={!ready}>Exportar CSV</Btn>
        </div>
      </header>

      <div className="admin-toolbar">
        <div className="lib-search">
          <Icon name="search" size={18} />
          <input placeholder="Buscar en consultas…" value={query} onChange={(e) => setQuery(e.target.value)} />
        </div>
        <div className="lib-chips">
          <button className={`chip ${!onlyFlagged ? "is-on" : ""}`} onClick={() => setOnlyFlagged(false)}>Todas</button>
          <button className={`chip ${onlyFlagged ? "is-on" : ""}`} onClick={() => setOnlyFlagged(true)}>Requieren seguimiento</button>
        </div>
      </div>

      {err && !ready && <div className="admin-empty">No pudimos cargar el log ({err}).</div>}

      <div className="chat-log">
        {!ready && <div className="admin-empty">Cargando…</div>}
        {ready && filtered.length === 0 && (
          <div className="admin-empty">
            {(items.length === 0) ? "Todavía no hay consultas al chat. Cuando las mamás escriban, aparecen acá." : "Ningún resultado coincide con la búsqueda."}
          </div>
        )}
        {ready && filtered.map((c) => (
          <article key={c.id} className={`chat-log-row ${c.escalationFlag ? "is-flag" : ""}`}>
            <div className="chat-log-row__top">
              <div className="chat-log-row__from">{c.from}</div>
              <div className="chat-log-row__t">{relTime(c.createdAt)}</div>
              {c.escalationFlag && <span className="chat-log-row__flag">🔶 Requiere seguimiento</span>}
            </div>
            <p className="chat-log-row__q">"{c.question}"</p>
            <div className="chat-log-row__actions">
              <span style={{ fontSize: 12, color: "var(--text-subtle)" }}>session: <code>{String(c.sessionId).slice(0, 12)}…</code> · categoría: {c.category || "—"}</span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

function Toggle({ on, onChange }) {
  return (
    <button className={`toggle ${on ? "is-on" : ""}`} onClick={() => onChange(!on)} aria-pressed={on}>
      <span />
    </button>
  );
}

Object.assign(window, { AdminHome, AdminContent, AdminUsers, AdminMetrics, AdminAI, AdminChatLog, Toggle });


/* ===== extras.jsx ===== */

/* Azulito — Forgot / Reset password + Onboarding + Detail views */

function ForgotPassword() {
  const { setRoute } = useApp();

  return (
    <AuthLayout
      title="¿Olvidaste tu contraseña?"
      subtitle="Te ayudamos a recuperar el acceso, de persona a persona."
      foot={
        <div className="auth__swap">
          ¿Te acordaste? <button onClick={() => setRoute(ROUTES.LOGIN)}>Volver al login</button>
        </div>
      }
    >
      <div className="auth__confirm">
        <Drop size={80} />
        <h3 className="display">Escribinos y la reseteamos</h3>
        <p>
          Todavía no mandamos enlaces por correo. Escribinos a{" "}
          <b>plataformaazulito@gmail.com</b> desde el correo con el que te registraste, o
          contactá al equipo de Azulito por el canal que uses (Amor Azul o los
          Clubes de Leones). Te generamos una contraseña temporal y al entrar
          la app te pide crear la tuya.
        </p>
        <Btn variant="primary" size="md" onClick={() => setRoute(ROUTES.LOGIN)}>Volver a entrar</Btn>
      </div>
    </AuthLayout>
  );
}

function Onboarding() {
  const { setRoute, showToast } = useApp();
  const [step, setStep] = useState(0);
  const steps = [
    {
      title: "Hola, bienvenida a la red.",
      sub: "Azulito es una guía digital para acompañar a tu familia día a día. Te muestro lo importante en 3 pasos.",
      emoji: "👋",
    },
    {
      title: "Hablá con Azulito cuando necesites.",
      sub: "El chat está disponible las 24 horas. No reemplaza al profesional, pero te da pasos claros y recursos concretos cuando aparece el 'no sé qué hacer'.",
      emoji: "💬",
    },
    {
      title: "Tenés una biblioteca de recursos.",
      sub: "Tableros visuales, guías descargables y plantillas para usar en casa y en la escuela. Validadas por profesionales.",
      emoji: "📚",
    },
    {
      title: "Y una red de profesionales cerca.",
      sub: "Especialistas de Treinta y Tres y la región, con contacto directo. Azulito te sugiere quién puede ayudar cuando corresponde.",
      emoji: "🤝",
    },
  ];
  const s = steps[step];
  const last = step === steps.length - 1;

  const next = () => {
    if (last) {
      localStorage.setItem("azulito:onboarded", "1");
      setRoute(ROUTES.APP_HOME);
      showToast("¡Listo! A explorar 💙", "success");
    } else {
      setStep(step + 1);
    }
  };
  const skip = () => {
    localStorage.setItem("azulito:onboarded", "1");
    setRoute(ROUTES.APP_HOME);
  };

  return (
    <div className="onb">
      <div className="onb__bg" aria-hidden>
        <div className="onb__blob onb__blob--a" />
        <div className="onb__blob onb__blob--b" />
      </div>
      <button className="onb__skip" onClick={skip}>Saltar</button>
      <div className="onb__stage">
        <div className="onb__mascot"><Drop size={220} /></div>
        <div className="onb__emoji">{s.emoji}</div>
        <h1 className="display onb__title">{s.title}</h1>
        <p className="onb__sub">{s.sub}</p>
        <div className="onb__dots">
          {steps.map((_, i) => <span key={i} className={i === step ? "is-on" : ""} />)}
        </div>
        <div className="onb__actions">
          {step > 0 && <Btn variant="ghost" size="lg" onClick={() => setStep(step - 1)}>Atrás</Btn>}
          <Btn variant="primary" size="lg" onClick={next} icon={last ? null : <Icon name="arrow" size={16} />}>
            {last ? "Empezar a explorar" : "Siguiente"}
          </Btn>
        </div>
      </div>
    </div>
  );
}

// ----- Detail: Resource -----
function ResourceDetail({ id, onBack }) {
  const { setRoute, showToast } = useApp();
  const content = useContent();
  const r = content.resources.find(x => x.id === id) || content.resources[0];
  const hasAsset = r.assetUrl && r.assetUrl !== "#";
  const tryDownload = () => {
    if (hasAsset) window.open(r.assetUrl, "_blank", "noopener");
    else showToast("Este recurso estará disponible para descarga próximamente.", "info");
  };
  const tryPreview = () => showToast("Previsualización en preparación.", "info");
  const openRelated = (x) => setRoute(ROUTES.RESOURCE_DETAIL, { id: x.id });
  return (
    <div className="detail">
      <button className="detail__back" onClick={onBack}>
        <Icon name="arrowLeft" size={16} /> Volver a la biblioteca
      </button>
      <div className="detail__grid">
        <div className="detail__cover">
          <div className="detail__cover-grid">
            {[...Array(9)].map((_, i) => <span key={i} style={{ opacity: 0.2 + (i % 3) * 0.25 }} />)}
          </div>
          <Badge tone="coral">{r.cat}</Badge>
        </div>
        <div className="detail__body">
          <span className="eyebrow">{r.type}{r.pages && ` · ${r.pages} páginas`}</span>
          <h1 className="display detail__title">{r.title}</h1>
          <p className="detail__lede">{r.shortDescription || "Contenido construido con el aporte de familias TEA de Treinta y Tres y la región."}</p>

          <div className="detail__stats">
            <div><b>{r.downloads}</b><span>vistas</span></div>
            <div><b>{r.pages || "—"}</b><span>páginas</span></div>
            <div><b>{r.cat}</b><span>categoría</span></div>
          </div>

          {r.tags && r.tags.length > 0 && (
            <>
              <h3 className="display detail__section-title">Temas que cubre</h3>
              <div className="pro-card__tags" style={{ margin: "4px 0 16px" }}>
                {r.tags.map(t => <Badge key={t} tone="azul">{t}</Badge>)}
              </div>
            </>
          )}

          <div className="detail__cta">
            <Btn variant="primary" size="lg" icon={<Icon name="download" size={16} />} onClick={tryDownload}>
              {hasAsset ? "Descargar PDF" : "Descarga próximamente"}
            </Btn>
            <Btn variant="ghost" size="lg" icon={<Icon name="eye" size={16} />} onClick={tryPreview}>Previsualizar</Btn>
          </div>
          {!hasAsset && (
            <p style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 8 }}>
              Este material está en producción con el equipo de contenidos de Azulito. Si querés colaborar, escribinos.
            </p>
          )}
        </div>
      </div>

      <div className="detail__related">
        <h3 className="display">Relacionados</h3>
        <div className="home-res">
          {content.resources.filter(x => x.id !== r.id).slice(0, 3).map(x => (
            <div key={x.id} className="res-row" style={{ cursor: "pointer" }} onClick={() => openRelated(x)}>
              <div className="res-row__icon"><Icon name="book" /></div>
              <div className="res-row__body">
                <div className="res-row__title">{x.title}</div>
                <div className="res-row__meta"><Badge tone="coral">{x.cat}</Badge><span>{x.type}</span></div>
              </div>
              <button className="res-row__action" onClick={(e) => { e.stopPropagation(); openRelated(x); }} aria-label="Abrir recurso"><Icon name="arrow" size={16} /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ----- Detail: Professional -----
function ProfessionalDetail({ id, onBack }) {
  const { showToast } = useApp();
  const content = useContent();
  const p = content.professionals.find(x => x.id === id) || content.professionals[0];
  const hasRealPhone = p.phone && p.phone !== "—" && /\d/.test(p.phone);
  const hasRealAddress = p.address && p.address !== "—";
  const needsInfo = !hasRealPhone && !hasRealAddress;
  const callPhone = () => {
    if (hasRealPhone) window.location.href = `tel:${p.phone.replace(/\s+/g, "")}`;
    else showToast("Estamos cargando el teléfono de contacto.", "info");
  };
  return (
    <div className="detail">
      <button className="detail__back" onClick={onBack}>
        <Icon name="arrowLeft" size={16} /> Volver a centros
      </button>
      <div className="pro-detail">
        <Avatar name={p.name} size={120} />
        <h1 className="display pro-detail__name">{p.name}</h1>
        <div className="pro-detail__role">{p.role}</div>
        <div className="pro-detail__city"><Icon name="location" size={14} />{p.city}</div>
        <div className="pro-card__tags" style={{ justifyContent: "center", margin: "12px 0 24px" }}>
          {p.tags && p.tags.map(t => <Badge key={t} tone="azul">{t}</Badge>)}
        </div>

        {p.notes && (
          <div className="pro-detail__notes">
            <p>{p.notes}</p>
          </div>
        )}

        <div className="detail__cta">
          {hasRealPhone && (
            <Btn variant="primary" size="lg" icon={<Icon name="phone" size={16} />} onClick={callPhone}>
              {p.phone}
            </Btn>
          )}
          {hasRealAddress && (
            <div className="pro-detail__address">
              <Icon name="location" size={16} /> {p.address}
            </div>
          )}
        </div>

        {needsInfo && (
          <p className="pro-detail__placeholder">
            Estamos cargando teléfono y dirección. Mientras tanto, el chat de Azulito te puede orientar sobre qué llevar y qué preguntar cuando los contactes.
          </p>
        )}
      </div>
    </div>
  );
}

// ----- Command palette / search -----
function CommandPalette({ open, onClose }) {
  const { setRoute } = useApp();
  const content = useContent();
  const [q, setQ] = useState("");
  const inputRef = useRef();

  useEffect(() => {
    if (open && inputRef.current) setTimeout(() => inputRef.current.focus(), 50);
    if (!open) setQ("");
  }, [open]);

  const results = useMemo(() => {
    const nav = [
      { type: "Navegar", label: "Inicio", action: () => setRoute(ROUTES.APP_HOME), icon: "home" },
      { type: "Navegar", label: "Biblioteca", action: () => setRoute(ROUTES.APP_LIBRARY), icon: "book" },
      { type: "Navegar", label: "Chat con Azulito", action: () => setRoute(ROUTES.APP_CHAT), icon: "chat" },
      { type: "Navegar", label: "Centros de salud", action: () => setRoute(ROUTES.APP_PROFESSIONALS), icon: "users" },
      { type: "Navegar", label: "Mi familia", action: () => setRoute(ROUTES.APP_PROFILE), icon: "heart" },
    ];
    const res = content.resources.map(r => ({ type: "Recurso", label: r.title, sub: r.cat, action: () => setRoute(ROUTES.APP_LIBRARY), icon: "book" }));
    const pros = content.professionals.map(p => ({ type: "Centro", label: p.name, sub: `${p.role} · ${p.city}`, action: () => setRoute(ROUTES.APP_PROFESSIONALS), icon: "users" }));
    const all = [...nav, ...res, ...pros];
    if (!q) return all.slice(0, 8);
    return all.filter(x => x.label.toLowerCase().includes(q.toLowerCase()) || (x.sub || "").toLowerCase().includes(q.toLowerCase())).slice(0, 12);
  }, [q, content]);

  if (!open) return null;
  return (
    <div className="cmdk" onClick={onClose}>
      <div className="cmdk__panel" onClick={e => e.stopPropagation()}>
        <div className="cmdk__search">
          <Icon name="search" size={18} />
          <input
            ref={inputRef}
            placeholder="Buscar recursos, centros, ir a…"
            value={q}
            onChange={e => setQ(e.target.value)}
          />
          <kbd>Esc</kbd>
        </div>
        <div className="cmdk__results">
          {results.length === 0 && (
            <div className="cmdk__empty">Sin resultados para "{q}"</div>
          )}
          {results.map((r, i) => (
            <button key={i} className="cmdk__item" onClick={() => { r.action(); onClose(); }}>
              <Icon name={r.icon} size={16} />
              <div>
                <div className="cmdk__item-label">{r.label}</div>
                {r.sub && <div className="cmdk__item-sub">{r.sub}</div>}
              </div>
              <span className="cmdk__item-type">{r.type}</span>
            </button>
          ))}
        </div>
        <div className="cmdk__foot">
          <span><kbd>↑</kbd><kbd>↓</kbd> navegar</span>
          <span><kbd>↵</kbd> abrir</span>
          <span><kbd>⌘</kbd><kbd>K</kbd> abrir desde cualquier lado</span>
        </div>
      </div>
    </div>
  );
}

// ----- Notification center -----
function NotifyCenter({ open, onClose }) {
  if (!open) return null;
  const items = [
    { t: "Nueva guía disponible", d: "Estrategias para el sueño · 10 páginas", time: "hace 2 h", icon: "book", tone: "azul" },
    { t: "Lic. Méndez te respondió", d: "Puede atenderte el viernes a las 15:00", time: "hace 1 d", icon: "users", tone: "coral" },
    { t: "Tu plan semanal se actualizó", d: "Tenés 2 rutas nuevas para esta semana", time: "hace 2 d", icon: "sparkles", tone: "sunny" },
  ];
  return (
    <>
      <div className="notif__backdrop" onClick={onClose} />
      <aside className="notif">
        <header className="notif__head">
          <h3 className="display">Novedades</h3>
          <button onClick={onClose}><Icon name="x" size={18} /></button>
        </header>
        <div className="notif__list">
          {items.map((n, i) => (
            <div key={i} className={`notif-item notif-item--${n.tone}`}>
              <div className="notif-item__icon"><Icon name={n.icon} size={16} /></div>
              <div className="notif-item__body">
                <b>{n.t}</b>
                <span>{n.d}</span>
                <small>{n.time}</small>
              </div>
            </div>
          ))}
        </div>
        <footer className="notif__foot">
          <button>Marcar todas como leídas</button>
        </footer>
      </aside>
    </>
  );
}

// ----- PWA install prompt -----
// Usa el evento beforeinstallprompt real (Chrome/Edge/Android). En iOS Safari
// ese evento no existe; ahí mostramos instrucciones manuales.
function InstallPrompt({ onClose }) {
  const { showToast } = useApp();
  const [deferred, setDeferred] = useState(() => window.__azulitoInstallPrompt || null);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    const onAvail = (e) => { setDeferred(e.detail || window.__azulitoInstallPrompt); };
    window.addEventListener("azulito:install-ready", onAvail);
    // Chequeo inicial por si ya llegó antes de montar
    if (window.__azulitoInstallPrompt) setDeferred(window.__azulitoInstallPrompt);
    return () => window.removeEventListener("azulito:install-ready", onAvail);
  }, []);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isStandalone =
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  if (isStandalone) return null; // ya está instalada, no mostrar

  const install = async () => {
    if (deferred) {
      try {
        await deferred.prompt();
        const { outcome } = await deferred.userChoice;
        if (outcome === "accepted") {
          showToast("¡Gracias! Azulito ya está en tu pantalla de inicio 💙", "success");
          localStorage.setItem("azulito:installed", "1");
          onClose?.();
        }
        window.__azulitoInstallPrompt = null;
        setDeferred(null);
      } catch (e) { console.warn("[install]", e); }
    } else if (isIOS) {
      setShowIOS(true);
    } else {
      showToast("Tu navegador no soporta instalación automática. Podés seguir usando Azulito desde el sitio.", "info");
    }
  };

  return (
    <>
      <div className="install">
        <Drop size={48} />
        <div className="install__body">
          <b>Instalá Azulito en tu celular</b>
          <span>Abrilo como app. Funciona sin internet con lo que ya visitaste.</span>
        </div>
        <Btn variant="primary" size="sm" onClick={install}>
          {isIOS ? "Cómo instalar" : "Instalar"}
        </Btn>
        <button className="install__close" onClick={onClose} aria-label="Cerrar">
          <Icon name="x" size={16} />
        </button>
      </div>

      {showIOS && (
        <div className="cmdk" onClick={() => setShowIOS(false)}>
          <div className="cmdk__panel" onClick={(e) => e.stopPropagation()} style={{ padding: 24, maxWidth: 440 }}>
            <h3 className="display" style={{ fontSize: 20, margin: "0 0 12px" }}>Instalar en iPhone / iPad</h3>
            <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.7 }}>
              <li>Tocá el botón de <b>Compartir</b> <span aria-label="icono compartir">(rectángulo con flecha arriba)</span> en la barra de Safari.</li>
              <li>Deslizá hacia abajo hasta <b>"Añadir a pantalla de inicio"</b>.</li>
              <li>Tocá <b>Añadir</b>. Azulito aparece como app en tu celular.</li>
            </ol>
            <p style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 16 }}>
              Esto sólo hace falta hacerlo una vez. Después entrás directo tocando el ícono, sin abrir el browser.
            </p>
            <div style={{ marginTop: 16, textAlign: "right" }}>
              <Btn variant="primary" size="sm" onClick={() => { setShowIOS(false); onClose?.(); }}>Entendido</Btn>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ----- Tweaks panel -----
function TweaksPanel({ cfg, setCfg }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onMsg = (e) => {
      if (e.data?.type === "__activate_edit_mode") setOpen(true);
      if (e.data?.type === "__deactivate_edit_mode") setOpen(false);
    };
    window.addEventListener("message", onMsg);
    window.parent.postMessage({ type: "__edit_mode_available" }, "*");
    return () => window.removeEventListener("message", onMsg);
  }, []);

  const update = (k, v) => {
    const next = { ...cfg, [k]: v };
    setCfg(next);
    window.parent.postMessage({ type: "__edit_mode_set_keys", edits: { [k]: v } }, "*");
  };

  if (!open) return null;
  return (
    <div className="tweaks">
      <header className="tweaks__head">
        <b>Tweaks</b>
        <button onClick={() => setOpen(false)}><Icon name="x" size={16} /></button>
      </header>
      <div className="tweaks__body">
        <label className="tweaks__row">
          <span>Densidad</span>
          <select value={cfg.density} onChange={e => update("density", e.target.value)}>
            <option value="cozy">Cómoda</option>
            <option value="compact">Compacta</option>
          </select>
        </label>
        <label className="tweaks__row">
          <span>Color de acento</span>
          <div className="tweaks__colors">
            {["#F4A26A", "#F7D46A", "#7BBF8A", "#E67D7D", "#B59CE8"].map(c => (
              <button key={c} className={cfg.accent === c ? "is-on" : ""} style={{ background: c }} onClick={() => { update("accent", c); document.documentElement.style.setProperty("--coral", c); }} />
            ))}
          </div>
        </label>
        <label className="tweaks__row">
          <span>Animaciones</span>
          <Toggle on={cfg.motion} onChange={v => { update("motion", v); document.documentElement.style.setProperty("--dur", v ? "240ms" : "0ms"); }} />
        </label>
        <label className="tweaks__row">
          <span>Tamaño de texto</span>
          <select value={cfg.fontSize} onChange={e => { update("fontSize", e.target.value); document.body.style.fontSize = e.target.value === "lg" ? "18px" : e.target.value === "xl" ? "20px" : "17px"; }}>
            <option value="md">Normal</option>
            <option value="lg">Grande</option>
            <option value="xl">Muy grande</option>
          </select>
        </label>
      </div>
    </div>
  );
}

Object.assign(window, { ForgotPassword, Onboarding, ResourceDetail, ProfessionalDetail, CommandPalette, NotifyCenter, InstallPrompt, TweaksPanel });


/* ===== reader.jsx ===== */

/* Azulito — In-app reader (Kindle-style) */

// --- Minimal markdown parser --------------------------------------------
// Soporta: ##, ### (h2/h3), listas con "- " y "1. ", blockquotes con "> ",
// separadores "---", y énfasis inline **bold**, *italic*, _italic_.
function parseMarkdown(text) {
  if (!text) return [];
  const lines = String(text).split("\n");
  const blocks = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (line.trim() === "") { i++; continue; }
    if (line.startsWith("## ")) {
      blocks.push({ type: "h2", text: line.slice(3).trim() });
      i++; continue;
    }
    if (line.startsWith("### ")) {
      blocks.push({ type: "h3", text: line.slice(4).trim() });
      i++; continue;
    }
    if (line.trim() === "---") {
      blocks.push({ type: "hr" });
      i++; continue;
    }
    if (line.startsWith("> ")) {
      const parts = [];
      while (i < lines.length && lines[i].startsWith("> ")) {
        parts.push(lines[i].slice(2));
        i++;
      }
      blocks.push({ type: "quote", text: parts.join(" ") });
      continue;
    }
    if (line.startsWith("- ")) {
      const items = [];
      while (i < lines.length && lines[i].startsWith("- ")) {
        items.push(lines[i].slice(2));
        i++;
      }
      blocks.push({ type: "ul", items });
      continue;
    }
    if (/^\d+\.\s/.test(line)) {
      const items = [];
      while (i < lines.length && /^\d+\.\s/.test(lines[i])) {
        items.push(lines[i].replace(/^\d+\.\s/, ""));
        i++;
      }
      blocks.push({ type: "ol", items });
      continue;
    }
    const parts = [];
    while (
      i < lines.length &&
      lines[i].trim() !== "" &&
      !lines[i].startsWith("## ") &&
      !lines[i].startsWith("### ") &&
      !lines[i].startsWith("> ") &&
      !lines[i].startsWith("- ") &&
      !/^\d+\.\s/.test(lines[i]) &&
      lines[i].trim() !== "---"
    ) {
      parts.push(lines[i]);
      i++;
    }
    blocks.push({ type: "p", text: parts.join(" ") });
  }
  return blocks;
}

function renderInline(text) {
  if (!text) return null;
  const nodes = [];
  const re = /(\*\*[^*\n]+\*\*|\*[^*\n]+\*|_[^_\n]+_)/g;
  let last = 0;
  let m;
  let key = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    const chunk = m[0];
    if (chunk.startsWith("**")) {
      nodes.push(<strong key={key++}>{chunk.slice(2, -2)}</strong>);
    } else {
      nodes.push(<em key={key++}>{chunk.slice(1, -1)}</em>);
    }
    last = re.lastIndex;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

function MarkdownBlock({ block }) {
  if (block.type === "h2") return <h2 className="reader__h2">{renderInline(block.text)}</h2>;
  if (block.type === "h3") return <h3 className="reader__h3">{renderInline(block.text)}</h3>;
  if (block.type === "hr") return <hr className="reader__hr" />;
  if (block.type === "quote") return <blockquote className="reader__quote">{renderInline(block.text)}</blockquote>;
  if (block.type === "ul") return <ul className="reader__ul">{block.items.map((it, i) => <li key={i}>{renderInline(it)}</li>)}</ul>;
  if (block.type === "ol") return <ol className="reader__ol">{block.items.map((it, i) => <li key={i}>{renderInline(it)}</li>)}</ol>;
  return <p className="reader__p">{renderInline(block.text)}</p>;
}

// --- Reader progress helpers --------------------------------------------
function readerProgressKey(id) { return `azulito:reading:${id}`; }

function saveProgress(id, data) {
  try { localStorage.setItem(readerProgressKey(id), JSON.stringify(data)); } catch {}
}

function loadProgress(id) {
  try {
    const raw = localStorage.getItem(readerProgressKey(id));
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

// Busca la última lectura incompleta entre todos los recursos conocidos.
function getLastReading(resources) {
  const all = [];
  for (const r of resources) {
    const p = loadProgress(r.id);
    if (p && p.pct > 1 && p.pct < 97) all.push({ ...p, resource: r });
  }
  all.sort((a, b) => (b.ts || 0) - (a.ts || 0));
  return all[0] || null;
}

// --- Reader component ---------------------------------------------------
function ResourceReader({ id, onBack, collection = "resources" }) {
  const { setRoute, showToast } = useApp();
  const content = useContent();
  const list = content[collection] || [];
  const r = list.find(x => x.id === id) || list[0] || {};

  const [fontSize, setFontSize] = useState(() => localStorage.getItem("azulito:reader:fontSize") || "md");
  const [readerTheme, setReaderTheme] = useState(() => localStorage.getItem("azulito:reader:theme") || "light");
  const [pct, setPct] = useState(() => (loadProgress(r.id)?.pct || 0));
  const scrollRef = useRef(null);
  const restoredRef = useRef(false);

  useEffect(() => { localStorage.setItem("azulito:reader:fontSize", fontSize); }, [fontSize]);
  useEffect(() => { localStorage.setItem("azulito:reader:theme", readerTheme); }, [readerTheme]);

  // Scroll listener (usa window: el contenedor scrolleable en este layout
  // es la ventana, no el div interno).
  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const maxScroll = doc.scrollHeight - window.innerHeight;
      if (maxScroll <= 0) { setPct(100); return; }
      const p = Math.max(0, Math.min(100, Math.round((window.scrollY / maxScroll) * 100)));
      setPct(p);
      saveProgress(r.id, { pct: p, ts: Date.now(), title: r.title });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [r.id, r.title]);

  // Restaurar posición al montar
  useEffect(() => {
    if (restoredRef.current) return;
    const prior = loadProgress(r.id);
    if (prior && prior.pct > 0 && prior.pct < 100) {
      const tryRestore = () => {
        const doc = document.documentElement;
        const maxScroll = doc.scrollHeight - window.innerHeight;
        if (maxScroll > 0) {
          window.scrollTo({ top: (prior.pct / 100) * maxScroll, behavior: "instant" });
          restoredRef.current = true;
        } else {
          requestAnimationFrame(tryRestore);
        }
      };
      requestAnimationFrame(tryRestore);
    } else {
      restoredRef.current = true;
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [r.id]);

  const blocks = useMemo(() => parseMarkdown(r.body || ""), [r.body]);
  const hasAsset = r.assetUrl && r.assetUrl !== "#";

  const handlePrint = () => {
    document.body.classList.add("is-printing-reader");
    setTimeout(() => {
      window.print();
      setTimeout(() => document.body.classList.remove("is-printing-reader"), 300);
    }, 80);
  };

  const openRelated = (x) => {
    setRoute(ROUTES.RESOURCE_DETAIL, { id: x.id });
  };

  const fontSizes = [
    { id: "sm", label: "A-" },
    { id: "md", label: "A" },
    { id: "lg", label: "A+" },
  ];
  const themes = [
    { id: "light", label: "Claro" },
    { id: "sepia", label: "Sepia" },
    { id: "dark", label: "Oscuro" },
  ];

  return (
    <div className={`reader reader--${fontSize} reader--theme-${readerTheme}`}>
      <header className="reader__chrome">
        <button className="reader__back" onClick={onBack} aria-label="Volver">
          <Icon name="arrowLeft" size={18} /> <span>Biblioteca</span>
        </button>
        <div className="reader__progress" aria-label={`Progreso de lectura: ${pct}%`}>
          <div className="reader__progress-fill" style={{ width: `${pct}%` }} />
          <span className="reader__progress-text">{pct}%</span>
        </div>
        <div className="reader__controls">
          <div className="reader__group" role="group" aria-label="Tamaño de texto">
            {fontSizes.map(f => (
              <button
                key={f.id}
                className={`reader__ctrl ${fontSize === f.id ? "is-on" : ""}`}
                onClick={() => setFontSize(f.id)}
                aria-pressed={fontSize === f.id}
                title={`Texto ${f.label}`}
              >
                {f.label}
              </button>
            ))}
          </div>
          <div className="reader__group" role="group" aria-label="Tema de lectura">
            {themes.map(t => (
              <button
                key={t.id}
                className={`reader__ctrl ${readerTheme === t.id ? "is-on" : ""}`}
                onClick={() => setReaderTheme(t.id)}
                aria-pressed={readerTheme === t.id}
                title={`Tema ${t.label.toLowerCase()}`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <button className="reader__ctrl reader__ctrl--icon" onClick={handlePrint} aria-label="Imprimir" title="Imprimir">
            <Icon name="download" size={16} />
          </button>
        </div>
      </header>

      <div className="reader__scroll" ref={scrollRef}>
        {r.imageUrl && (
          <div className="reader__hero">
            <img src={r.imageUrl} alt="" loading="eager" />
          </div>
        )}
        <article className="reader__article">
          <div className="reader__meta">
            <Badge tone="coral">{r.cat}</Badge>
            <span>{r.type}</span>
            {r.readMin && <span>· {r.readMin} min de lectura</span>}
          </div>
          <h1 className="display reader__title">{r.title}</h1>
          {r.shortDescription && <p className="reader__lede">{r.shortDescription}</p>}

          <div className="reader__body">
            {blocks.map((b, i) => <MarkdownBlock key={i} block={b} />)}
          </div>

          {r.tags && r.tags.length > 0 && (
            <div className="reader__tags">
              {r.tags.map(t => <Badge key={t} tone="azul">{t}</Badge>)}
            </div>
          )}

          {!hasAsset && (
            <div className="reader__note">
              ¿Preferís leerlo en papel? Usá el botón de imprimir en la barra superior. Si necesitás una versión editable, escribinos al chat.
            </div>
          )}
        </article>

        <aside className="reader__related">
          <h3 className="display">Seguir leyendo</h3>
          <div className="reader__related-list">
            {content.resources.filter(x => x.id !== r.id).slice(0, 4).map(x => (
              <button key={x.id} className="reader__related-item" onClick={() => openRelated(x)}>
                <Badge tone="coral">{x.cat}</Badge>
                <div className="reader__related-title">{x.title}</div>
                <div className="reader__related-meta">{x.readMin ? `${x.readMin} min` : x.type}</div>
              </button>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}

Object.assign(window, { ResourceReader, parseMarkdown, getLastReading, loadProgress });


/* ===== privacy.jsx ===== */

/* Azulito — Política de privacidad (página pública, accesible desde landing y registro) */

function PrivacyPolicy() {
  const { setRoute } = useApp();
  return (
    <div className="privacy-page">
      <header className="privacy-page__nav">
        <button className="privacy-page__back" onClick={() => setRoute(ROUTES.LANDING)}>
          <Icon name="arrowLeft" size={16} /> Volver
        </button>
        <button className="privacy-page__brand" onClick={() => setRoute(ROUTES.LANDING)}>
          <Drop size={28} />
          <span className="display">Azulito</span>
        </button>
      </header>

      <article className="privacy-page__article">
        <span className="eyebrow">Política de privacidad</span>
        <h1 className="display privacy-page__title">Cómo cuidamos tu información</h1>
        <p className="privacy-page__lede">
          Azulito trabaja con datos sensibles de familias. Este documento explica qué datos recolectamos,
          para qué los usamos y qué derechos tenés sobre ellos, en lenguaje claro.
        </p>
        <div className="privacy-page__meta">
          Última actualización: 17 de agosto de 2026 · Versión 1.1
        </div>

        <h2 className="privacy-page__h2">Quiénes somos</h2>
        <p>
          Azulito es un proyecto sin fines de lucro impulsado por los Clubes de Leones Treinta y Tres
          Olimar y Treinta y Tres Yerbal, la Asesoría TEA del Distrito y Amor Azul, con apoyo
          tecnológico de 33IA (comunidad impulsada por INDATA). Somos el responsable del tratamiento
          de tus datos, de acuerdo a la Ley N° 18.331 de Protección de Datos Personales de Uruguay
          y el marco de la URCDP.
        </p>

        <h2 className="privacy-page__h2">Qué datos recolectamos</h2>
        <p>
          Solo pedimos la información mínima necesaria para que Azulito te sea útil. Específicamente:
        </p>
        <ul>
          <li><strong>Datos de registro:</strong> nombre o alias, email, ciudad, departamento y una contraseña que vos elegís.</li>
          <li><strong>Información familiar opcional:</strong> cantidad y edades aproximadas de tus hijos o hijas. No pedimos nombres completos ni diagnósticos formales.</li>
          <li><strong>Interacciones con el chat:</strong> los mensajes que escribís al chat de Azulito se guardan para mejorar la calidad de las respuestas.</li>
          <li><strong>Datos técnicos mínimos:</strong> fecha del último acceso. No usamos tracking publicitario ni cookies de terceros.</li>
        </ul>

        <h2 className="privacy-page__h2">Para qué los usamos</h2>
        <ul>
          <li>Darte acceso al área privada y a los recursos.</li>
          <li>Enviarte recomendaciones adecuadas al contexto de tu familia.</li>
          <li>Generar estadísticas <strong>agregadas y anónimas</strong> sobre la realidad de las familias TEA del departamento (ej. cuántas familias hay, qué temas consultan más). Estas estadísticas nunca permiten identificar a una persona.</li>
          <li>Mejorar el servicio y detectar problemas técnicos.</li>
        </ul>

        <h2 className="privacy-page__h2">Con quién los compartimos</h2>
        <p>
          <strong>Con nadie.</strong> No vendemos, alquilamos ni intercambiamos datos con terceros.
          La única excepción es la integración técnica con OpenAI para procesar el chat: cuando el
          chat usa el modo IA, el texto de tu mensaje se envía a sus servidores para generar la
          respuesta. No enviamos tu nombre, email ni datos de tu familia en esa llamada.
        </p>

        {/* La Ley 18.331 (art. 23) exige declarar y fundar la transferencia de datos
            al exterior. Decir "se lo mandamos a OpenAI" sin calificarla como
            transferencia internacional deja el punto sin cubrir, y es lo primero
            que revisa un organismo público. */}
        <h2 className="privacy-page__h2">Transferencia internacional de datos</h2>
        <p>
          Los servidores de OpenAI están fuera de Uruguay (Estados Unidos). Enviarles el texto
          de tu consulta es, legalmente, una <strong>transferencia internacional de datos</strong>,
          regulada por el artículo 23 de la Ley N° 18.331. La hacemos amparados en tu{" "}
          <strong>consentimiento previo, libre e informado</strong>: al usar el chat en modo IA
          aceptás que el texto de tus mensajes se procese en el exterior con esa única finalidad.
        </p>
        <p>
          Para reducir el alcance de esa transferencia: no enviamos tu nombre, tu correo, tu
          documento ni el nombre de tus hijas o hijos; viaja solo el texto que escribís. Te
          pedimos que <strong>no incluyas datos identificatorios</strong> en el chat — no hacen
          falta para que Azulito te oriente. Si preferís no usar el modo IA, el resto de la
          plataforma (biblioteca, centros de salud, comunidad) funciona sin ninguna transferencia
          al exterior.
        </p>

        {/* Los datos de salud son categoría especial en el art. 18. Conviene decirlo
            explícitamente y no dejarlo implícito en "datos sensibles de familias". */}
        <h2 className="privacy-page__h2">Datos sensibles</h2>
        <p>
          La información sobre la condición de una persona —incluido el diagnóstico o la sospecha
          de TEA— es un <strong>dato sensible</strong> según el artículo 18 de la Ley N° 18.331 y
          tiene protección reforzada. Por eso: su registro es siempre voluntario, pedimos tu
          consentimiento expreso, nadie fuera del equipo responsable accede a esa información,
          nunca se publica ni se cede, y podés retirarla en cualquier momento sin perder el acceso
          a la plataforma.
        </p>

        <h2 className="privacy-page__h2">Cuánto tiempo los guardamos</h2>
        <p>
          Guardamos tus datos mientras tengas cuenta activa. Si no accedés durante más de 24 meses,
          te contactamos al email para confirmar si querés conservar la cuenta; si no respondés, la
          archivamos y luego la borramos.
        </p>

        <h2 className="privacy-page__h2">Datos de niñas y niños</h2>
        <p>
          Los datos sobre hijos o hijas son opcionales y los aportás vos como madre, padre o
          persona a cargo. Los tratamos con especial cuidado: quedan solo vinculados a tu cuenta,
          no se usan para personalizar contenido sensible, y podés borrarlos en cualquier momento
          desde el perfil.
        </p>

        <h2 className="privacy-page__h2">Seguridad</h2>
        <ul>
          <li>Todas las contraseñas se almacenan con un hash fuerte (PBKDF2-SHA512), nunca en texto plano.</li>
          <li>El tráfico entre tu navegador y nuestros servidores viaja cifrado (TLS/HTTPS).</li>
          <li>El servidor corre en infraestructura con acceso restringido al equipo técnico mínimo.</li>
          <li>Hacemos copias de respaldo diarias del sistema.</li>
        </ul>
        <p>
          A pesar de estos cuidados, ningún sistema es 100% invulnerable. Si ocurriera un incidente
          de seguridad que afecte tus datos, te lo comunicaríamos dentro de los plazos que exige la
          normativa y tomaríamos las medidas correctivas correspondientes.
        </p>

        <h2 className="privacy-page__h2">Tus derechos</h2>
        <p>Tenés derecho en todo momento a:</p>
        <ul>
          <li><strong>Acceder</strong> a la información que tenemos sobre vos.</li>
          <li><strong>Rectificarla</strong> si hay algo mal.</li>
          <li><strong>Borrarla</strong> total o parcialmente.</li>
          <li><strong>Descargarla</strong> en un formato portable.</li>
          <li><strong>Oponerte</strong> al uso de tus datos para las finalidades descritas.</li>
          <li><strong>Retirar tu consentimiento</strong> en cualquier momento.</li>
        </ul>
        <p>
          Para ejercer cualquiera de estos derechos, escribinos a <strong>plataformaazulito@gmail.com</strong> o
          por el chat. Respondemos en un plazo máximo de 5 días hábiles.
        </p>
        <p>
          Si considerás que no estamos cumpliendo tus derechos, podés reclamar ante la Unidad Reguladora
          y de Control de Datos Personales (URCDP) de Uruguay en <a href="https://www.gub.uy/unidad-reguladora-control-datos-personales/" target="_blank" rel="noopener noreferrer">gub.uy/urcdp</a>.
        </p>

        <h2 className="privacy-page__h2">Cambios en esta política</h2>
        <p>
          Si actualizamos esta política, te avisamos con destacado en la app antes de que entre en
          vigencia. Los cambios nunca son retroactivos: las reglas con las que te registraste siguen
          aplicándose a lo que ya te pasó.
        </p>

        <h2 className="privacy-page__h2">Importante: Azulito no es diagnóstico ni emergencia</h2>
        <p>
          Azulito orienta y acompaña, pero <strong>no reemplaza la consulta con profesionales de
          salud</strong>. Si estás ante una situación de crisis o emergencia, comunicate con los
          servicios de emergencia (<strong>911</strong>) o con tu equipo tratante.
        </p>

        <div className="privacy-page__footer">
          <p>
            Si tenés cualquier duda sobre cómo tratamos tus datos, escribinos.
            Este proyecto existe para acompañar, no para exponer a las familias.
          </p>
          <div className="privacy-page__actions">
            <Btn variant="primary" size="lg" onClick={() => setRoute(ROUTES.REGISTER)}>Crear cuenta</Btn>
            <Btn variant="ghost" size="lg" onClick={() => setRoute(ROUTES.LANDING)}>Volver al inicio</Btn>
          </div>
        </div>
      </article>
    </div>
  );
}

Object.assign(window, { PrivacyPolicy });


/* ===== bootstrap.jsx ===== */

/* Azulito — entrypoint: SW register + App router + Root render */

// Registrar el Service Worker nuevo. El SW viejo (si existía) se reemplaza
// automáticamente: el browser detecta el nuevo sw.js, instala, activate del
// nuevo limpia caches viejos.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((e) => {
      console.warn("[sw] register failed:", e);
    });
  });
}

// Capturar el prompt de instalación PWA. Chrome/Edge/Android lo dispara una vez
// que el SW está activo y la heurística de "instalable" se cumple. iOS Safari
// no dispara este evento — ahí el InstallPrompt muestra instrucciones manuales.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__azulitoInstallPrompt = e;
  // Si el browser dispara este evento, la app NO está instalada: limpiamos la
  // marca vieja (la X del banner la seteaba para siempre y ocultaba el prompt).
  try { localStorage.removeItem("azulito:installed"); } catch {}
  window.dispatchEvent(new CustomEvent("azulito:install-ready", { detail: e }));
});
window.addEventListener("appinstalled", () => {
  window.__azulitoInstallPrompt = null;
  try { localStorage.setItem("azulito:installed", "1"); } catch {}
});

function App() {
  const { route, user, toast, setRoute, params } = useApp();
  const [chatOpen, setChatOpen] = useState(false);
  const [cmdOpen, setCmdOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const INSTALL_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000; // cerrar pospone 7 días
  const installSnoozed = () => {
    try { return Date.now() - Number(localStorage.getItem("azulito:install-snooze") || 0) < INSTALL_SNOOZE_MS; }
    catch { return false; }
  };
  const [installOpen, setInstallOpen] = useState(() => !localStorage.getItem("azulito:installed") && !installSnoozed());

  // Si el prompt nativo llega después del primer render (Chrome lo dispara
  // async), reabrimos el banner salvo que esté pospuesto.
  useEffect(() => {
    const onReady = () => { if (!installSnoozed()) setInstallOpen(true); };
    window.addEventListener("azulito:install-ready", onReady);
    return () => window.removeEventListener("azulito:install-ready", onReady);
  }, []);
  const [tweaks, setTweaks] = useState(() => {
    try { return JSON.parse(localStorage.getItem("azulito:tweaks")) || { density: "cozy", accent: "#F4A26A", motion: true, fontSize: "md" }; }
    catch { return { density: "cozy", accent: "#F4A26A", motion: true, fontSize: "md" }; }
  });
  useEffect(() => { localStorage.setItem("azulito:tweaks", JSON.stringify(tweaks)); }, [tweaks]);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCmdOpen((o) => !o);
      }
      if (e.key === "Escape") { setCmdOpen(false); setNotifOpen(false); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const privateRoutes = [ROUTES.APP_HOME, ROUTES.APP_LIBRARY, ROUTES.APP_CHAT, ROUTES.APP_PROFESSIONALS, ROUTES.APP_PROFILE, ROUTES.APP_TESTIMONIALS];
  const adminRoutes = [ROUTES.ADMIN_HOME, ROUTES.ADMIN_CONTENT, ROUTES.ADMIN_USERS, ROUTES.ADMIN_METRICS, ROUTES.ADMIN_AI, ROUTES.ADMIN_CHAT_LOG];

  let view = null;

  if (route === ROUTES.LANDING) {
    view = <>
      <Landing onOpenChat={() => setChatOpen(true)} />
      <ChatFab open={chatOpen} onToggle={() => setChatOpen((o) => !o)} />
    </>;
  } else if (route === ROUTES.LOGIN) {
    view = <Login />;
  } else if (route === ROUTES.REGISTER) {
    view = <Register />;
  } else if (route === ROUTES.FORGOT) {
    view = <ForgotPassword />;
  } else if (route === ROUTES.ONBOARDING) {
    view = <Onboarding />;
  } else if (route === ROUTES.CHANGE_PASSWORD) {
    view = <ChangePassword />;
  } else if (route === ROUTES.PRIVACY) {
    view = <PrivacyPolicy />;
  } else if (route === ROUTES.RESOURCE_DETAIL) {
    view = (
      <div className="app-shell">
        <PrivateNav />
        <ResourceReader id={params.id} onBack={() => setRoute(ROUTES.APP_LIBRARY)} />
      </div>
    );
  } else if (route === ROUTES.ARTICLE_DETAIL) {
    view = (
      <div className="app-shell">
        <PrivateNav />
        <ResourceReader id={params.id} collection="articles" onBack={() => setRoute(ROUTES.APP_HOME)} />
      </div>
    );
  } else if (route === ROUTES.PROFESSIONAL_DETAIL) {
    view = (
      <div className="app-shell">
        <PrivateNav />
        <ProfessionalDetail id={params.id} onBack={() => setRoute(ROUTES.APP_PROFESSIONALS)} />
      </div>
    );
  } else if (privateRoutes.includes(route)) {
    view = (
      <div className="app-shell">
        <PrivateNav />
        {route === ROUTES.APP_HOME && <AppHome />}
        {route === ROUTES.APP_LIBRARY && <Library />}
        {route === ROUTES.APP_CHAT && <ChatView />}
        {route === ROUTES.APP_PROFESSIONALS && <Professionals />}
        {route === ROUTES.APP_TESTIMONIALS && <Testimonials />}
        {route === ROUTES.APP_PROFILE && <Profile />}
      </div>
    );
  } else if (adminRoutes.includes(route)) {
    view = (
      <div className="admin-shell">
        <AdminNav />
        {route === ROUTES.ADMIN_HOME && <AdminHome />}
        {route === ROUTES.ADMIN_CONTENT && <AdminContent />}
        {route === ROUTES.ADMIN_USERS && <AdminUsers />}
        {route === ROUTES.ADMIN_METRICS && <AdminMetrics />}
        {route === ROUTES.ADMIN_AI && <AdminAI />}
        {route === ROUTES.ADMIN_CHAT_LOG && <AdminChatLog />}
      </div>
    );
  } else {
    view = <Landing onOpenChat={() => setChatOpen(true)} />;
  }

  const isPrivate = privateRoutes.includes(route) || adminRoutes.includes(route);

  return <>
    {view}
    <Toast toast={toast} />
    <CommandPalette open={cmdOpen} onClose={() => setCmdOpen(false)} />
    <NotifyCenter open={notifOpen} onClose={() => setNotifOpen(false)} />
    {isPrivate && (
      <>
        <button className="fab-cmd" onClick={() => setCmdOpen(true)} title="Buscar (⌘K)" aria-label="Buscar">
          <Icon name="search" size={18} /> <kbd>⌘K</kbd>
        </button>
        <button className="fab-bell" onClick={() => setNotifOpen(true)} title="Novedades" aria-label="Novedades">
          <Icon name="bell" size={18} /> <span className="fab-bell__dot" />
        </button>
      </>
    )}
    {installOpen && (route === ROUTES.LANDING || privateRoutes.includes(route)) && (
      <InstallPrompt onClose={() => {
        setInstallOpen(false);
        try { localStorage.setItem("azulito:install-snooze", String(Date.now())); } catch {}
      }} />
    )}
    <TweaksPanel cfg={tweaks} setCfg={setTweaks} />
  </>;
}

function Root() {
  return (
    <AppProvider>
      <App />
    </AppProvider>
  );
}

const rootEl = document.getElementById("root");
ReactDOM.createRoot(rootEl).render(<Root />);
